// Auto-generated from Spring 2021 Named Burial Master List Update 23jul21.xlsx
// Do not edit manually; regenerate from source workbook when needed.

export const namedPersonsData = [
  {
    "nameId": "Rev Evan Morgan",
    "gNumber": "H-100964",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1709",
    "yearOfDeath": 1709,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rev Samuel Jones",
    "gNumber": "H-100716",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 65,
    "ancestry": "Unknown",
    "dateOfDeath": "1722",
    "yearOfDeath": 1722,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rev Abel Morgan",
    "gNumber": "H-100965",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 49,
    "ancestry": "Unknown",
    "dateOfDeath": "1722-12-16",
    "yearOfDeath": 1722,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"In memory of Abel Morgan Baptist minister who departed this life Dec ys 16th 1722 in ye 49th year of His Age\""
  },
  {
    "nameId": "Bernard Eglesfield",
    "gNumber": "H-100437",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 37,
    "ancestry": "Unknown",
    "dateOfDeath": "1733-02-20",
    "yearOfDeath": 1733,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rev Joseph Wood",
    "gNumber": "H-101568",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 88,
    "ancestry": "Unknown",
    "dateOfDeath": "1747",
    "yearOfDeath": 1747,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Israel Morris",
    "gNumber": "H-100970",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 25,
    "ancestry": "Unknown",
    "dateOfDeath": "1754-12-09",
    "yearOfDeath": 1754,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Hannah Jones",
    "gNumber": "H-100717",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 82,
    "ancestry": "Unknown",
    "dateOfDeath": "1758-05-30",
    "yearOfDeath": 1758,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Rev. Jenkins"
  },
  {
    "nameId": "Rev Jenkins Jones",
    "gNumber": "H-100718",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 74,
    "ancestry": "Unknown",
    "dateOfDeath": "1760-07-06",
    "yearOfDeath": 1760,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "h. Hannah; \"Late Minister of the Baptist Church \u2026in which \u2026. 35 years\u2026"
  },
  {
    "nameId": "Abraham Regin",
    "gNumber": "H-101142",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 38,
    "ancestry": "Unknown",
    "dateOfDeath": "1762",
    "yearOfDeath": 1762,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Stephen Anthony",
    "gNumber": "H-100017",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 66,
    "ancestry": "Unknown",
    "dateOfDeath": "1763-05-12",
    "yearOfDeath": 1763,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "h. Joanna"
  },
  {
    "nameId": "Mary Edwards",
    "gNumber": "H-100433",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1769",
    "yearOfDeath": 1769,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Rev. Morgan Edwards"
  },
  {
    "nameId": "Edith Priestly",
    "gNumber": "H-101120",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1772-01-09",
    "yearOfDeath": 1772,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Judith Fulton",
    "gNumber": "H-100510",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1772-04-05",
    "yearOfDeath": 1772,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Morris",
    "gNumber": "H-100971",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1772-04-14",
    "yearOfDeath": 1772,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Powell",
    "gNumber": "H-101109",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1773-06-29",
    "yearOfDeath": 1773,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rebecca Williams",
    "gNumber": "H-101553",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1773-09-02",
    "yearOfDeath": 1773,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Grace Lloyd",
    "gNumber": "H-100834",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1773-09-09",
    "yearOfDeath": 1773,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth Byles",
    "gNumber": "H-100216",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1773-10-06",
    "yearOfDeath": 1773,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Isaac Jones Esq",
    "gNumber": "H-100719",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1773-10-18",
    "yearOfDeath": 1773,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Frances McGlone",
    "gNumber": "H-100902",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1774-01-17",
    "yearOfDeath": 1774,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Deborah Price",
    "gNumber": "H-101118",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1774-08-11",
    "yearOfDeath": 1774,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Susannah De Nyss",
    "gNumber": "H-100371",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1774-08-27",
    "yearOfDeath": 1774,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Benjamin Howell",
    "gNumber": "H-100667",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1774-09-04",
    "yearOfDeath": 1774,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Samuel Burkeloe",
    "gNumber": "H-100196",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1774-10-08",
    "yearOfDeath": 1774,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "The Sexton"
  },
  {
    "nameId": "Mr R? Watson",
    "gNumber": "H-101498",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1775",
    "yearOfDeath": 1775,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Prudence Flowers",
    "gNumber": "H-100486",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1775-05-28",
    "yearOfDeath": 1775,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Gov Samuel Ward Esq.",
    "gNumber": "H-101470",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 52,
    "ancestry": "Unknown",
    "dateOfDeath": "1776-03-26",
    "yearOfDeath": 1776,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Rush",
    "gNumber": "H-101194",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1780",
    "yearOfDeath": 1780,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "M. Burkiloe",
    "gNumber": "H-100197",
    "sex": "Unknown",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1781-10-30",
    "yearOfDeath": 1781,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "James Hunter",
    "gNumber": "H-100675",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1782-12-05",
    "yearOfDeath": 1782,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Merchant"
  },
  {
    "nameId": "Ann Levering",
    "gNumber": "H-100829",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1782-10-11",
    "yearOfDeath": 1782,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Benjamin Britton",
    "gNumber": "H-100174",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 78,
    "ancestry": "Unknown",
    "dateOfDeath": "1782-02-16",
    "yearOfDeath": 1782,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Wilson",
    "gNumber": "H-101559",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1783",
    "yearOfDeath": 1783,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth Ustick",
    "gNumber": "H-101433",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1783-07-01",
    "yearOfDeath": 1783,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Beasly",
    "gNumber": "H-100087",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1784-09-25",
    "yearOfDeath": 1784,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Gourley",
    "gNumber": "H-100552",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1789-08-27",
    "yearOfDeath": 1789,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Hugh and Mary"
  },
  {
    "nameId": "John Regin",
    "gNumber": "H-101143",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1790",
    "yearOfDeath": 1790,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Lydia Sheilds",
    "gNumber": "H-101250",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 46,
    "ancestry": "Unknown",
    "dateOfDeath": "1791-03-10",
    "yearOfDeath": 1791,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Catharine Fitzgerald",
    "gNumber": "H-100479",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 34,
    "ancestry": "Unknown",
    "dateOfDeath": "1791-02-07",
    "yearOfDeath": 1791,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Thomas"
  },
  {
    "nameId": "Rachel Darris",
    "gNumber": "H-100339",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1791",
    "yearOfDeath": 1791,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth Beasly",
    "gNumber": "H-100088",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1791",
    "yearOfDeath": 1791,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Sarah Moulder",
    "gNumber": "H-100988",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1791-10-01",
    "yearOfDeath": 1791,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(grandchild) Ustick",
    "gNumber": "H-101434",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1791",
    "yearOfDeath": 1791,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "grandchild of Thomas and Hannah"
  },
  {
    "nameId": "Cornelius Barnes",
    "gNumber": "H-100063",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1791-07-09",
    "yearOfDeath": 1791,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Cornelius and Sarah"
  },
  {
    "nameId": "Mary Bringhurst",
    "gNumber": "H-100166",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1792",
    "yearOfDeath": 1792,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "James Shields",
    "gNumber": "H-101264",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 20,
    "ancestry": "Unknown",
    "dateOfDeath": "1792",
    "yearOfDeath": 1792,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Thomas and Lydia"
  },
  {
    "nameId": "J. Bellinger",
    "gNumber": "H-100099",
    "sex": "Unknown",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1792-04-06",
    "yearOfDeath": 1792,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Richard Carter",
    "gNumber": "H-100234",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1792-04-06",
    "yearOfDeath": 1792,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ann Gourley",
    "gNumber": "H-100553",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1792-07-10",
    "yearOfDeath": 1792,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Hugh and Mary"
  },
  {
    "nameId": "Lucy Bennet",
    "gNumber": "H-100105",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Thomas"
  },
  {
    "nameId": "Thomas Bennet",
    "gNumber": "H-100106",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "h. Lucy; Laborer"
  },
  {
    "nameId": "Miss (female) Bowers",
    "gNumber": "H-100129",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Brown",
    "gNumber": "H-100181",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jacob Burkellow Jr",
    "gNumber": "H-100195",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Alexander Campbell",
    "gNumber": "H-100225",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "James Carter",
    "gNumber": "H-100235",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Miss (female) Clarke",
    "gNumber": "H-100276",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. of Mrs."
  },
  {
    "nameId": "Mrs (female) Clarke",
    "gNumber": "H-100277",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs (female) Cohen",
    "gNumber": "H-100296",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Hester Davis",
    "gNumber": "H-100345",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. of S. L.? Sr."
  },
  {
    "nameId": "Sarah Davis",
    "gNumber": "H-100346",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Denny",
    "gNumber": "H-100375",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth Ferguson",
    "gNumber": "H-100468",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jonathan French",
    "gNumber": "H-100501",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Goff",
    "gNumber": "H-100543",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch of Morris"
  },
  {
    "nameId": "Mrs (female) Goff",
    "gNumber": "H-100544",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. of Morris"
  },
  {
    "nameId": "Morris Goff",
    "gNumber": "H-100545",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Enoch Gordon",
    "gNumber": "H-100548",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Shoemaker"
  },
  {
    "nameId": "Peter Gordon",
    "gNumber": "H-100549",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Shoemaker"
  },
  {
    "nameId": "John Jasman Jr",
    "gNumber": "H-100689",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Margaret Keene",
    "gNumber": "H-100763",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Kline",
    "gNumber": "H-100796",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Charles Knight",
    "gNumber": "H-100797",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rachel Lawrence",
    "gNumber": "H-100813",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "George Lee",
    "gNumber": "H-100816",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Joseph and Mary"
  },
  {
    "nameId": "Joseph Lee",
    "gNumber": "H-100817",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "h. Mary"
  },
  {
    "nameId": "Mary Lee",
    "gNumber": "H-100818",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Joseph"
  },
  {
    "nameId": "Elizabeth Lovell",
    "gNumber": "H-100839",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Capt James Marsh",
    "gNumber": "H-100864",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "brother of Stephen"
  },
  {
    "nameId": "Stephen Marsh",
    "gNumber": "H-100865",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "brother of Capt. Jame"
  },
  {
    "nameId": "William McCloud",
    "gNumber": "H-100888",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Ridge Jr",
    "gNumber": "H-101164",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Robinson",
    "gNumber": "H-101176",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "widow"
  },
  {
    "nameId": "Stephen Shakespear",
    "gNumber": "H-101243",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Frances Summers",
    "gNumber": "H-101355",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Swim",
    "gNumber": "H-101362",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Benjamin Thaw Jr",
    "gNumber": "H-101375",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Maria Thaw",
    "gNumber": "H-101376",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "sister of Benjamin Jr"
  },
  {
    "nameId": "Richard Towne",
    "gNumber": "H-101414",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs (female) Wales",
    "gNumber": "H-101454",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. John"
  },
  {
    "nameId": "John Wales",
    "gNumber": "H-101455",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Benjamin Weatherby",
    "gNumber": "H-101503",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Samuel and Sarah"
  },
  {
    "nameId": "Samuel Weatherby",
    "gNumber": "H-101504",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "h. Sarah"
  },
  {
    "nameId": "Joseph Weatherby",
    "gNumber": "H-101505",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Samuel and Sarah"
  },
  {
    "nameId": "Samuel Weatherby",
    "gNumber": "H-101506",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Samuel and Sarah"
  },
  {
    "nameId": "Sarah Weatherby",
    "gNumber": "H-101507",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Samuel"
  },
  {
    "nameId": "Sarah Weatherby",
    "gNumber": "H-101508",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Samuel"
  },
  {
    "nameId": "Thomas Weatherby",
    "gNumber": "H-101509",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Samuel and Sarah"
  },
  {
    "nameId": "Elijah Weed",
    "gNumber": "H-101515",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jail keeper"
  },
  {
    "nameId": "Mary Wood",
    "gNumber": "H-101569",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Doctor Samuel Davis",
    "gNumber": "H-100347",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 32,
    "ancestry": "Unknown",
    "dateOfDeath": "1793-07-05",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Marsha Loot",
    "gNumber": "H-100835",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793-10-10",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Jenkins",
    "gNumber": "H-100690",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Thomas and Ann"
  },
  {
    "nameId": "Samuel Limes",
    "gNumber": "H-100830",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 20,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "E. Vankern",
    "gNumber": "H-101444",
    "sex": "Unknown",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Sarah Sutton",
    "gNumber": "H-101356",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Beckner",
    "gNumber": "H-100096",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Aaron Vanhorne",
    "gNumber": "H-101443",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "taylor"
  },
  {
    "nameId": "James Watkins",
    "gNumber": "H-101489",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "corder"
  },
  {
    "nameId": "John Hopper",
    "gNumber": "H-100660",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Joiner"
  },
  {
    "nameId": "Hannah Rogers",
    "gNumber": "H-101180",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 40,
    "ancestry": "Unknown",
    "dateOfDeath": "1793-10-10",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Rev. Dr. William Rogers"
  },
  {
    "nameId": "Mary Shewell",
    "gNumber": "H-101260",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 26,
    "ancestry": "Unknown",
    "dateOfDeath": "1793-08-17",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Mr Sallows Shewell, merchant"
  },
  {
    "nameId": "George Cohen",
    "gNumber": "H-100295",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. of Mrs."
  },
  {
    "nameId": "Mary Engels",
    "gNumber": "H-100446",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Joseph"
  },
  {
    "nameId": "Ann Peckworth",
    "gNumber": "H-101054",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793-10-17",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Cornelius Barnes",
    "gNumber": "H-100065",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 50,
    "ancestry": "Unknown",
    "dateOfDeath": "1793-09-16",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Merchant"
  },
  {
    "nameId": "Cornelius Barnes",
    "gNumber": "H-100064",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Merchant"
  },
  {
    "nameId": "Mary Engle",
    "gNumber": "H-100448",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "W of Joseph"
  },
  {
    "nameId": "Ann Peckworth",
    "gNumber": "H-101053",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Hannah Rogers",
    "gNumber": "H-101179",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "wife of Rev. Dr. William Rogers"
  },
  {
    "nameId": "Mary Shewell",
    "gNumber": "H-101259",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1793",
    "yearOfDeath": 1793,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "wife of Mr. Sallows Shewell, Merchant"
  },
  {
    "nameId": "Thomas Jenkins",
    "gNumber": "H-100691",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "1-5",
    "ageAtDeath": 3,
    "ancestry": "Unknown",
    "dateOfDeath": "1794",
    "yearOfDeath": 1794,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Thomas and Ann"
  },
  {
    "nameId": "E. Kelsor",
    "gNumber": "H-100776",
    "sex": "Unknown",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1794-11-23",
    "yearOfDeath": 1794,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth Shewell",
    "gNumber": "H-101261",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 64,
    "ancestry": "Unknown",
    "dateOfDeath": "1794-10-10",
    "yearOfDeath": 1794,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Stephen"
  },
  {
    "nameId": "Charity Allison Mason?",
    "gNumber": "H-100872",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 86,
    "ancestry": "Unknown",
    "dateOfDeath": "1794-10-21",
    "yearOfDeath": 1794,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Burgiss & Rhoda"
  },
  {
    "nameId": "Benjamin Ustick",
    "gNumber": "H-101435",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1794-08-27",
    "yearOfDeath": 1794,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Samuel Simes",
    "gNumber": "H-101273",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 59,
    "ancestry": "Unknown",
    "dateOfDeath": "1795",
    "yearOfDeath": 1795,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Millis",
    "gNumber": "H-100948",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1795-12-27",
    "yearOfDeath": 1795,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Maria Gourley",
    "gNumber": "H-100554",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1795-08-24",
    "yearOfDeath": 1795,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Hugh and Mary"
  },
  {
    "nameId": "Rev Morgan Edwards A.M.",
    "gNumber": "H-100434",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 73,
    "ancestry": "Unknown",
    "dateOfDeath": "1795-01-28",
    "yearOfDeath": 1795,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"Not dead but gone before\""
  },
  {
    "nameId": "Abraham Regin",
    "gNumber": "H-101144",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "3-7",
    "ageAtDeath": 5,
    "ancestry": "Unknown",
    "dateOfDeath": "1796",
    "yearOfDeath": 1796,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Hiram Sewell",
    "gNumber": "H-101230",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 21,
    "ancestry": "Unknown",
    "dateOfDeath": "1796",
    "yearOfDeath": 1796,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Hungary",
    "gNumber": "H-100674",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1796",
    "yearOfDeath": 1796,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Gourley",
    "gNumber": "H-100555",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 37,
    "ancestry": "Unknown",
    "dateOfDeath": "1796-11-28",
    "yearOfDeath": 1796,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Hugh; \"\u2026and her Children\u2026\""
  },
  {
    "nameId": "Mrs Abigail Barker",
    "gNumber": "H-100062",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1797",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Mother of Mr. Barker (merchant); Sister to Dr. Rogers (prof of oratory at U Penn)"
  },
  {
    "nameId": "William Graham",
    "gNumber": "H-100561",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 17,
    "ancestry": "Unknown",
    "dateOfDeath": "1797",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Margaret Graham",
    "gNumber": "H-100562",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 50,
    "ancestry": "Unknown",
    "dateOfDeath": "1797",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Sarah Maghee",
    "gNumber": "H-100855",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 33,
    "ancestry": "Unknown",
    "dateOfDeath": "1797",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. William"
  },
  {
    "nameId": "Elizabeth Holmes",
    "gNumber": "H-100657",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1797-09-30",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rev Elhanan Winchester",
    "gNumber": "H-101561",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 46,
    "ancestry": "Unknown",
    "dateOfDeath": "1797",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "James Gourley",
    "gNumber": "H-100556",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1797-01-16",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Hugh and Mary"
  },
  {
    "nameId": "Hannah Strong",
    "gNumber": "H-101354",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1797-08-17",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Margaret Jackway",
    "gNumber": "H-100684",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1797-09-03",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"a child\""
  },
  {
    "nameId": "(wife) Grigery",
    "gNumber": "H-100575",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1797-09-11",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. John"
  },
  {
    "nameId": "(son) Basset",
    "gNumber": "H-100075",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1797-09-12",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Widow Basset, \"a child\""
  },
  {
    "nameId": "Peter Briler",
    "gNumber": "H-100165",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1797-09-12",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Davis",
    "gNumber": "H-100348",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1797-09-17",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Robenson",
    "gNumber": "H-101171",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1797-09-24",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John S. Holmes",
    "gNumber": "H-100656",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1797-09-29",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"a child\""
  },
  {
    "nameId": "(child) Penrose",
    "gNumber": "H-101065",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1797-10-04",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Widow Penrose"
  },
  {
    "nameId": "Samuel Burkalow Jr",
    "gNumber": "H-100194",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1797-10-05",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Merriam",
    "gNumber": "H-100923",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1797-10-08",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"a child\""
  },
  {
    "nameId": "Martha Davis",
    "gNumber": "H-100349",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1797-10-20",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Stephen Engel",
    "gNumber": "H-100445",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1797-10-24",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jonathan Rose",
    "gNumber": "H-101186",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1797-10-24",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Catharine Miles",
    "gNumber": "H-100925",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1797-10-25",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Colonel Samuel Miles, of Cheltenham township  firmerly Mayor of this city\""
  },
  {
    "nameId": "Nathaniel Dickinson",
    "gNumber": "H-100379",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1797-08-15",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Samuel Jones M.D.",
    "gNumber": "H-100722",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 27,
    "ancestry": "Unknown",
    "dateOfDeath": "1797-09-17",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"fever caught by performing the most laborious Acts of humanity & charity to the poor of Philadlephia\u2026 He lived and died in the Truth of the Gospel of Jesus Christ Blessed is that Servant whom his Lord when he cometh shall find so doing\""
  },
  {
    "nameId": "Esther Jones",
    "gNumber": "H-100721",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 64,
    "ancestry": "Unknown",
    "dateOfDeath": "1797-08-05",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "wid. Philip"
  },
  {
    "nameId": "Philip Jones",
    "gNumber": "H-100720",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 68,
    "ancestry": "Unknown",
    "dateOfDeath": "1797-04-22",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "h. Esther"
  },
  {
    "nameId": "(son) Steward",
    "gNumber": "H-101334",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1797-09-15",
    "yearOfDeath": 1797,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Thomas, \"A child\""
  },
  {
    "nameId": "Nathan Bryan Esq",
    "gNumber": "H-100192",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 50,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-06-04",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"A member of the hosue of Representative of the United States from the State of North Carolina who died on the 4th day of June A D 1798 in the 50th year of his age while attending the 2nd Session of the 5th Congress\" \"His grandson James? A. Lane ??? This Tabel to his memory\""
  },
  {
    "nameId": "Nathaniel Davis",
    "gNumber": "H-100351",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 37,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-08-21",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Moulder",
    "gNumber": "H-100989",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 73,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-24",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "h. Mary"
  },
  {
    "nameId": "Mary Oakford",
    "gNumber": "H-101021",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-25",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Charles"
  },
  {
    "nameId": "Joseph Anthony",
    "gNumber": "H-100018",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 59,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-29",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "h. Elizabeth; \"a victim to a pestilential fever then prevelant in Philadlephia\""
  },
  {
    "nameId": "John Easby",
    "gNumber": "H-100423",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1798",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Margaret Kinshaw?",
    "gNumber": "H-100793",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 60,
    "ancestry": "Unknown",
    "dateOfDeath": "1798",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Samuel Davis Jr.",
    "gNumber": "H-100350",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Morland",
    "gNumber": "H-100969",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-08-04",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Joiner"
  },
  {
    "nameId": "Ann Rine",
    "gNumber": "H-101166",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-08-05",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(widow) Letts",
    "gNumber": "H-100828",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-08-10",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "widow"
  },
  {
    "nameId": "(daughter) Stephens",
    "gNumber": "H-101331",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-08-11",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Henry"
  },
  {
    "nameId": "(wife) Corneles",
    "gNumber": "H-100314",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-08-22",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Matthew"
  },
  {
    "nameId": "(wife) Walker",
    "gNumber": "H-101457",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-05",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. John"
  },
  {
    "nameId": "(wife) Wall",
    "gNumber": "H-101464",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-08",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Charles"
  },
  {
    "nameId": "(unknown) (unknown)",
    "gNumber": "H-100002",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-09",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"a woman from John Peckworth's\""
  },
  {
    "nameId": "(sister) White",
    "gNumber": "H-101534",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-09",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "sister of Isaac (a shipcarpenter)"
  },
  {
    "nameId": "(son) Wall",
    "gNumber": "H-101465",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-10",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Charles"
  },
  {
    "nameId": "Alley Duce",
    "gNumber": "H-100409",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-15",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Mr. Coombes"
  },
  {
    "nameId": "Zachariah Stewart",
    "gNumber": "H-101335",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-16",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(wife) Third",
    "gNumber": "H-101383",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-18",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. John"
  },
  {
    "nameId": "(child) McCarer",
    "gNumber": "H-100882",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-20",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Garret"
  },
  {
    "nameId": "(widow) Stewart",
    "gNumber": "H-101336",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-24",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "wid.Zachariah"
  },
  {
    "nameId": "Mrs Hannah Jones",
    "gNumber": "H-100723",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-26",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Bringhurst",
    "gNumber": "H-100167",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-27",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "soninlaw of William"
  },
  {
    "nameId": "John Hancock",
    "gNumber": "H-100596",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-27",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "grocer"
  },
  {
    "nameId": "(daughter1) Oakford",
    "gNumber": "H-101022",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-27",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Charles"
  },
  {
    "nameId": "(wife) Wheaton",
    "gNumber": "H-101528",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-30",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Amos Sr"
  },
  {
    "nameId": "George Young",
    "gNumber": "H-101598",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-30",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Garret McCarer",
    "gNumber": "H-100883",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-10-07",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Bringhurst",
    "gNumber": "H-100168",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-10-17",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) McCarer",
    "gNumber": "H-100884",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-10-18",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Garret"
  },
  {
    "nameId": "(widow) McCarer",
    "gNumber": "H-100885",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-10-20",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "wid. Garret"
  },
  {
    "nameId": "(child) Merriam",
    "gNumber": "H-100924",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-10-29",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John"
  },
  {
    "nameId": "(child) Townsend",
    "gNumber": "H-101415",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-11-05",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Henry"
  },
  {
    "nameId": "John Walker",
    "gNumber": "H-101456",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-03",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Corder"
  },
  {
    "nameId": "(wife) Perey",
    "gNumber": "H-101069",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-19",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. John"
  },
  {
    "nameId": "(son) Perey",
    "gNumber": "H-101070",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-22",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. John"
  },
  {
    "nameId": "Samuel Perey",
    "gNumber": "H-101071",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-24",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "House Carpenter"
  },
  {
    "nameId": "William Easby",
    "gNumber": "H-100424",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 29,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-25",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(daughter2) Perey",
    "gNumber": "H-101072",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-25",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. John"
  },
  {
    "nameId": "John Perey",
    "gNumber": "H-101073",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-27",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "House Carpenter"
  },
  {
    "nameId": "(daughter) Perey",
    "gNumber": "H-101074",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-28",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. John"
  },
  {
    "nameId": "Catharine Easby",
    "gNumber": "H-100425",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 26,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-10-02",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "wid. William"
  },
  {
    "nameId": "John W. Easby",
    "gNumber": "H-100426",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 34,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-10-16",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "H. Catherine"
  },
  {
    "nameId": "Ann Easby",
    "gNumber": "H-100427",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-10-28",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. John"
  },
  {
    "nameId": "Thomas Debaskewill",
    "gNumber": "H-100372",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798,09.02",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Dudman",
    "gNumber": "H-100410",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798,09.16",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "widow"
  },
  {
    "nameId": "Mary Parker",
    "gNumber": "H-101040",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-08-26",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "George Passfield",
    "gNumber": "H-101043",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-08-30",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Chivener",
    "gNumber": "H-100259",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-05",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(daughter) Appleton",
    "gNumber": "H-100022",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-09-14",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Charles"
  },
  {
    "nameId": "(daughter) Easby",
    "gNumber": "H-100428",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1798-10-28",
    "yearOfDeath": 1798,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. John"
  },
  {
    "nameId": "Mary Maull",
    "gNumber": "H-100878",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 30,
    "ancestry": "Unknown",
    "dateOfDeath": "1799-05-16",
    "yearOfDeath": 1799,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "consort of Mr. Robert Maull; d. Mr. Joseph Eagle of Northern Liberties"
  },
  {
    "nameId": "Elizabeth Anthony",
    "gNumber": "H-100019",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 59,
    "ancestry": "Unknown",
    "dateOfDeath": "1799-02-01",
    "yearOfDeath": 1799,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "wid. Joseph"
  },
  {
    "nameId": "Joseph M. Ashmead",
    "gNumber": "H-100028",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 23,
    "ancestry": "Unknown",
    "dateOfDeath": "1799-06-23",
    "yearOfDeath": 1799,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. John and Mary"
  },
  {
    "nameId": "Elizabeth Ball",
    "gNumber": "H-100055",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 67,
    "ancestry": "Unknown",
    "dateOfDeath": "1799-08-05",
    "yearOfDeath": 1799,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Nathan"
  },
  {
    "nameId": "John Challis",
    "gNumber": "H-100247",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 36,
    "ancestry": "Unknown",
    "dateOfDeath": "1799",
    "yearOfDeath": 1799,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Gourley",
    "gNumber": "H-100557",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "11-15",
    "ageAtDeath": 13,
    "ancestry": "Unknown",
    "dateOfDeath": "1799-09-05",
    "yearOfDeath": 1799,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Hugh and Mary; Buried in Presbyterian Burying groun, Middletown, Delaware"
  },
  {
    "nameId": "Benjamin Britton",
    "gNumber": "H-100175",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 24,
    "ancestry": "Unknown",
    "dateOfDeath": "1800",
    "yearOfDeath": 1800,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ann Fosters",
    "gNumber": "H-100497",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 32,
    "ancestry": "Unknown",
    "dateOfDeath": "1800",
    "yearOfDeath": 1800,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Sarah M. Rogers",
    "gNumber": "H-101181",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "3-7",
    "ageAtDeath": 5,
    "ancestry": "Unknown",
    "dateOfDeath": "1801-11-01",
    "yearOfDeath": 1801,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Sisty",
    "gNumber": "H-101290",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 40,
    "ancestry": "Unknown",
    "dateOfDeath": "1801-05-13",
    "yearOfDeath": 1801,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "sexton"
  },
  {
    "nameId": "John Ashmead",
    "gNumber": "H-100029",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1802",
    "yearOfDeath": 1802,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Andrew Friend",
    "gNumber": "H-100503",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 38,
    "ancestry": "Unknown",
    "dateOfDeath": "1802-11-06",
    "yearOfDeath": 1802,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Walker",
    "gNumber": "H-101458",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 49,
    "ancestry": "Unknown",
    "dateOfDeath": "1803",
    "yearOfDeath": 1803,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rev Thomas Ustick A.M.",
    "gNumber": "H-101436",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 50,
    "ancestry": "Unknown",
    "dateOfDeath": "1803-04-18",
    "yearOfDeath": 1803,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(wife) Hellings",
    "gNumber": "H-100623",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 66,
    "ancestry": "Unknown",
    "dateOfDeath": "1804",
    "yearOfDeath": 1804,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Sydney"
  },
  {
    "nameId": "Robert Rogers",
    "gNumber": "H-101182",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "2-6",
    "ageAtDeath": 4,
    "ancestry": "Unknown",
    "dateOfDeath": "1804",
    "yearOfDeath": 1804,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "M. Harper",
    "gNumber": "H-100604",
    "sex": "Unknown",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1804",
    "yearOfDeath": 1804,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rev Morgan John Rhees",
    "gNumber": "H-101153",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 44,
    "ancestry": "Unknown",
    "dateOfDeath": "1804-12-07",
    "yearOfDeath": 1804,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"\u2026a native of Glamorganshire, S. Wales\u2026died at Simersetp Pennsylvania...His Remains were removed to the family vault\""
  },
  {
    "nameId": "Samuel Miles",
    "gNumber": "H-100926",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1805-12-30",
    "yearOfDeath": 1805,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Benjamin Hellings",
    "gNumber": "H-100624",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 70,
    "ancestry": "Unknown",
    "dateOfDeath": "1805",
    "yearOfDeath": 1805,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child1) Warner",
    "gNumber": "H-101472",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1806-05-28",
    "yearOfDeath": 1806,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "unamed ch (1) of Mr. William Warner"
  },
  {
    "nameId": "(child2) Warner",
    "gNumber": "H-101473",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1806-05-31",
    "yearOfDeath": 1806,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "unamed ch (2) of Mr. William Warner"
  },
  {
    "nameId": "Hannah McCulder",
    "gNumber": "H-100894",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "9-13",
    "ageAtDeath": 11,
    "ancestry": "Unknown",
    "dateOfDeath": "1806-08-17",
    "yearOfDeath": 1806,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Robert M. Graham",
    "gNumber": "H-100563",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 34,
    "ancestry": "Unknown",
    "dateOfDeath": "1806",
    "yearOfDeath": 1806,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Miles",
    "gNumber": "H-100927",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1806",
    "yearOfDeath": 1806,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Stuart"
  },
  {
    "nameId": "Mr Ephram Smith",
    "gNumber": "H-101295",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 30,
    "ancestry": "Unknown",
    "dateOfDeath": "1806-02-13",
    "yearOfDeath": 1806,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Eliza Norton",
    "gNumber": "H-101015",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1806-07-11",
    "yearOfDeath": 1806,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Maria Foering",
    "gNumber": "H-100487",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 19,
    "ancestry": "Unknown",
    "dateOfDeath": "1806-05-10",
    "yearOfDeath": 1806,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Hannah Moulder",
    "gNumber": "H-100990",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "9-13",
    "ageAtDeath": 11,
    "ancestry": "Unknown",
    "dateOfDeath": "1806-08-17",
    "yearOfDeath": 1806,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Sarah Turner",
    "gNumber": "H-101424",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1806",
    "yearOfDeath": 1806,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. John"
  },
  {
    "nameId": "William Miles",
    "gNumber": "H-100928",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1806-05-24",
    "yearOfDeath": 1806,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child3) Warner",
    "gNumber": "H-101474",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "7-11",
    "ageAtDeath": 9,
    "ancestry": "Unknown",
    "dateOfDeath": "1806-06-10",
    "yearOfDeath": 1806,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. William Warner"
  },
  {
    "nameId": "Elizabeth Ann Jones",
    "gNumber": "H-100724",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "6-10",
    "ageAtDeath": 8,
    "ancestry": "Unknown",
    "dateOfDeath": "1806-07-25",
    "yearOfDeath": 1806,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Philip"
  },
  {
    "nameId": "Elican Smith",
    "gNumber": "H-101296",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 30,
    "ancestry": "Unknown",
    "dateOfDeath": "1806-08-13",
    "yearOfDeath": 1806,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Moulder",
    "gNumber": "H-100991",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1806-09-23",
    "yearOfDeath": 1806,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Ch. Mr. Moulder"
  },
  {
    "nameId": "Lydia Billings",
    "gNumber": "H-100117",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "1-5",
    "ageAtDeath": 3,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-01-21",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Susansah Rose",
    "gNumber": "H-101187",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 77,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-02-21",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth Robinson",
    "gNumber": "H-101177",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-03-04",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Thomas"
  },
  {
    "nameId": "Joseph Hess",
    "gNumber": "H-100635",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-04-04",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Susanna Morgan",
    "gNumber": "H-100966",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1807",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs (wife) Rittenhouse",
    "gNumber": "H-101168",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1807",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Henry"
  },
  {
    "nameId": "Thomas Sailer",
    "gNumber": "H-101209",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1807",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John"
  },
  {
    "nameId": "Thomas Entriken",
    "gNumber": "H-100450",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-05-04",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Thomas"
  },
  {
    "nameId": "Thomas Thomas",
    "gNumber": "H-101385",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-05-27",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Joshua"
  },
  {
    "nameId": "(child) Keen",
    "gNumber": "H-100752",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-06-11",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Joseph"
  },
  {
    "nameId": "Robert Hamilton",
    "gNumber": "H-100588",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "12-16",
    "ageAtDeath": 14,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-10-02",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Moore",
    "gNumber": "H-100958",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-10-03",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Roberts",
    "gNumber": "H-101172",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-10-03",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Thomas"
  },
  {
    "nameId": "(child) Smith",
    "gNumber": "H-101297",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1807",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Francis"
  },
  {
    "nameId": "Rebecca Delacroix",
    "gNumber": "H-100373",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 55,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-12-06",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Sophia Taylor",
    "gNumber": "H-101371",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "8-12",
    "ageAtDeath": 10,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-12-11",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Susannah Shepard",
    "gNumber": "H-101255",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "6-10",
    "ageAtDeath": 8,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-12-14",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Died in James Boyers House"
  },
  {
    "nameId": "John Andrews",
    "gNumber": "H-100016",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-12-28",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Watkins",
    "gNumber": "H-101490",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-12-30",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "son of John Watkins"
  },
  {
    "nameId": "John Hacker",
    "gNumber": "H-100581",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1807",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Engels McLeod",
    "gNumber": "H-100916",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-08-21",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "James Wells",
    "gNumber": "H-101518",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-11-08",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Dallam",
    "gNumber": "H-100336",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-04-29",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Samuel"
  },
  {
    "nameId": "Naomi Loves",
    "gNumber": "H-100840",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 18,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-05-19",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Benjamin and Sarah"
  },
  {
    "nameId": "Mrs Sarah Marsh",
    "gNumber": "H-100866",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 68,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-02-10",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Mr."
  },
  {
    "nameId": "Thomas Hamilton",
    "gNumber": "H-100587",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 55,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-08-09",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Deborah Shingleton",
    "gNumber": "H-101267",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 83,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-02-11",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Mr. Shingleton"
  },
  {
    "nameId": "(child) Baker",
    "gNumber": "H-100044",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "7-11",
    "ageAtDeath": 9,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-04-18",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mr Henry and Mrs."
  },
  {
    "nameId": "George Dalrimple",
    "gNumber": "H-100338",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-04-20",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Enoch Thomas",
    "gNumber": "H-101384",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 57,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-04-20",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Catherine Galloway",
    "gNumber": "H-100511",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-07-26",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Mr. Calloway"
  },
  {
    "nameId": "Carolina Dorsey",
    "gNumber": "H-100399",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-07-28",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"child\""
  },
  {
    "nameId": "(child) Davis",
    "gNumber": "H-100352",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1807",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Samson"
  },
  {
    "nameId": "Joseph Lawson",
    "gNumber": "H-100815",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-08-04",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Biss",
    "gNumber": "H-100123",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "3-7",
    "ageAtDeath": 5,
    "ancestry": "Unknown",
    "dateOfDeath": "1807-11-23",
    "yearOfDeath": 1807,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth Hollingsworth",
    "gNumber": "H-100655",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 28,
    "ancestry": "Unknown",
    "dateOfDeath": "1808-02-06",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Lee",
    "gNumber": "H-100819",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1808-02-24",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Benjamin"
  },
  {
    "nameId": "James Jamieson Kelly",
    "gNumber": "H-100766",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1808-02-28",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Scott",
    "gNumber": "H-101225",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 18,
    "ancestry": "Unknown",
    "dateOfDeath": "1808-03-02",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "James Peckworth",
    "gNumber": "H-101055",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1808-03-08",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Knight",
    "gNumber": "H-100798",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1808-03-13",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John"
  },
  {
    "nameId": "Susannah Bright",
    "gNumber": "H-100157",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 84,
    "ancestry": "Unknown",
    "dateOfDeath": "1808-05-28",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Samuel C. Reynolds",
    "gNumber": "H-101147",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1808-07-02",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rebecca Ann Jones",
    "gNumber": "H-100725",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1808-08-12",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Sweborrough Friends",
    "gNumber": "H-100506",
    "sex": "Unknown",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 42,
    "ancestry": "Unknown",
    "dateOfDeath": "1808-08-20",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Galloway",
    "gNumber": "H-100512",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1808-08-25",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Ch. John"
  },
  {
    "nameId": "(child) Sailor (Sailer)",
    "gNumber": "H-101213",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1808",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John"
  },
  {
    "nameId": "Jacob Bright",
    "gNumber": "H-100158",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 44,
    "ancestry": "Unknown",
    "dateOfDeath": "1808-10-07",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Flintham",
    "gNumber": "H-100485",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 75,
    "ancestry": "Unknown",
    "dateOfDeath": "1808-10-17",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Hess",
    "gNumber": "H-100636",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1808-10-17",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Wm."
  },
  {
    "nameId": "(child) Williams",
    "gNumber": "H-101554",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1808-10-31",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "child of Jesse Williams"
  },
  {
    "nameId": "(daughter) Gordon",
    "gNumber": "H-100550",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1808",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Francis; 3 hrs after birth"
  },
  {
    "nameId": "Jacob C. Ferrell",
    "gNumber": "H-100471",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 24,
    "ancestry": "Unknown",
    "dateOfDeath": "1808-11-03",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Miss Catharine Woods",
    "gNumber": "H-101582",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 27,
    "ancestry": "Unknown",
    "dateOfDeath": "1808-11-17",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Richard Wells",
    "gNumber": "H-101519",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 46,
    "ancestry": "Unknown",
    "dateOfDeath": "1808",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Morris",
    "gNumber": "H-100972",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 38,
    "ancestry": "Unknown",
    "dateOfDeath": "1808-12-13",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Joseph Watkins",
    "gNumber": "H-101491",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 74,
    "ancestry": "Unknown",
    "dateOfDeath": "1808-12-15",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Kinshaw?",
    "gNumber": "H-100794",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 74,
    "ancestry": "Unknown",
    "dateOfDeath": "1808",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ann Malony",
    "gNumber": "H-100860",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1808",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Owen",
    "gNumber": "H-101034",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 58,
    "ancestry": "Unknown",
    "dateOfDeath": "1808",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(infant) Malony",
    "gNumber": "H-100861",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1808-09-30",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth Grace Jones",
    "gNumber": "H-100726",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1808-11-07",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Philip Jones"
  },
  {
    "nameId": "James North",
    "gNumber": "H-101014",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 76,
    "ancestry": "Unknown",
    "dateOfDeath": "1808",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Edward Waters",
    "gNumber": "H-101488",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 25,
    "ancestry": "Unknown",
    "dateOfDeath": "1808-12-10",
    "yearOfDeath": 1808,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "also listed at 24 y/o"
  },
  {
    "nameId": "(child) Turner",
    "gNumber": "H-101425",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1809",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "child of John Turner"
  },
  {
    "nameId": "Olivia Gardner",
    "gNumber": "H-100516",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 45,
    "ancestry": "Unknown",
    "dateOfDeath": "1809",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "James Smith",
    "gNumber": "H-101298",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 35,
    "ancestry": "Unknown",
    "dateOfDeath": "1809",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Matthew Trumball",
    "gNumber": "H-101422",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "14-18",
    "ageAtDeath": 16,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-02-11",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Unice Smith",
    "gNumber": "H-101299",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 72,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-02-17",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Hester Billings",
    "gNumber": "H-100118",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 23,
    "ancestry": "Unknown",
    "dateOfDeath": "1809",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Bozorth",
    "gNumber": "H-100144",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1809",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Andrew"
  },
  {
    "nameId": "William Baker",
    "gNumber": "H-100045",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-03-04",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Basset"
  },
  {
    "nameId": "(child) Billings",
    "gNumber": "H-100119",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-04-11",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mr. Billings"
  },
  {
    "nameId": "William Bright",
    "gNumber": "H-100159",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-04-12",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(daughter) Ellis",
    "gNumber": "H-100443",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "1-5",
    "ageAtDeath": 3,
    "ancestry": "Unknown",
    "dateOfDeath": "1809",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Enos."
  },
  {
    "nameId": "Ezekiel Taylor",
    "gNumber": "H-101372",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 35,
    "ancestry": "Unknown",
    "dateOfDeath": "1809",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Wood",
    "gNumber": "H-101570",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 55,
    "ancestry": "Unknown",
    "dateOfDeath": "1809",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Baker",
    "gNumber": "H-100046",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-05-07",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch Capt. Thomas"
  },
  {
    "nameId": "John Hellings",
    "gNumber": "H-100625",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 67,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-05-21",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(infant) Roberts",
    "gNumber": "H-101173",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-05-30",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "inf ch. Thomas"
  },
  {
    "nameId": "(child) Wells",
    "gNumber": "H-101520",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-05-31",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "child of Thomas Wells"
  },
  {
    "nameId": "George Rose",
    "gNumber": "H-101188",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 41,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-06-01",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Chaldwich",
    "gNumber": "H-100246",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 22,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-06-24",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Kingston",
    "gNumber": "H-100790",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1809",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Capt."
  },
  {
    "nameId": "Alexander Ross Cox",
    "gNumber": "H-100319",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-07-03",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jane Babes",
    "gNumber": "H-100040",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 30,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-07-06",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Jane McNight",
    "gNumber": "H-100920",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 18,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-07-14",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Sears",
    "gNumber": "H-101229",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-07-14",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mr. Sears"
  },
  {
    "nameId": "Sarah Moore",
    "gNumber": "H-100959",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1809",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Isaac Warner",
    "gNumber": "H-101475",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "10-14",
    "ageAtDeath": 12,
    "ancestry": "Unknown",
    "dateOfDeath": "1809",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Son of William Warner"
  },
  {
    "nameId": "Betsey Hawk",
    "gNumber": "H-100618",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1809",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Joanna"
  },
  {
    "nameId": "Thomas Waters Britton",
    "gNumber": "H-100176",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 19,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-09-19",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Poulson",
    "gNumber": "H-101102",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 32,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-10-29",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Margaret Graham",
    "gNumber": "H-100564",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 60,
    "ancestry": "Unknown",
    "dateOfDeath": "1809",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "James Perkins",
    "gNumber": "H-101077",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1809",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Beck",
    "gNumber": "H-100090",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-11-11",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Israel and Ann"
  },
  {
    "nameId": "Benjamin Norton",
    "gNumber": "H-101016",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1809",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rebecca Woods",
    "gNumber": "H-101583",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 20,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-12-20",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ann Beck",
    "gNumber": "H-100091",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 25,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-12-21",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jane Bebb",
    "gNumber": "H-100089",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-07-06",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"Hard: bur it may be done\""
  },
  {
    "nameId": "Stephen Shewell",
    "gNumber": "H-101262",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 84,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-12-24",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "h. Elizabeth"
  },
  {
    "nameId": "Lydia Boram",
    "gNumber": "H-100127",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-11-21",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. John and Lydia; granddaughter of Stephen and Elizabeth Shewall"
  },
  {
    "nameId": "Ann Loxley",
    "gNumber": "H-100845",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 34,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-09-23",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Joanna Anthony",
    "gNumber": "H-100020",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 90,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-04-29",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Relict of Stephen"
  },
  {
    "nameId": "Mrs Elizabeth Hassal",
    "gNumber": "H-100617",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 47,
    "ancestry": "Unknown",
    "dateOfDeath": "1809-07-06",
    "yearOfDeath": 1809,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Joseph"
  },
  {
    "nameId": "John Glen Fleeson",
    "gNumber": "H-100481",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 28,
    "ancestry": "Unknown",
    "dateOfDeath": "1810-07-26",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "grandson of Plunket Fleeson, Esq"
  },
  {
    "nameId": "William Ball Esq.",
    "gNumber": "H-100057",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 81,
    "ancestry": "Unknown",
    "dateOfDeath": "1810-05-31",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Martha Fry",
    "gNumber": "H-100509",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 63,
    "ancestry": "Unknown",
    "dateOfDeath": "1810-01-14",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Joseph Fry signed"
  },
  {
    "nameId": "(child) Friend",
    "gNumber": "H-100504",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1810",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Isaac"
  },
  {
    "nameId": "Robert Stenet",
    "gNumber": "H-101330",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1810-02-01",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rebecca Gordon",
    "gNumber": "H-100551",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 62,
    "ancestry": "Unknown",
    "dateOfDeath": "1810",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Jordan",
    "gNumber": "H-100742",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1810",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jane Stedman",
    "gNumber": "H-101327",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 25,
    "ancestry": "Unknown",
    "dateOfDeath": "1810",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Yardley",
    "gNumber": "H-101593",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1810",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Richard"
  },
  {
    "nameId": "(child) Weatherby",
    "gNumber": "H-101510",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1810-03-15",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "child of Mr. Weatherby"
  },
  {
    "nameId": "(child) Hamilton",
    "gNumber": "H-100589",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1810-03-24",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Ch. Mrs.; Wm. Hamilton signed"
  },
  {
    "nameId": "James Anderson",
    "gNumber": "H-100012",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 20,
    "ancestry": "Unknown",
    "dateOfDeath": "1810",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "James Barret",
    "gNumber": "H-100070",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 57,
    "ancestry": "Unknown",
    "dateOfDeath": "1810",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Samuel Baker",
    "gNumber": "H-100047",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 18,
    "ancestry": "Unknown",
    "dateOfDeath": "1810-04-08",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. David and Elizabeth"
  },
  {
    "nameId": "Mary Alberson",
    "gNumber": "H-100006",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 82,
    "ancestry": "Unknown",
    "dateOfDeath": "1810-04-12",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Lewis Blackwell",
    "gNumber": "H-100124",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 29,
    "ancestry": "Unknown",
    "dateOfDeath": "1810",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Miller",
    "gNumber": "H-100934",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1810-05-16",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. James"
  },
  {
    "nameId": "Mary Burrows",
    "gNumber": "H-100205",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 50,
    "ancestry": "Unknown",
    "dateOfDeath": "1810-05-18",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ann Lowe",
    "gNumber": "H-100842",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1810-05-29",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. John and Ann"
  },
  {
    "nameId": "Charles Rhodes",
    "gNumber": "H-101160",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 40,
    "ancestry": "Unknown",
    "dateOfDeath": "1810",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Martha Pattan",
    "gNumber": "H-101044",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 32,
    "ancestry": "Unknown",
    "dateOfDeath": "1810",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Turner",
    "gNumber": "H-101426",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1810",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Child of James W. Turner"
  },
  {
    "nameId": "Ann Kelly",
    "gNumber": "H-100767",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 27,
    "ancestry": "Unknown",
    "dateOfDeath": "1810-07-05",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Straton",
    "gNumber": "H-101353",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1810-07-08",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John"
  },
  {
    "nameId": "(child) Croskey",
    "gNumber": "H-100329",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1810-07-27",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. George"
  },
  {
    "nameId": "(unknown) Baker",
    "gNumber": "H-100048",
    "sex": "Unknown",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 76,
    "ancestry": "Unknown",
    "dateOfDeath": "1810",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Sims",
    "gNumber": "H-101287",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1810",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Sims"
  },
  {
    "nameId": "(child) Turner",
    "gNumber": "H-101428",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1810-08-06",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "child of Capt. Jno. Turner"
  },
  {
    "nameId": "Rachel Kelly",
    "gNumber": "H-100768",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 60,
    "ancestry": "Unknown",
    "dateOfDeath": "1810-08-13",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Francis Stoat",
    "gNumber": "H-101346",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 31,
    "ancestry": "Unknown",
    "dateOfDeath": "1810-10-14",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth Baker",
    "gNumber": "H-100049",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 40,
    "ancestry": "Unknown",
    "dateOfDeath": "1810",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Gaskill",
    "gNumber": "H-100519",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1810",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Edmund"
  },
  {
    "nameId": "James Miller",
    "gNumber": "H-100935",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 25,
    "ancestry": "Unknown",
    "dateOfDeath": "1810",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Weed",
    "gNumber": "H-101516",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 63,
    "ancestry": "Unknown",
    "dateOfDeath": "1810",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Hannah Yates",
    "gNumber": "H-101596",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 28,
    "ancestry": "Unknown",
    "dateOfDeath": "1810",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Monnes Brown",
    "gNumber": "H-100182",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1810-12-30",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Nathan Ball Esq.",
    "gNumber": "H-100056",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 80,
    "ancestry": "Unknown",
    "dateOfDeath": "1810-05-30",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "h. Elizabeth"
  },
  {
    "nameId": "Elizabeth Shewell",
    "gNumber": "H-101263",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1810-06-07",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Stephen and Elizabeth"
  },
  {
    "nameId": "William Topham",
    "gNumber": "H-101409",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 24,
    "ancestry": "Unknown",
    "dateOfDeath": "1810-04-30",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Turner",
    "gNumber": "H-101427",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1810",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. John"
  },
  {
    "nameId": "Elizabeth Hawley",
    "gNumber": "H-100621",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 24,
    "ancestry": "Unknown",
    "dateOfDeath": "1810-12-16",
    "yearOfDeath": 1810,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Fignel",
    "gNumber": "H-100472",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "1-5",
    "ageAtDeath": 3,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-01-08",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch of Fignel"
  },
  {
    "nameId": "Deborah Wood",
    "gNumber": "H-101571",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-01-24",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Bainbridge",
    "gNumber": "H-100043",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "1-5",
    "ageAtDeath": 3,
    "ancestry": "Unknown",
    "dateOfDeath": "1811",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Henry"
  },
  {
    "nameId": "(child) Preest",
    "gNumber": "H-101115",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-07-18",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Francis"
  },
  {
    "nameId": "Christeanah Benned",
    "gNumber": "H-100100",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "1-5",
    "ageAtDeath": 3,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-08-10",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Sailor",
    "gNumber": "H-101210",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 40,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-09-10",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Nailer",
    "gNumber": "H-101000",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1811",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John"
  },
  {
    "nameId": "Edwin Croskey",
    "gNumber": "H-100330",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1811",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Martin",
    "gNumber": "H-100869",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1811",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Margaret Martin"
  },
  {
    "nameId": "(child) Poulson",
    "gNumber": "H-101103",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1811",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John"
  },
  {
    "nameId": "(child) Figuier",
    "gNumber": "H-100474",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-01-04",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Andrew"
  },
  {
    "nameId": "Hannah Thaw",
    "gNumber": "H-101377",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 55,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-01-19",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Benjmain"
  },
  {
    "nameId": "William Britton Jr",
    "gNumber": "H-100177",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "3-7",
    "ageAtDeath": 5,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-08-15",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. William and Catharine"
  },
  {
    "nameId": "Harriet Carson",
    "gNumber": "H-100232",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 18,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-02-18",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Peter Bicknell",
    "gNumber": "H-100112",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 52,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-04-17",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Reed (Read)",
    "gNumber": "H-101138",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-02-13",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. James"
  },
  {
    "nameId": "Martha Martin",
    "gNumber": "H-100868",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 20,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-05-10",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) John",
    "gNumber": "H-100697",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-06-13",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. David"
  },
  {
    "nameId": "Edgar Dallam",
    "gNumber": "H-100337",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-06-15",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Samuel Dallan signed"
  },
  {
    "nameId": "Samuel Hamilton",
    "gNumber": "H-100590",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 32,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-06-17",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Sarah Penrose",
    "gNumber": "H-101066",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 43,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-06-17",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Henry Riley",
    "gNumber": "H-101165",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "4-8",
    "ageAtDeath": 6,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-06-18",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John"
  },
  {
    "nameId": "(child) Smith",
    "gNumber": "H-101300",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-06-23",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Francis"
  },
  {
    "nameId": "Catherine Plaine",
    "gNumber": "H-101093",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "14-18",
    "ageAtDeath": 16,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-06-29",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(son) Griffin",
    "gNumber": "H-100570",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-07-05",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. William"
  },
  {
    "nameId": "Thomas Stewart Jr.",
    "gNumber": "H-101337",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 31,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-07-14",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Thomas"
  },
  {
    "nameId": "Thomas T. (T.T.) Peters",
    "gNumber": "H-101080",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 52,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-08-08",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Peter Worral (Wornal)",
    "gNumber": "H-101587",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "9-13",
    "ageAtDeath": 11,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-08-18",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Bennet",
    "gNumber": "H-100108",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-09-06",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Henry"
  },
  {
    "nameId": "Mary Harper",
    "gNumber": "H-100605",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-09-08",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. William"
  },
  {
    "nameId": "Sarah Wright",
    "gNumber": "H-101589",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-09-16",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Thomas and Ann"
  },
  {
    "nameId": "Adelaide Martin",
    "gNumber": "H-100870",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-11-05",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Margaret Martin"
  },
  {
    "nameId": "Elizabeth Ramsey",
    "gNumber": "H-101130",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 53,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-11-09",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Margaret Martin",
    "gNumber": "H-100871",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 30,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-11-15",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Berthenia Lafferty",
    "gNumber": "H-100804",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 27,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-12-10",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. James"
  },
  {
    "nameId": "Mary McClutch",
    "gNumber": "H-100891",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 62,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-12-11",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"poor\""
  },
  {
    "nameId": "(child) Steinburgh",
    "gNumber": "H-101329",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-12-12",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mr."
  },
  {
    "nameId": "Elizabeth Douglas",
    "gNumber": "H-100404",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 40,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-12-13",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(grandchild) Brown",
    "gNumber": "H-100183",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-01-02",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "grandchild of Francis"
  },
  {
    "nameId": "(wife) Figuier",
    "gNumber": "H-100475",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-01-07",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Andrew"
  },
  {
    "nameId": "(child) Wood",
    "gNumber": "H-101572",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-01-26",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. James"
  },
  {
    "nameId": "(child) Cage",
    "gNumber": "H-100218",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-03-18",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. James M"
  },
  {
    "nameId": "Elizabeth Collins",
    "gNumber": "H-100304",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-04-05",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) French",
    "gNumber": "H-100502",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-04-16",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Isaac F"
  },
  {
    "nameId": "Mr Jonathan Heyde",
    "gNumber": "H-100643",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-04-18",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "$10 total paid for his and Mrs. Kenndy's burial"
  },
  {
    "nameId": "Mrs (wife) Kennedy",
    "gNumber": "H-100777",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-04-18",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "$10 paid for hers and Jonathan Heyde's burial"
  },
  {
    "nameId": "Lydia Thomas",
    "gNumber": "H-101386",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-06-28",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"money return'd, burial by the overseer of the poor\""
  },
  {
    "nameId": "(child) Prent",
    "gNumber": "H-101116",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-07-19",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Levi"
  },
  {
    "nameId": "(child) Brainbridge",
    "gNumber": "H-100151",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-07-31",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. H.J."
  },
  {
    "nameId": "(child) Bennet",
    "gNumber": "H-100107",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-08-12",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Henry"
  },
  {
    "nameId": "Joseph Clay",
    "gNumber": "H-100284",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-08-27",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"Buried in church burial ground\"; \"buried in Church burial ground\""
  },
  {
    "nameId": "(child) Mortin",
    "gNumber": "H-100980",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-10-03",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Margaret"
  },
  {
    "nameId": "(child) Sailor",
    "gNumber": "H-101211",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-10-08",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John"
  },
  {
    "nameId": "(wife) Sailor",
    "gNumber": "H-101212",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-10-27",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. John"
  },
  {
    "nameId": "(child) Whiteside",
    "gNumber": "H-101542",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-11-02",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Sarah"
  },
  {
    "nameId": "(grandchild) Ashmead",
    "gNumber": "H-100030",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-11-04",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "grandch. Capt. Ashmead"
  },
  {
    "nameId": "(child) Paulson",
    "gNumber": "H-101049",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-11-09",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Jonathan"
  },
  {
    "nameId": "John Wells Sr.",
    "gNumber": "H-101521",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 62,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-11-17",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Mary J. Wells and John Wells Jr. signed"
  },
  {
    "nameId": "(son) Carr",
    "gNumber": "H-100231",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-11-23",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Isaac"
  },
  {
    "nameId": "(boy) Simm",
    "gNumber": "H-101274",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-12-01",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "boy of Joseph"
  },
  {
    "nameId": "(child) Dorsey",
    "gNumber": "H-100400",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-12-02",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Thomas"
  },
  {
    "nameId": "Harriet Coxe",
    "gNumber": "H-100324",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 44,
    "ancestry": "Unknown",
    "dateOfDeath": "1811-01-03",
    "yearOfDeath": 1811,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. John T"
  },
  {
    "nameId": "(child) Morton",
    "gNumber": "H-100981",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1812",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Ebenezer"
  },
  {
    "nameId": "William Brown",
    "gNumber": "H-100184",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "6-10",
    "ageAtDeath": 8,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-01-13",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Andrew Bozorth",
    "gNumber": "H-100145",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 79,
    "ancestry": "Unknown",
    "dateOfDeath": "1812",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Hezekiah Hawk",
    "gNumber": "H-100619",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 40,
    "ancestry": "Unknown",
    "dateOfDeath": "1812",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William A. Lotz",
    "gNumber": "H-100838",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1812",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) McEntire",
    "gNumber": "H-100900",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1812",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. McEntire"
  },
  {
    "nameId": "Stephen Beasley",
    "gNumber": "H-100084",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 73,
    "ancestry": "Unknown",
    "dateOfDeath": "1812",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Moses Johnson",
    "gNumber": "H-100702",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Af. Decent",
    "dateOfDeath": "1812",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "African Decent"
  },
  {
    "nameId": "(child) Brinton",
    "gNumber": "H-100171",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-01-14",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Joseph"
  },
  {
    "nameId": "(child) Horton",
    "gNumber": "H-100662",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-01-16",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Ebenezer"
  },
  {
    "nameId": "(grandmother) Tract",
    "gNumber": "H-101416",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-01-18",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Mary Tract's grandmother"
  },
  {
    "nameId": "(father) Borgarth",
    "gNumber": "H-100128",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-02-12",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "father Andrew"
  },
  {
    "nameId": "(child) Tapels",
    "gNumber": "H-101365",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-03-05",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Andrew"
  },
  {
    "nameId": "John Walker",
    "gNumber": "H-101459",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-03-09",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Haykrech Hawkes",
    "gNumber": "H-100620",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-05-10",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Williams",
    "gNumber": "H-101556",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-06-11",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. James"
  },
  {
    "nameId": "Mary Taylor",
    "gNumber": "H-101373",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-07-15",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Leto",
    "gNumber": "H-100827",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-08-08",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. William"
  },
  {
    "nameId": "(child) McInt\u2026",
    "gNumber": "H-100906",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-08-09",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Jonathan"
  },
  {
    "nameId": "(wife) Cole",
    "gNumber": "H-100300",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-08-21",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Benjamin"
  },
  {
    "nameId": "(child) Rittenhouse",
    "gNumber": "H-101169",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-09-16",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Henry"
  },
  {
    "nameId": "John Fopless",
    "gNumber": "H-100489",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-03-06",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Andrew"
  },
  {
    "nameId": "Jon Babcock",
    "gNumber": "H-100038",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 57,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-04-14",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"Wm. Britton to see it paid\""
  },
  {
    "nameId": "Dorothea Babcock",
    "gNumber": "H-100039",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "4-8",
    "ageAtDeath": 6,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-08-15",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Jacob; \"Wm. Britton to see it paid\""
  },
  {
    "nameId": "Ann Williams",
    "gNumber": "H-101555",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 95,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-01-13",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"Ritenhouse's Mother in Law\"; \"from Scotland\""
  },
  {
    "nameId": "Susannah Willis",
    "gNumber": "H-101557",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 39,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-06-13",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ruth Johns",
    "gNumber": "H-100698",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 33,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-07-09",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. David"
  },
  {
    "nameId": "Samuel Burkloe",
    "gNumber": "H-100199",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 53,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-08-26",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "h. Catherine"
  },
  {
    "nameId": "Ann Ryan",
    "gNumber": "H-101207",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 55,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-08-25",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Edward; \"poor\""
  },
  {
    "nameId": "Jane Ford",
    "gNumber": "H-100491",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 62,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-02-01",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Morford",
    "gNumber": "H-100963",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 99,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-02-08",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"poor\"; \"He had 7 children, 42 grandchildren, 116 great grand children, 15 great great grandchildren\""
  },
  {
    "nameId": "Gen Michael Bright",
    "gNumber": "H-100160",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 50,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-02-11",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Dorothy Badcock",
    "gNumber": "H-100042",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 22,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-02-25",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Widow of Jacob Badcock; \"Wm. Britton to see it paid\"; \"Wm. Britton to see it paid\""
  },
  {
    "nameId": "Sarah Miller",
    "gNumber": "H-100936",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1812",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Jesse"
  },
  {
    "nameId": "Mary Moulder",
    "gNumber": "H-100992",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 67,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-03-27",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "wid. William; \"tombstone\"; wid. William; \"tombstone\""
  },
  {
    "nameId": "Catharine Howell",
    "gNumber": "H-100668",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 57,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-06-12",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Reading"
  },
  {
    "nameId": "C. Saxon",
    "gNumber": "H-101222",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-08-03",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. John"
  },
  {
    "nameId": "Alexander Powell (Powel)",
    "gNumber": "H-101114",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 19,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-08-25",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Samuel Burklel",
    "gNumber": "H-100198",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 52,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-08-27",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Beck",
    "gNumber": "H-100092",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-09-22",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Martin"
  },
  {
    "nameId": "(son) Foot",
    "gNumber": "H-100488",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-09-23",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. James"
  },
  {
    "nameId": "Jonathan Gregory Senior",
    "gNumber": "H-100569",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 74,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-10-27",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(daughter) Morse",
    "gNumber": "H-100979",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1812-11-10",
    "yearOfDeath": 1812,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Capt Morse"
  },
  {
    "nameId": "William Oakford",
    "gNumber": "H-101023",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-06-15",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Susan Campbell",
    "gNumber": "H-100226",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1813",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Wight",
    "gNumber": "H-101544",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-07-12",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "child of Thomas Wight; Age is listed at \"Less than one year\""
  },
  {
    "nameId": "Abner Poulson",
    "gNumber": "H-101104",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "13-17",
    "ageAtDeath": 15,
    "ancestry": "Unknown",
    "dateOfDeath": "1813",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Dorsey",
    "gNumber": "H-100402",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "3-7",
    "ageAtDeath": 5,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-08-24",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Thomas"
  },
  {
    "nameId": "Thomas Hess",
    "gNumber": "H-100637",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-08-31",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Joseph Haines",
    "gNumber": "H-100584",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 30,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-09-30",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jacob Feiring",
    "gNumber": "H-100467",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 22,
    "ancestry": "Unknown",
    "dateOfDeath": "1813",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Luther Miles",
    "gNumber": "H-100929",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 40,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-10-15",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Robert K Cave",
    "gNumber": "H-100237",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-02-26",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ann Connell",
    "gNumber": "H-100308",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Hugh McConnell",
    "gNumber": "H-100892",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-01-18",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Baker",
    "gNumber": "H-100050",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-01-24",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Basset"
  },
  {
    "nameId": "Mary Jackway",
    "gNumber": "H-100685",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-01-25",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Silas Thaw",
    "gNumber": "H-101378",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-01-25",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Nicholas Whetstone",
    "gNumber": "H-101532",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-02-01",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Anderson",
    "gNumber": "H-100013",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-02-05",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Alexander Chenec",
    "gNumber": "H-100258",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-02-15",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Davenport",
    "gNumber": "H-100340",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-02-18",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. William"
  },
  {
    "nameId": "(child) Stewart",
    "gNumber": "H-101338",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-02-24",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Thomas"
  },
  {
    "nameId": "Sarah Powell",
    "gNumber": "H-101110",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-03-04",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs (wife) Bogarth",
    "gNumber": "H-100126",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-04-06",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Low",
    "gNumber": "H-100841",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-04-20",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. William"
  },
  {
    "nameId": "(wife) Dorsey",
    "gNumber": "H-100401",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-04-22",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Thomas"
  },
  {
    "nameId": "(child) Miller",
    "gNumber": "H-100937",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-04-28",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. William"
  },
  {
    "nameId": "(young man) Dobson",
    "gNumber": "H-100388",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-04-29",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "young man of Thomas"
  },
  {
    "nameId": "Sarah Woode",
    "gNumber": "H-101580",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-05-18",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Walter",
    "gNumber": "H-101466",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-06-13",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Clarkford",
    "gNumber": "H-100281",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-06-15",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. William"
  },
  {
    "nameId": "(child) James",
    "gNumber": "H-100686",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-06-28",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Otto"
  },
  {
    "nameId": "(child) Campabello",
    "gNumber": "H-100224",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-07-12",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "cb. George"
  },
  {
    "nameId": "(child) Wright",
    "gNumber": "H-101590",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-07-14",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Thomas"
  },
  {
    "nameId": "Abner Paulson",
    "gNumber": "H-101050",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-08-22",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "brother of John"
  },
  {
    "nameId": "(child) Dorsey",
    "gNumber": "H-100403",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-08-25",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. William"
  },
  {
    "nameId": "(grandchild) Mitchell",
    "gNumber": "H-100950",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-09-01",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "grandch. Abraham"
  },
  {
    "nameId": "John Carson",
    "gNumber": "H-100233",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "11-15",
    "ageAtDeath": 13,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-09-30",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Joseph Harris",
    "gNumber": "H-100607",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-09-30",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jacob Turing",
    "gNumber": "H-101423",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-10-08",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"a member\"; \"poor\""
  },
  {
    "nameId": "Mrs J. Cold",
    "gNumber": "H-100298",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-10-09",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Harriot Cox",
    "gNumber": "H-100320",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 46,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-04-07",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. John T."
  },
  {
    "nameId": "Hannah Kirkpatrick",
    "gNumber": "H-100795",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 40,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-09-26",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Jas."
  },
  {
    "nameId": "John T. Cox",
    "gNumber": "H-100321",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-04-09",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Suchay Miles",
    "gNumber": "H-100930",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 42,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-10-16",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John W. Christie",
    "gNumber": "H-100260",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 64,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-06-07",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "From Scotland"
  },
  {
    "nameId": "Ann Reagan (Regin)",
    "gNumber": "H-101132",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 52,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-07-05",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Catherin Jane Chapman",
    "gNumber": "H-100251",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-07-11",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. L.; L. Chapman, signed"
  },
  {
    "nameId": "Edward Burrowes",
    "gNumber": "H-100204",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "11-15",
    "ageAtDeath": 13,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-07-17",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Davis",
    "gNumber": "H-100353",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-07-27",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Sampson"
  },
  {
    "nameId": "William Gaskill",
    "gNumber": "H-100520",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-08-02",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Edmund"
  },
  {
    "nameId": "Sarah Applegate",
    "gNumber": "H-100021",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 67,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-08-20",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"pd by Capt. Rguet\"; \"pd by Capt Raguet\""
  },
  {
    "nameId": "Mary Davis",
    "gNumber": "H-100354",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "10-14",
    "ageAtDeath": 12,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-08-23",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Hariet Davis",
    "gNumber": "H-100355",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "14-18",
    "ageAtDeath": 16,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-08-31",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Harriet"
  },
  {
    "nameId": "Alexander Thomas",
    "gNumber": "H-101387",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "5-9",
    "ageAtDeath": 7,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-08-31",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Edward"
  },
  {
    "nameId": "Mary Neaves (Neave)",
    "gNumber": "H-101007",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 54,
    "ancestry": "Unknown",
    "dateOfDeath": "1813",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(son) King",
    "gNumber": "H-100787",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-09-22",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Hermanus"
  },
  {
    "nameId": "Isabela McDougal",
    "gNumber": "H-100897",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 25,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-10-15",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Swain",
    "gNumber": "H-101358",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-10-18",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Christopher"
  },
  {
    "nameId": "Charles King",
    "gNumber": "H-100788",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "10-14",
    "ageAtDeath": 12,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-12-01",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. W. H."
  },
  {
    "nameId": "Catherine Hollingshead",
    "gNumber": "H-100654",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 60,
    "ancestry": "Unknown",
    "dateOfDeath": "1813-12-03",
    "yearOfDeath": 1813,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Burtis",
    "gNumber": "H-100207",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1814",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John"
  },
  {
    "nameId": "Almeria Smith",
    "gNumber": "H-101301",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "4-8",
    "ageAtDeath": 6,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-01-17",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Martha Shinn",
    "gNumber": "H-101268",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 54,
    "ancestry": "Unknown",
    "dateOfDeath": "1814",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jane Morris",
    "gNumber": "H-100973",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 23,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-02-27",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Susannah Tatem",
    "gNumber": "H-101366",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1814",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Susan"
  },
  {
    "nameId": "Rebecca McKeage",
    "gNumber": "H-100907",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "1-5",
    "ageAtDeath": 3,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-03-19",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. John and Ann"
  },
  {
    "nameId": "Alexander S. Vesey",
    "gNumber": "H-101446",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 27,
    "ancestry": "Unknown",
    "dateOfDeath": "1814",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Ashmead",
    "gNumber": "H-100031",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 71,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-05-18",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Purnell Reckworth",
    "gNumber": "H-101137",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-05-27",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Miss (Willison) Wilkson",
    "gNumber": "H-101550",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 38,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-07-01",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John McAuleans (McNuleans)",
    "gNumber": "H-100881",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 76,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-07-18",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Margaret Davis",
    "gNumber": "H-100356",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 80,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-08-11",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Walker",
    "gNumber": "H-101460",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-10-02",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "child of Joseph S. Walker"
  },
  {
    "nameId": "Benjamin Britten",
    "gNumber": "H-100172",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 36,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-11-28",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jonathan Taterns",
    "gNumber": "H-101370",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-04-04",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Hannah Smith",
    "gNumber": "H-101302",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-01-17",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"member\""
  },
  {
    "nameId": "Homer Smith",
    "gNumber": "H-101303",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-01-17",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Batie",
    "gNumber": "H-100079",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-01-19",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John"
  },
  {
    "nameId": "Marsha Shemin",
    "gNumber": "H-101254",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-02-14",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Reages",
    "gNumber": "H-101134",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-03-14",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. James"
  },
  {
    "nameId": "Jonathan Salem",
    "gNumber": "H-101219",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-04-04",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Vesey",
    "gNumber": "H-101447",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-04-15",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Alexander L"
  },
  {
    "nameId": "(child) Peckworth",
    "gNumber": "H-101056",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-05-27",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. J.P."
  },
  {
    "nameId": "(child) Bruck",
    "gNumber": "H-100191",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-07-13",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. William"
  },
  {
    "nameId": "Jonathan McCleod",
    "gNumber": "H-100887",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-07-19",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"John McLeod for\u2026\""
  },
  {
    "nameId": "Miss (woman) Milleson",
    "gNumber": "H-100947",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-08-02",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Davis",
    "gNumber": "H-100357",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-08-11",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Walter",
    "gNumber": "H-101467",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-10-04",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Joseph L .Walter"
  },
  {
    "nameId": "Margaret Barry",
    "gNumber": "H-100072",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-11-21",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Catherine Galloway (Holloway)",
    "gNumber": "H-100513",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 70,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-04-21",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Ann Hacker",
    "gNumber": "H-100582",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-09-24",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. George and Louise"
  },
  {
    "nameId": "Hannah Smith",
    "gNumber": "H-101304",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 35,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-12-01",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Isaac"
  },
  {
    "nameId": "Mrs Mary Ashmead",
    "gNumber": "H-100032",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 70,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-05-19",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. John"
  },
  {
    "nameId": "Stephen Beasley",
    "gNumber": "H-100085",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 73,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-11-17",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "h. Abigail"
  },
  {
    "nameId": "Sarah Miller",
    "gNumber": "H-100938",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 24,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-03-09",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Joshua Morris (Movies)",
    "gNumber": "H-100978",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "10-14",
    "ageAtDeath": 12,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-01-05",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary George",
    "gNumber": "H-100527",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 48,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-01-25",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(son) Russell",
    "gNumber": "H-101202",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-02-03",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mr."
  },
  {
    "nameId": "Ann Kelly",
    "gNumber": "H-100769",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-03-23",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Hugh; Hugh Kelly Signed"
  },
  {
    "nameId": "Margaret Cole",
    "gNumber": "H-100301",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 25,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-04-09",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ann Russell",
    "gNumber": "H-101203",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-04-14",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. John"
  },
  {
    "nameId": "Eliza Sailor (Sailer)",
    "gNumber": "H-101214",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-05-28",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John; John Sailer signed"
  },
  {
    "nameId": "Kenneth Roberts",
    "gNumber": "H-101174",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "5-9",
    "ageAtDeath": 7,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-08-08",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Benjamin"
  },
  {
    "nameId": "Sarah Davis",
    "gNumber": "H-100358",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 22,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-08-26",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(daughter) Shiver (Shrivers)",
    "gNumber": "H-101270",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "4-8",
    "ageAtDeath": 6,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-09-02",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. John"
  },
  {
    "nameId": "William Ashmead",
    "gNumber": "H-100033",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 41,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-10-20",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Capt. Jonathan"
  },
  {
    "nameId": "Mrs Annie Wood",
    "gNumber": "H-101573",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 90,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-12-06",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(daughter) Houck",
    "gNumber": "H-100664",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1814-07-16",
    "yearOfDeath": 1814,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. William"
  },
  {
    "nameId": "Mary Watkins",
    "gNumber": "H-101492",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 65,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-01-29",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth Rutherford",
    "gNumber": "H-101204",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-03-22",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Joseph B Duncan",
    "gNumber": "H-100412",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-03-25",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Smith",
    "gNumber": "H-101305",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-03-25",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Francis"
  },
  {
    "nameId": "Mary Shields",
    "gNumber": "H-101265",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-04-13",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Ryan",
    "gNumber": "H-101208",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-06-02",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "a child"
  },
  {
    "nameId": "(child) Keyser",
    "gNumber": "H-100782",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-06-12",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Jacob"
  },
  {
    "nameId": "Sarah Barnet",
    "gNumber": "H-100067",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-06-19",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(grandchild) Mitchell",
    "gNumber": "H-100951",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-07-12",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "grandchild Abraham Mitchell"
  },
  {
    "nameId": "Huldah Rambo",
    "gNumber": "H-101124",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-07-24",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Malin",
    "gNumber": "H-100856",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-08-11",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mrs. Malin"
  },
  {
    "nameId": "(child) McGage",
    "gNumber": "H-100901",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-08-13",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. James"
  },
  {
    "nameId": "James Stewart",
    "gNumber": "H-101339",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-08-28",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Thomas"
  },
  {
    "nameId": "(wife) Hyde",
    "gNumber": "H-100677",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-08-31",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. John"
  },
  {
    "nameId": "Sampson Davis",
    "gNumber": "H-100359",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-09-28",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Susannah Thomas",
    "gNumber": "H-101388",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-10-04",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Margaret Keen",
    "gNumber": "H-100753",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-10-07",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Draper",
    "gNumber": "H-100408",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-10-09",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mary"
  },
  {
    "nameId": "Marsha Barnet",
    "gNumber": "H-100068",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-10-14",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Ferguson",
    "gNumber": "H-100469",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-10-14",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Johnson",
    "gNumber": "H-100703",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-11-20",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Dickson",
    "gNumber": "H-100380",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-11-22",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. George"
  },
  {
    "nameId": "Thomas Stewart",
    "gNumber": "H-101340",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-12-01",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ann Horton",
    "gNumber": "H-100663",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-12-08",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth Wood",
    "gNumber": "H-101574",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-12-08",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth Eldredge",
    "gNumber": "H-100439",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-12-16",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Margaret Malin",
    "gNumber": "H-100857",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-12-23",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs (wife) Spear",
    "gNumber": "H-101320",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-12-29",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "George Turner",
    "gNumber": "H-101429",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-08-28",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Capt. Turner"
  },
  {
    "nameId": "Elizabeth Medley",
    "gNumber": "H-100922",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-05-12",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Sarah"
  },
  {
    "nameId": "Mrs Sarah Falconer (Falkner)",
    "gNumber": "H-100466",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 81,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-05-15",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Oakford",
    "gNumber": "H-101024",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 49,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-05-21",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Father of John; John Oakford, son signed"
  },
  {
    "nameId": "Hilda Rambo",
    "gNumber": "H-101125",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1815-08-09",
    "yearOfDeath": 1815,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Huldah"
  },
  {
    "nameId": "William Warner",
    "gNumber": "H-101476",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-01-29",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Deborha Malony",
    "gNumber": "H-100862",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-02-17",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Brittin Sr",
    "gNumber": "H-100173",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 78,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-03-11",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Gaskill",
    "gNumber": "H-100521",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-07-20",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Edmund"
  },
  {
    "nameId": "Martha More",
    "gNumber": "H-100962",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 27,
    "ancestry": "Unknown",
    "dateOfDeath": "1816",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Martha Barnett",
    "gNumber": "H-100069",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1816",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Lugg",
    "gNumber": "H-100848",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-01-02",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Bright"
  },
  {
    "nameId": "(child) Spears",
    "gNumber": "H-101321",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-01-02",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. George"
  },
  {
    "nameId": "(child) McKinley",
    "gNumber": "H-100913",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-01-09",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Nathan"
  },
  {
    "nameId": "(child) Maloney",
    "gNumber": "H-100859",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-01-19",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Joseph"
  },
  {
    "nameId": "(child) Poulson",
    "gNumber": "H-101105",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-01-23",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Eliza"
  },
  {
    "nameId": "(child) Bennet",
    "gNumber": "H-100109",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-05-09",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Henry"
  },
  {
    "nameId": "Benjamin Roberts",
    "gNumber": "H-101175",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-05-10",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Geskill",
    "gNumber": "H-100541",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-07-20",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Edmund"
  },
  {
    "nameId": "(child) Welsh",
    "gNumber": "H-101525",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-08-08",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John"
  },
  {
    "nameId": "Ann Zebly",
    "gNumber": "H-101603",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-08-09",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Bozorsh",
    "gNumber": "H-100143",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-08-17",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. William"
  },
  {
    "nameId": "Capt (man) Alberson",
    "gNumber": "H-100007",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-09-23",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(wife) Reynolds",
    "gNumber": "H-101149",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-10-11",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. capt. Reynolds"
  },
  {
    "nameId": "Marsha Moone",
    "gNumber": "H-100957",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-11-11",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Charles Oakford",
    "gNumber": "H-101025",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 34,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-12-28",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Eliza Eldridge",
    "gNumber": "H-100441",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 19,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-12-16",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ann Lownsbury (Lawnsbury)",
    "gNumber": "H-100843",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 80,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-02-22",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Margaret Evans",
    "gNumber": "H-100453",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 38,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-06-09",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Josiah"
  },
  {
    "nameId": "Hannah Reynolds",
    "gNumber": "H-101148",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 33,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-10-09",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Joseph"
  },
  {
    "nameId": "Catherine Davis",
    "gNumber": "H-100360",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 55,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-08-27",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Samuel Crawford",
    "gNumber": "H-100327",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-01-30",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. William"
  },
  {
    "nameId": "Elizabeth Owen",
    "gNumber": "H-101035",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 55,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-02-22",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rachel Pennock",
    "gNumber": "H-101063",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 29,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-03-27",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Horatio"
  },
  {
    "nameId": "Margaret Evans",
    "gNumber": "H-100452",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "4-8",
    "ageAtDeath": 6,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-05-16",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Joseph Ogden Evans"
  },
  {
    "nameId": "Margaret Sexton",
    "gNumber": "H-101234",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-05-24",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. John"
  },
  {
    "nameId": "Nioma Page",
    "gNumber": "H-101036",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-06-01",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. John"
  },
  {
    "nameId": "Mary Miller",
    "gNumber": "H-100939",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 40,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-06-04",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John P. Bozarth",
    "gNumber": "H-100140",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "1-5",
    "ageAtDeath": 3,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-07-06",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Pennock",
    "gNumber": "H-101064",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "2-6",
    "ageAtDeath": 4,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-07-08",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Horatio"
  },
  {
    "nameId": "Mary Ann Fering",
    "gNumber": "H-100470",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-07-12",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. George"
  },
  {
    "nameId": "(daughter) Naples (Nagle)",
    "gNumber": "H-101003",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-07-28",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Samuel"
  },
  {
    "nameId": "Joseph Moulder",
    "gNumber": "H-100993",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 36,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-08-13",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Butler",
    "gNumber": "H-100210",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 28,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-10-14",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"Jonathan Davis to pay\""
  },
  {
    "nameId": "Mary Kelly",
    "gNumber": "H-100770",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-10-25",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Hugh"
  },
  {
    "nameId": "Hannah Arey",
    "gNumber": "H-100023",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 78,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-10-31",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Samuel George",
    "gNumber": "H-100528",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 24,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-11-12",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Sarah Story",
    "gNumber": "H-101351",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 34,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-12-14",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Charles Simons",
    "gNumber": "H-101281",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "3-7",
    "ageAtDeath": 5,
    "ancestry": "Unknown",
    "dateOfDeath": "1816-12-27",
    "yearOfDeath": 1816,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Widow Simons"
  },
  {
    "nameId": "(daughter) Killam",
    "gNumber": "H-100783",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1817",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Baird"
  },
  {
    "nameId": "William Sailor (Sailer)",
    "gNumber": "H-101215",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "7-11",
    "ageAtDeath": 9,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-03-31",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John"
  },
  {
    "nameId": "John R. Peddle",
    "gNumber": "H-101057",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-05-20",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Barton D. Bozorth",
    "gNumber": "H-100146",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1817",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Andrew McKees",
    "gNumber": "H-100910",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-08-19",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Eliza McKees"
  },
  {
    "nameId": "(child) Hess",
    "gNumber": "H-100638",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1817",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. William Hess Jr"
  },
  {
    "nameId": "(son) Caffries",
    "gNumber": "H-100217",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1817",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "son\u2026"
  },
  {
    "nameId": "Alice Cone",
    "gNumber": "H-100307",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1817",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mathias Cowse",
    "gNumber": "H-100318",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-01-04",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Little",
    "gNumber": "H-100831",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-01-09",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Archibald"
  },
  {
    "nameId": "(child) Wiley",
    "gNumber": "H-101545",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-01-17",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Benjamin"
  },
  {
    "nameId": "(child) Kellum",
    "gNumber": "H-100765",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-03-05",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. B. Kelloins"
  },
  {
    "nameId": "(child) Sailor (Sailer)",
    "gNumber": "H-101216",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-05-05",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John"
  },
  {
    "nameId": "Mary Wright",
    "gNumber": "H-101591",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-05-14",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Morris",
    "gNumber": "H-100974",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-05-20",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Pearson"
  },
  {
    "nameId": "(child) Watts",
    "gNumber": "H-101500",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-07-21",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. James J."
  },
  {
    "nameId": "(child) McKee",
    "gNumber": "H-100909",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-08-20",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. A."
  },
  {
    "nameId": "(child) Warner",
    "gNumber": "H-101477",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-09-28",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John"
  },
  {
    "nameId": "(child) Maddock",
    "gNumber": "H-100851",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-10-24",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. E.E."
  },
  {
    "nameId": "(grandchild) Mitchell",
    "gNumber": "H-100952",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-11-25",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "grandchild Abraham"
  },
  {
    "nameId": "Henry W. Maddock",
    "gNumber": "H-100850",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-02-22",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Ezekiel and Phoebe"
  },
  {
    "nameId": "Mary Philips",
    "gNumber": "H-101085",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 24,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-04-04",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. John"
  },
  {
    "nameId": "Catharine Davis",
    "gNumber": "H-100361",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 46,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-01-30",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Robert Davis Signed"
  },
  {
    "nameId": "Louisa Woodruff",
    "gNumber": "H-101581",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "13-17",
    "ageAtDeath": 15,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-02-08",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. A."
  },
  {
    "nameId": "Mrs Ann(y) Armstrong",
    "gNumber": "H-100024",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 79,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-02-15",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary George",
    "gNumber": "H-100529",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-02-18",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Charles"
  },
  {
    "nameId": "Mary Evans",
    "gNumber": "H-100454",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-04-29",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Thomas"
  },
  {
    "nameId": "Robert Davis",
    "gNumber": "H-100362",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 44,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-04-30",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Lydia Cobb",
    "gNumber": "H-100290",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-05-12",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Joseph and Susan"
  },
  {
    "nameId": "Isaac Jones",
    "gNumber": "H-100727",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "9-13",
    "ageAtDeath": 11,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-06-16",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Isaac R. Jones"
  },
  {
    "nameId": "John Neil",
    "gNumber": "H-101009",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-07-01",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. William"
  },
  {
    "nameId": "George Robbins",
    "gNumber": "H-101170",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-07-11",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. George C."
  },
  {
    "nameId": "(child) Russel",
    "gNumber": "H-101196",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "4-8",
    "ageAtDeath": 6,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-07-14",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Jonathan"
  },
  {
    "nameId": "Jared Sexton",
    "gNumber": "H-101235",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-07-21",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Silas and Harriet"
  },
  {
    "nameId": "John Dewees",
    "gNumber": "H-100376",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "1-5",
    "ageAtDeath": 3,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-09-29",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Samuel"
  },
  {
    "nameId": "Eunice Winter",
    "gNumber": "H-101562",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 21,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-09-29",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. William"
  },
  {
    "nameId": "Jared Sexton",
    "gNumber": "H-101236",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 61,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-10-03",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "George Clark",
    "gNumber": "H-100264",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-10-13",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Henery"
  },
  {
    "nameId": "Nehemiah Maul (Maull)",
    "gNumber": "H-100877",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 44,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-10-23",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Charles Douglas",
    "gNumber": "H-100405",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "5-9",
    "ageAtDeath": 7,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-10-25",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John"
  },
  {
    "nameId": "John Lorrain Jr.",
    "gNumber": "H-100836",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 43,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-11-04",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Jordan",
    "gNumber": "H-100743",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 30,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-11-15",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Robert Carter",
    "gNumber": "H-100236",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 25,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-11-19",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs (wife) Clark",
    "gNumber": "H-100265",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 26,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-12-09",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Clark",
    "gNumber": "H-100266",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-12-11",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Ann Coffin",
    "gNumber": "H-100293",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-12-20",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Jeremiah"
  },
  {
    "nameId": "Ann Britton",
    "gNumber": "H-100178",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 62,
    "ancestry": "Unknown",
    "dateOfDeath": "1817-12-25",
    "yearOfDeath": 1817,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"poor member\"; \"poor member\""
  },
  {
    "nameId": "Juliana Coyle",
    "gNumber": "H-100326",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "13-17",
    "ageAtDeath": 15,
    "ancestry": "Unknown",
    "dateOfDeath": "1818",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "George Wilkie Morris",
    "gNumber": "H-100975",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-05-20",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Pearson and Ann"
  },
  {
    "nameId": "William Harris",
    "gNumber": "H-100608",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 53,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-05-26",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Sarah E. Cave",
    "gNumber": "H-100238",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "2-6",
    "ageAtDeath": 4,
    "ancestry": "Unknown",
    "dateOfDeath": "1818",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Dutton",
    "gNumber": "H-100419",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-01-22",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Joseph"
  },
  {
    "nameId": "Ann Smith",
    "gNumber": "H-101306",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-01-23",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Catherine Allen",
    "gNumber": "H-100009",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-02-01",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Edwards",
    "gNumber": "H-100435",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-06-01",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth Davenport",
    "gNumber": "H-100341",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-06-15",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Ann Calhone",
    "gNumber": "H-100221",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-06-16",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Watts",
    "gNumber": "H-101501",
    "sex": "Unknown",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-07-01",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. James"
  },
  {
    "nameId": "Gabe Barry",
    "gNumber": "H-100073",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-07-11",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Hills",
    "gNumber": "H-100646",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-07-19",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Doctor Hills"
  },
  {
    "nameId": "(child) Lawrence",
    "gNumber": "H-100814",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-09-02",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Lawrence"
  },
  {
    "nameId": "(child) Shaw",
    "gNumber": "H-101247",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-10-29",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Charles"
  },
  {
    "nameId": "(child) Jones",
    "gNumber": "H-100729",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-11-13",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mr."
  },
  {
    "nameId": "Ann Mauelle?",
    "gNumber": "H-100875",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-04-12",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Samuel Sowen",
    "gNumber": "H-101319",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 42,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-03-12",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth (Eliza) Shane (Shain)",
    "gNumber": "H-101244",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 20,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-01-10",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Billings",
    "gNumber": "H-100120",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 44,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-01-13",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Conrad Johnson (Johnston)",
    "gNumber": "H-100708",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 79,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-01-13",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Died in \"Alms house\""
  },
  {
    "nameId": "Mary Young",
    "gNumber": "H-101599",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 50,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-01-15",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Samuel Paine (Payne)",
    "gNumber": "H-101037",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-02-01",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. William Jr."
  },
  {
    "nameId": "Rachel Morgan",
    "gNumber": "H-100967",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 72,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-03-16",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs E. Taylor",
    "gNumber": "H-101374",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 37,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-04-11",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth Crawford",
    "gNumber": "H-100328",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 40,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-04-11",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mr George Evans",
    "gNumber": "H-100455",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 86,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-05-09",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Died in \"Northern Liberties\""
  },
  {
    "nameId": "Jane Reynolds",
    "gNumber": "H-101150",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 46,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-05-11",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rebecca Powell",
    "gNumber": "H-101111",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 20,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-06-30",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Catharine George",
    "gNumber": "H-100530",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-08-03",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. David and Jane"
  },
  {
    "nameId": "Thomas Fowler (Forster)",
    "gNumber": "H-100500",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 55,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-08-05",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rebecca Sailor (Sailer)",
    "gNumber": "H-101217",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-08-10",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. John"
  },
  {
    "nameId": "Ann Maria Stewart",
    "gNumber": "H-101341",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 21,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-11-21",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Robert Adams",
    "gNumber": "H-100003",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 33,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-11-28",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Hildeburn Maddock",
    "gNumber": "H-100852",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-12-23",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Mr. E."
  },
  {
    "nameId": "Mrs (wife) Harris",
    "gNumber": "H-100609",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 53,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-05-27",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "George Estel",
    "gNumber": "H-100451",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "13-17",
    "ageAtDeath": 15,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-07-26",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jean Dobson",
    "gNumber": "H-100389",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 66,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-03-07",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Thomas"
  },
  {
    "nameId": "Mrs Lydia Dunlop",
    "gNumber": "H-100417",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 70,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-12-01",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Joseph Bringhurst",
    "gNumber": "H-100169",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "9-13",
    "ageAtDeath": 11,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-01-21",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. William and Mary"
  },
  {
    "nameId": "Mrs Mary Duncan",
    "gNumber": "H-100413",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 44,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-04-28",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "consort of William Duncan; \"jonathan Duglass paid\""
  },
  {
    "nameId": "John Ashmead",
    "gNumber": "H-100034",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 79,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-06-06",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "h. Mary"
  },
  {
    "nameId": "Edward Britton",
    "gNumber": "H-100179",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 27,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-02-03",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Susan Jones",
    "gNumber": "H-100728",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 19,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-07-08",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "George A. Harvey",
    "gNumber": "H-100612",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1818-07-10",
    "yearOfDeath": 1818,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Gabriel"
  },
  {
    "nameId": "William Fowler",
    "gNumber": "H-100498",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "4-8",
    "ageAtDeath": 6,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-02-10",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Lorrains",
    "gNumber": "H-100837",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1819",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Silvian Coile",
    "gNumber": "H-100297",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-01-08",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Richard Fowler",
    "gNumber": "H-100499",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-02-10",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Clark",
    "gNumber": "H-100267",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-03-02",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mrs."
  },
  {
    "nameId": "John Silaner",
    "gNumber": "H-101271",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-03-30",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Charton E. Maylin",
    "gNumber": "H-100880",
    "sex": "Unknown",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-04-02",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Thomas Story",
    "gNumber": "H-101352",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-04-03",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Allen",
    "gNumber": "H-100010",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-04-15",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Alberto"
  },
  {
    "nameId": "William Johnson",
    "gNumber": "H-100704",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 50,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-07-10",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Bretan",
    "gNumber": "H-100155",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-07-13",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Bretan"
  },
  {
    "nameId": "(child) Naple",
    "gNumber": "H-101001",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-08-02",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Samuel"
  },
  {
    "nameId": "(child) Kimby",
    "gNumber": "H-100786",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-08-18",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Nathan"
  },
  {
    "nameId": "(child) Swoggy",
    "gNumber": "H-101363",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-08-18",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mrs. Sevoggy Swoggy"
  },
  {
    "nameId": "(child) Harvy",
    "gNumber": "H-100613",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-08-27",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Gabriel"
  },
  {
    "nameId": "(child) Thompson",
    "gNumber": "H-101398",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-09-14",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mrs. Thompson"
  },
  {
    "nameId": "Edward Wheeler",
    "gNumber": "H-101530",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-10-20",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Johnson",
    "gNumber": "H-100705",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 48,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-11-20",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Hester Stewart",
    "gNumber": "H-101343",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-12-01",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Thomas",
    "gNumber": "H-101390",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-12-10",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mr. Thomas"
  },
  {
    "nameId": "(child) Coffin",
    "gNumber": "H-100294",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-12-17",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Jeremiah"
  },
  {
    "nameId": "Edward Whitely (Whetly)",
    "gNumber": "H-101538",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "4-8",
    "ageAtDeath": 6,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-06-07",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Edward"
  },
  {
    "nameId": "Mary Bigar",
    "gNumber": "H-100113",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 50,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-04-09",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. John"
  },
  {
    "nameId": "Thomas Shields",
    "gNumber": "H-101266",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 78,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-12-08",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Rebecca Sailor (Sailer)",
    "gNumber": "H-101218",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 34,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-01-05",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Hannah Douglas",
    "gNumber": "H-100406",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-01-09",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John"
  },
  {
    "nameId": "Thomas Hamilton",
    "gNumber": "H-100591",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-01-14",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. William"
  },
  {
    "nameId": "Susannah Beck",
    "gNumber": "H-100093",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-01-25",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Sarah Thomas",
    "gNumber": "H-101389",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 49,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-02-09",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Hannah Miles",
    "gNumber": "H-100931",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 82,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-02-13",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"returned\"; \"returned\""
  },
  {
    "nameId": "Rebecca Stevens",
    "gNumber": "H-101333",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 58,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-05-25",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Richard Yardley",
    "gNumber": "H-101594",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 46,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-07-05",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary George",
    "gNumber": "H-100531",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 21,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-07-26",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elles Topham",
    "gNumber": "H-101410",
    "sex": "Unknown",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-08-14",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Robert Jackson",
    "gNumber": "H-100682",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 21,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-11-20",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Powell",
    "gNumber": "H-101112",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 54,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-11-24",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth Gray",
    "gNumber": "H-100565",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-12-07",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Capt. Richard"
  },
  {
    "nameId": "Mrs Esther Stewart",
    "gNumber": "H-101342",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 22,
    "ancestry": "Unknown",
    "dateOfDeath": "1819-11-30",
    "yearOfDeath": 1819,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. John"
  },
  {
    "nameId": "William Tatem",
    "gNumber": "H-101367",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "3-7",
    "ageAtDeath": 5,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-01-04",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Susan"
  },
  {
    "nameId": "James W. Turner",
    "gNumber": "H-101430",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 35,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-01-14",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth Cowgill",
    "gNumber": "H-100316",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1820",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Arnold Cowgill, signed"
  },
  {
    "nameId": "Henry Whiteman",
    "gNumber": "H-101539",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 49,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-04-07",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Thomas Walborn",
    "gNumber": "H-101450",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 56,
    "ancestry": "Unknown",
    "dateOfDeath": "1820",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Eliza Ann Davis",
    "gNumber": "H-100363",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 21,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-05-17",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Salter Brettin",
    "gNumber": "H-100156",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 37,
    "ancestry": "Unknown",
    "dateOfDeath": "1820",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"British\""
  },
  {
    "nameId": "William Wells",
    "gNumber": "H-101522",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-06-24",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(daughter) Reager",
    "gNumber": "H-101133",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1820",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. James M."
  },
  {
    "nameId": "Elizabeth Weatherby",
    "gNumber": "H-101512",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-07-16",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "James Hall",
    "gNumber": "H-100585",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-07-19",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Henry H. Bozorth",
    "gNumber": "H-100147",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-07-21",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth Benner",
    "gNumber": "H-100101",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-10-13",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rebecca Hugg",
    "gNumber": "H-100670",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "10-14",
    "ageAtDeath": 12,
    "ancestry": "Unknown",
    "dateOfDeath": "1820",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Kitty Roe",
    "gNumber": "H-101178",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 36,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-11-14",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Sarah Maria Thaw",
    "gNumber": "H-101379",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1820",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Charles"
  },
  {
    "nameId": "John Storms",
    "gNumber": "H-101350",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "11-15",
    "ageAtDeath": 13,
    "ancestry": "Unknown",
    "dateOfDeath": "1820",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Susan Satem?",
    "gNumber": "H-101221",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-01-04",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John W. Turner",
    "gNumber": "H-101431",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-01-15",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Weatherby",
    "gNumber": "H-101511",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-01-15",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. D."
  },
  {
    "nameId": "(child) Watson",
    "gNumber": "H-101499",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-02-25",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Thomas"
  },
  {
    "nameId": "Henry Whiteman",
    "gNumber": "H-101540",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-04-08",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Copal",
    "gNumber": "H-100312",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-04-25",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Arnold"
  },
  {
    "nameId": "(child) Hill",
    "gNumber": "H-100644",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-06-09",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Dr. Hills"
  },
  {
    "nameId": "(child) Wells",
    "gNumber": "H-101523",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-06-24",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Wm. H."
  },
  {
    "nameId": "(child) Wells",
    "gNumber": "H-101524",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-06-24",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Wm. H."
  },
  {
    "nameId": "(child) Weatherby",
    "gNumber": "H-101513",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-07-18",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. David"
  },
  {
    "nameId": "(child) Watts",
    "gNumber": "H-101502",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-07-20",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch."
  },
  {
    "nameId": "(child) Bozarsh",
    "gNumber": "H-100135",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-07-22",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. William"
  },
  {
    "nameId": "(child) McKeage",
    "gNumber": "H-100908",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-08-02",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. James"
  },
  {
    "nameId": "Joseph McLeod",
    "gNumber": "H-100917",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-08-17",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Pearney",
    "gNumber": "H-101051",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-10-13",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Henry"
  },
  {
    "nameId": "Catharine Rue",
    "gNumber": "H-101191",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-11-15",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(girl) Sexton",
    "gNumber": "H-101237",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-12-01",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"Benjamin Sexton's girl\""
  },
  {
    "nameId": "Ann Thomas",
    "gNumber": "H-101392",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-12-15",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Shaw",
    "gNumber": "H-101248",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-12-25",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Charles"
  },
  {
    "nameId": "Sarah Thomas",
    "gNumber": "H-101391",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 52,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-02-07",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Bigar",
    "gNumber": "H-100114",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 59,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-08-09",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Capt James Josiah",
    "gNumber": "H-100745",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 69,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-09-18",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "h. Elizabeth; \"an exemplery citizen, a firm, patient and christian believer But the fond hopes imnspired by pious love draws back the veil when spirits meet above\"; officer in early US Navy"
  },
  {
    "nameId": "Barnaby (Barney) Barnes",
    "gNumber": "H-100066",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 29,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-05-27",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Begar (Bigar)",
    "gNumber": "H-100098",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 69,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-08-29",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ann Cornelius (Coeniling)",
    "gNumber": "H-100315",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 28,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-07-18",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Anna Stokes",
    "gNumber": "H-101347",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 29,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-02-15",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Ethan"
  },
  {
    "nameId": "Thomas Walbram",
    "gNumber": "H-101451",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 33,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-05-15",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(daughter) Russel",
    "gNumber": "H-101197",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-01-31",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Mr. Russel"
  },
  {
    "nameId": "John Storm",
    "gNumber": "H-101349",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "2-6",
    "ageAtDeath": 4,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-02-12",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. John"
  },
  {
    "nameId": "William Frost",
    "gNumber": "H-100507",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-02-18",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Thomas"
  },
  {
    "nameId": "Mrs Jane George",
    "gNumber": "H-100532",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 44,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-04-08",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Anna Stokes",
    "gNumber": "H-101348",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-04-09",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Charles"
  },
  {
    "nameId": "Marsha (Martha) Leman (Lemon)",
    "gNumber": "H-100823",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 20,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-04-19",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ann Peters",
    "gNumber": "H-101081",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 31,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-04-19",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William V. McMinn",
    "gNumber": "H-100918",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "1-5",
    "ageAtDeath": 3,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-04-24",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. William"
  },
  {
    "nameId": "Mary Ann Gray",
    "gNumber": "H-100566",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "4-8",
    "ageAtDeath": 6,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-05-06",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Capt. Richard"
  },
  {
    "nameId": "Samuel Buckley",
    "gNumber": "H-100193",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 23,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-05-22",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rebecca Evans",
    "gNumber": "H-100456",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-06-06",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Joseph Ogden Evans"
  },
  {
    "nameId": "Hester Collins",
    "gNumber": "H-100305",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-06-24",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth Fletcher",
    "gNumber": "H-100484",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 73,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-07-12",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Eliza"
  },
  {
    "nameId": "Enoch Land",
    "gNumber": "H-100811",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-07-21",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Enoch"
  },
  {
    "nameId": "Henry Fisk (Fiss)",
    "gNumber": "H-100478",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 20,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-08-09",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs (wife) Ramage",
    "gNumber": "H-101121",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 78,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-08-19",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Josiah Clark Jr.",
    "gNumber": "H-100268",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-08-25",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Mrs."
  },
  {
    "nameId": "Morgan Davis",
    "gNumber": "H-100364",
    "sex": "Unknown",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 26,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-10-16",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Naples (Nagel)",
    "gNumber": "H-101002",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-11-15",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. William"
  },
  {
    "nameId": "(daughter) Jones",
    "gNumber": "H-100731",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-11-22",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Jacob and Ms. Jones"
  },
  {
    "nameId": "(son) McKey",
    "gNumber": "H-100911",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-12-25",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Andrew"
  },
  {
    "nameId": "(wife) McKey",
    "gNumber": "H-100912",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 27,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-12-25",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Andrew"
  },
  {
    "nameId": "Capt Lloyd Jones",
    "gNumber": "H-100730",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 62,
    "ancestry": "Unknown",
    "dateOfDeath": "1820-05-26",
    "yearOfDeath": 1820,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "h. Eliza (Loxley) the d. Benjamin"
  },
  {
    "nameId": "Catherine Clarke",
    "gNumber": "H-100278",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 27,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-01-07",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Catherine Loxley",
    "gNumber": "H-100846",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 83,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-01-19",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Clark Perpignan",
    "gNumber": "H-101078",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "3-7",
    "ageAtDeath": 5,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-04-19",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Benjamin Thaw",
    "gNumber": "H-101380",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1821",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Charles and Elizabeth"
  },
  {
    "nameId": "Benjamin Wood",
    "gNumber": "H-101575",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "8-12",
    "ageAtDeath": 10,
    "ancestry": "Unknown",
    "dateOfDeath": "1821",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Albert Watkins",
    "gNumber": "H-101493",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-07-03",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Amanda Homes",
    "gNumber": "H-100659",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-08-02",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Isaac Friend Jr",
    "gNumber": "H-100505",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-09-11",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Hess",
    "gNumber": "H-100639",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1821",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(daughter) Miller",
    "gNumber": "H-100942",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1821",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. William and Rachel"
  },
  {
    "nameId": "Mary Miles",
    "gNumber": "H-100932",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 47,
    "ancestry": "Unknown",
    "dateOfDeath": "1821",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w.Stuart"
  },
  {
    "nameId": "(child) Clark",
    "gNumber": "H-100269",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-04-21",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. George"
  },
  {
    "nameId": "Bright Hug",
    "gNumber": "H-100669",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-04-24",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Joseph Keen",
    "gNumber": "H-100754",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-05-12",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rebecca Wilson",
    "gNumber": "H-101560",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-06-15",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Ogleby (Ogilsly)",
    "gNumber": "H-101031",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 39,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-07-15",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"pew holder\""
  },
  {
    "nameId": "(child) Shaw",
    "gNumber": "H-101249",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-07-24",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Charles"
  },
  {
    "nameId": "(child) Woods",
    "gNumber": "H-101584",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-07-31",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. James G."
  },
  {
    "nameId": "(grandchild) Bozarsh",
    "gNumber": "H-100137",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-08-02",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "grandchild William"
  },
  {
    "nameId": "Mary L. Whelen",
    "gNumber": "H-101531",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-08-21",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "L.F. Keech",
    "gNumber": "H-100751",
    "sex": "Unknown",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-08-23",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Allison",
    "gNumber": "H-100011",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-09-12",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mary"
  },
  {
    "nameId": "(child) Mitchel",
    "gNumber": "H-100949",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-10-20",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Abraham"
  },
  {
    "nameId": "Father Walter S. Burnwood",
    "gNumber": "H-100202",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 79,
    "ancestry": "Unknown",
    "dateOfDeath": "1821",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Cox",
    "gNumber": "H-100322",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 49,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-03-27",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. John T."
  },
  {
    "nameId": "George Kelsh (Ketch, Kelch)",
    "gNumber": "H-100775",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 48,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-01-13",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Kezia Sweetman",
    "gNumber": "H-101361",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 66,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-03-12",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Stewart Thompson Kelsh",
    "gNumber": "H-100774",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "7-11",
    "ageAtDeath": 9,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-08-21",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Angelina Little",
    "gNumber": "H-100832",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-01-06",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Charles"
  },
  {
    "nameId": "Josiah Thompson",
    "gNumber": "H-101399",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "6-10",
    "ageAtDeath": 8,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-01-17",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Benjmain"
  },
  {
    "nameId": "Louisa Maria Naples (Nagle)",
    "gNumber": "H-101004",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-02-26",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. William"
  },
  {
    "nameId": "Carter Harvy",
    "gNumber": "H-100614",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-03-12",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. G."
  },
  {
    "nameId": "Archibald Little",
    "gNumber": "H-100833",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 44,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-03-29",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Mary Leonard (Lennard)",
    "gNumber": "H-100826",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 33,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-06-13",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Basset Baker",
    "gNumber": "H-100051",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 58,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-06-20",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Alice Bozorth",
    "gNumber": "H-100148",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 36,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-06-21",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "(poss w. William)"
  },
  {
    "nameId": "(son) Kelly",
    "gNumber": "H-100771",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-07-02",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Daniel R. and Rebecca"
  },
  {
    "nameId": "Mrs Mary Stewart",
    "gNumber": "H-101344",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 47,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-07-03",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rebecca Bozarsh",
    "gNumber": "H-100136",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "7-11",
    "ageAtDeath": 9,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-07-17",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Phillips",
    "gNumber": "H-101086",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "3-7",
    "ageAtDeath": 5,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-08-08",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Jonathan"
  },
  {
    "nameId": "William Dutton",
    "gNumber": "H-100420",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "7-11",
    "ageAtDeath": 9,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-08-13",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth (Eliza) Simmons",
    "gNumber": "H-101276",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 39,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-08-13",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "James Eldredge",
    "gNumber": "H-100440",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "2-6",
    "ageAtDeath": 4,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-08-31",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Jos."
  },
  {
    "nameId": "Alfred Miller",
    "gNumber": "H-100940",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "1-5",
    "ageAtDeath": 3,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-09-14",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. William T."
  },
  {
    "nameId": "Mariah Miller",
    "gNumber": "H-100941",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-09-22",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. William P."
  },
  {
    "nameId": "(child) Smith",
    "gNumber": "H-101307",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-10-04",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Francis"
  },
  {
    "nameId": "Mrs Mary Johnson (Johnston)",
    "gNumber": "H-100709",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 54,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-10-09",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "George Firing",
    "gNumber": "H-100477",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 27,
    "ancestry": "Unknown",
    "dateOfDeath": "1821-11-22",
    "yearOfDeath": 1821,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Hugg",
    "gNumber": "H-100671",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "4-8",
    "ageAtDeath": 6,
    "ancestry": "Unknown",
    "dateOfDeath": "1822",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Leonard Stager",
    "gNumber": "H-101322",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 64,
    "ancestry": "Unknown",
    "dateOfDeath": "1822",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ann Byefield",
    "gNumber": "H-100215",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 62,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-01-09",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Hopper",
    "gNumber": "H-100661",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 24,
    "ancestry": "Unknown",
    "dateOfDeath": "1822",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Penting",
    "gNumber": "H-101068",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 60,
    "ancestry": "Unknown",
    "dateOfDeath": "1822",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Peggy Brown",
    "gNumber": "H-100186",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 78,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-12-22",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elisabeth Josiah",
    "gNumber": "H-100746",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 82,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-12-20",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jane Kelsey",
    "gNumber": "H-100773",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1822",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ann Kepsin",
    "gNumber": "H-100780",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1822",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(wife) Sexton",
    "gNumber": "H-101238",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-01-21",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. John"
  },
  {
    "nameId": "Olivia Claghorn",
    "gNumber": "H-100262",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-01-22",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. John W. and Elizabeth"
  },
  {
    "nameId": "(child) Dobson",
    "gNumber": "H-100390",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-02-27",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Robt."
  },
  {
    "nameId": "(child) Hall",
    "gNumber": "H-100586",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-03-06",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. James"
  },
  {
    "nameId": "George Campbell",
    "gNumber": "H-100227",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-03-30",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Burtis",
    "gNumber": "H-100208",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-05-15",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. J."
  },
  {
    "nameId": "William L. Burtis",
    "gNumber": "H-100209",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-05-15",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs (wife) Maul",
    "gNumber": "H-100876",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-05-24",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Samuel P. Oglebe",
    "gNumber": "H-101030",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-05-24",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary B. Johns",
    "gNumber": "H-100699",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-06-05",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rebecca Parker",
    "gNumber": "H-101041",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-06-05",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Thompson",
    "gNumber": "H-101400",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-06-07",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Benjamin"
  },
  {
    "nameId": "(child) Russel",
    "gNumber": "H-101198",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-06-12",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Susan Hensey",
    "gNumber": "H-100632",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-06-21",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jane Jackson",
    "gNumber": "H-100683",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-07-03",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Walters",
    "gNumber": "H-101469",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-07-18",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Jos. L."
  },
  {
    "nameId": "(child) Irvin",
    "gNumber": "H-100680",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-07-26",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Arnie"
  },
  {
    "nameId": "Mary Clark",
    "gNumber": "H-100270",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-08-12",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Margaret Thompson",
    "gNumber": "H-101401",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-09-13",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Vogel",
    "gNumber": "H-101448",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-09-19",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Joseph"
  },
  {
    "nameId": "Mary Penson",
    "gNumber": "H-101067",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-11-16",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Margaret Brown",
    "gNumber": "H-100185",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-12-04",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Isabella Dilworth",
    "gNumber": "H-100381",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 81,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-05-05",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Susanna Hinsey",
    "gNumber": "H-100648",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 25,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-06-19",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. John and Margaret (of the State of Delaware)"
  },
  {
    "nameId": "George Ingels Walter",
    "gNumber": "H-101468",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-07-01",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Miss Tabitha Green",
    "gNumber": "H-100568",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 26,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-02-06",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Timothy Thomas",
    "gNumber": "H-101393",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 60,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-06-19",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "consort Sarah"
  },
  {
    "nameId": "Leonard Sayre",
    "gNumber": "H-101224",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 39,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-01-10",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Thomas Fitzgerald",
    "gNumber": "H-100480",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 73,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-12-31",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "H. Catharine; \"LATER NOTE: 1823.04.12: \"for erecting a tombstone over the remains of Thomas Fitzgerald\"\"Reinterred in Sa Laurel Hill Cem, Phila. In Dale family plot see tombstone there\""
  },
  {
    "nameId": "Rebbecca Sharp",
    "gNumber": "H-101245",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 55,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-05-13",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "consort of Thomas Sharp"
  },
  {
    "nameId": "Rachel Miller",
    "gNumber": "H-100943",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 32,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-01-01",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. William P."
  },
  {
    "nameId": "Amy Irrmin (Ivins)",
    "gNumber": "H-100679",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 21,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-01-21",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Amey"
  },
  {
    "nameId": "John Alexander",
    "gNumber": "H-100008",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 54,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-07-09",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Martha A. Dewees",
    "gNumber": "H-100377",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-07-14",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Hannah Brades",
    "gNumber": "H-100149",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "6-10",
    "ageAtDeath": 8,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-09-02",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Peter"
  },
  {
    "nameId": "Hettie (Hester) Hess",
    "gNumber": "H-100640",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 45,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-09-09",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Louisa M. Davenport",
    "gNumber": "H-100342",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "2-6",
    "ageAtDeath": 4,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-09-24",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Silence",
    "gNumber": "H-101272",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 45,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-10-23",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Hannah M. Hess",
    "gNumber": "H-100641",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-10-28",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. John"
  },
  {
    "nameId": "Mary Jennings",
    "gNumber": "H-100692",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 22,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-10-28",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mariah Oakford",
    "gNumber": "H-101026",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "13-17",
    "ageAtDeath": 15,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-11-06",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Mrs. Hannah"
  },
  {
    "nameId": "Ann Bicking",
    "gNumber": "H-100111",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 25,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-11-30",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jacob Jones",
    "gNumber": "H-100732",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 28,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-12-04",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rachel Potterfield (Porter)",
    "gNumber": "H-101099",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 58,
    "ancestry": "Unknown",
    "dateOfDeath": "1822-12-27",
    "yearOfDeath": 1822,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ann Dugle",
    "gNumber": "H-100411",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 50,
    "ancestry": "Unknown",
    "dateOfDeath": "1823",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Dobson",
    "gNumber": "H-100391",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-02-20",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Robert; Hannah Dobson signed"
  },
  {
    "nameId": "Catherine Miles",
    "gNumber": "H-100933",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 31,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-04-11",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Holmes",
    "gNumber": "H-100658",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-05-05",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mary"
  },
  {
    "nameId": "Isabella Beek",
    "gNumber": "H-100097",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "1-5",
    "ageAtDeath": 3,
    "ancestry": "Unknown",
    "dateOfDeath": "1823",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(daughter) Russel",
    "gNumber": "H-101199",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "1-5",
    "ageAtDeath": 3,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-07-29",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Samuel"
  },
  {
    "nameId": "Ann Brashfield",
    "gNumber": "H-100154",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-01-09",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Hugg",
    "gNumber": "H-100672",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-01-18",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mrs."
  },
  {
    "nameId": "Ann McDougle",
    "gNumber": "H-100898",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-02-01",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Joseph Rogers",
    "gNumber": "H-101183",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-07-26",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Russel",
    "gNumber": "H-101200",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-07-30",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Jonathan"
  },
  {
    "nameId": "(child2) Ustick",
    "gNumber": "H-101437",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-08-28",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Jonathan"
  },
  {
    "nameId": "Hannah Sexton",
    "gNumber": "H-101239",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-09-08",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Thomas",
    "gNumber": "H-101394",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-10-24",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Enoch"
  },
  {
    "nameId": "Ann Neil",
    "gNumber": "H-101010",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-11-01",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Evins",
    "gNumber": "H-100464",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-11-07",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Joseph C."
  },
  {
    "nameId": "(child) Helmbold",
    "gNumber": "H-100631",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-11-17",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Jos."
  },
  {
    "nameId": "(child) Boyd",
    "gNumber": "H-100130",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-12-03",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Jonothan"
  },
  {
    "nameId": "Mrs (wife) Johnson",
    "gNumber": "H-100706",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 45,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-07-30",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"formerly Walker\""
  },
  {
    "nameId": "Samuel Barclay",
    "gNumber": "H-100060",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 63,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-08-28",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Sarah Ogden",
    "gNumber": "H-101028",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 49,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-05-29",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary B. Reynolds",
    "gNumber": "H-101151",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-06-22",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"Reynolds child\""
  },
  {
    "nameId": "Samuel Oakford",
    "gNumber": "H-101027",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 90,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-10-21",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Thomas Dobson",
    "gNumber": "H-100392",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 73,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-03-09",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "h. Jean"
  },
  {
    "nameId": "Susannah Downing",
    "gNumber": "H-100407",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 46,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-03-12",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Caldwell C. O'Neill",
    "gNumber": "H-101019",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-03-26",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. George"
  },
  {
    "nameId": "Edwin Chadwick",
    "gNumber": "H-100245",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-03-27",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Thomas"
  },
  {
    "nameId": "Mary Clements",
    "gNumber": "H-100288",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 55,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-04-28",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Jemima Daisy",
    "gNumber": "H-100335",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 73,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-04-29",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Harriett Beck",
    "gNumber": "H-100094",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-06-25",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Martin"
  },
  {
    "nameId": "(daughter) McGraw",
    "gNumber": "H-100903",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-07-15",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Mr."
  },
  {
    "nameId": "Sarah Harvy",
    "gNumber": "H-100615",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-07-19",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Gabriel; Gabriel Harvey signed"
  },
  {
    "nameId": "Daphna (Daphne) Peterson",
    "gNumber": "H-101083",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 94,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-07-21",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Charles Monroe Bozarsh",
    "gNumber": "H-100138",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-08-12",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. William"
  },
  {
    "nameId": "Margaret Young",
    "gNumber": "H-101600",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 25,
    "ancestry": "Unknown",
    "dateOfDeath": "1823-08-12",
    "yearOfDeath": 1823,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth Vanosten (Vanaustin)",
    "gNumber": "H-101445",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "1-5",
    "ageAtDeath": 3,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-02-24",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Kunzi",
    "gNumber": "H-100801",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 24,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-03-19",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Charles Jewell",
    "gNumber": "H-100694",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 22,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-04-27",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Catherine Saxon",
    "gNumber": "H-101223",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "3-7",
    "ageAtDeath": 5,
    "ancestry": "Unknown",
    "dateOfDeath": "1824",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Alse WIlliam",
    "gNumber": "H-101552",
    "sex": "Unknown",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 50,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-09-22",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Watkins",
    "gNumber": "H-101494",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1824",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "child of Samuel Watkin"
  },
  {
    "nameId": "Lea Marcia Clark",
    "gNumber": "H-100272",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "8-12",
    "ageAtDeath": 10,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-10-04",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Susanna Dobson",
    "gNumber": "H-100393",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-10-29",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Samuel H. H. Jones",
    "gNumber": "H-100733",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "4-8",
    "ageAtDeath": 6,
    "ancestry": "Unknown",
    "dateOfDeath": "1824",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) White",
    "gNumber": "H-101535",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-01-05",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Samuel"
  },
  {
    "nameId": "??? Walker",
    "gNumber": "H-101461",
    "sex": "Unknown",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-01-13",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Vanestery",
    "gNumber": "H-101442",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-02-24",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. William"
  },
  {
    "nameId": "Elizabeth Clark",
    "gNumber": "H-100271",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-03-01",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Evans",
    "gNumber": "H-100457",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-03-11",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Thomas"
  },
  {
    "nameId": "Mary Keenzi?",
    "gNumber": "H-100764",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-03-19",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Sisty",
    "gNumber": "H-101291",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 72,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-04-12",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Nathaniel Parker",
    "gNumber": "H-101042",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-05-01",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Arrison?",
    "gNumber": "H-100026",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-07-10",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John"
  },
  {
    "nameId": "Charles W. Willis",
    "gNumber": "H-101558",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-07-24",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Evans",
    "gNumber": "H-100458",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-08-16",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Joseph O."
  },
  {
    "nameId": "James Perine",
    "gNumber": "H-101075",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-08-21",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"this order was returned, Samuel W. Keen\""
  },
  {
    "nameId": "(child) Charles",
    "gNumber": "H-100252",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-10-04",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. James"
  },
  {
    "nameId": "(child) Davis",
    "gNumber": "H-100365",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-10-16",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Jonathan"
  },
  {
    "nameId": "Robert Dobson",
    "gNumber": "H-100394",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-10-30",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Boyd",
    "gNumber": "H-100131",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-11-09",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. William"
  },
  {
    "nameId": "Rev Henry Holcombe D.D.",
    "gNumber": "H-100652",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 62,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-05-22",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Pastor"
  },
  {
    "nameId": "Samuel Clarke",
    "gNumber": "H-100279",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 66,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-10-16",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Catherine Burkloe (Berkellow)",
    "gNumber": "H-100201",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 79,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-06-04",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Henry H. Nagle (Naples)",
    "gNumber": "H-100999",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-06-11",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Samuel R."
  },
  {
    "nameId": "Joseph Rhodes (Rhoads)",
    "gNumber": "H-101162",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 24,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-03-08",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Malachi Beagle",
    "gNumber": "H-100082",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "2-6",
    "ageAtDeath": 4,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-04-03",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s.Henry"
  },
  {
    "nameId": "Charles Sewell",
    "gNumber": "H-101231",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 22,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-04-27",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Kenneth"
  },
  {
    "nameId": "Rev William Rogers D.D.",
    "gNumber": "H-101184",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 73,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-04-09",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Francis Snyder",
    "gNumber": "H-101318",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 57,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-01-07",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Marcus Smith",
    "gNumber": "H-101308",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 20,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-02-09",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Matthew Cavin",
    "gNumber": "H-100244",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-03-09",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Robert"
  },
  {
    "nameId": "Christianna Tally",
    "gNumber": "H-101364",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 75,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-03-22",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Joseph Figner",
    "gNumber": "H-100473",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "3-7",
    "ageAtDeath": 5,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-04-19",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Andrew"
  },
  {
    "nameId": "William Oliver (Olive)",
    "gNumber": "H-101032",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-04-19",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. James"
  },
  {
    "nameId": "Ann E. Jones",
    "gNumber": "H-100734",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "4-8",
    "ageAtDeath": 6,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-05-04",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Samuel"
  },
  {
    "nameId": "Catherine Harvard",
    "gNumber": "H-100611",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 87,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-05-30",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Died at \"House of Wiliam Davenport,\" William Davenport, signed"
  },
  {
    "nameId": "(son) George",
    "gNumber": "H-100533",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-06-15",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Charles"
  },
  {
    "nameId": "John Baldwin",
    "gNumber": "H-100053",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-07-01",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mr."
  },
  {
    "nameId": "Mrs Ann Shelmerden (Shelmerdine)",
    "gNumber": "H-101252",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 59,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-07-16",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "C. Shelmerdine, signed"
  },
  {
    "nameId": "Charles Holcombe Myers",
    "gNumber": "H-100998",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-07-28",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Henry"
  },
  {
    "nameId": "Peter Harvy Jr",
    "gNumber": "H-100616",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 21,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-08-30",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Merebah Kille (Kelle)",
    "gNumber": "H-100785",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 79,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-09-20",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Amanda Bozarsh",
    "gNumber": "H-100139",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-10-04",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. William"
  },
  {
    "nameId": "Mrs Mary Bashford",
    "gNumber": "H-100074",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 58,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-10-09",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jonathan J. Fleming",
    "gNumber": "H-100483",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 30,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-10-16",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Wiliam T. Thomas",
    "gNumber": "H-101395",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 31,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-11-02",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "of Baltimore"
  },
  {
    "nameId": "Mary Ann Davison",
    "gNumber": "H-100369",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1824-12-18",
    "yearOfDeath": 1824,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Sarah Ann Wiley",
    "gNumber": "H-101546",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "2-6",
    "ageAtDeath": 4,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-04-29",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller, signed inter. cert."
  },
  {
    "nameId": "Mary Kunzi",
    "gNumber": "H-100802",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "1-5",
    "ageAtDeath": 3,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-04-28",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller signed inter cert"
  },
  {
    "nameId": "Ann Regin",
    "gNumber": "H-101145",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 32,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-05-07",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller, agd. Int cer."
  },
  {
    "nameId": "George Campbell",
    "gNumber": "H-100228",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 21,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-06-25",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller, signed inter. cer."
  },
  {
    "nameId": "Joseph Rogers",
    "gNumber": "H-101185",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "14-18",
    "ageAtDeath": 16,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-07-25",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ann Cole",
    "gNumber": "H-100302",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-08-20",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Eliza Thaw",
    "gNumber": "H-101381",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 35,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-11-01",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller, signed int cert."
  },
  {
    "nameId": "Elizabeth Hellings",
    "gNumber": "H-100626",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "12-16",
    "ageAtDeath": 14,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-11-19",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Margaret McCormick",
    "gNumber": "H-100893",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 72,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-11-26",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller signed inter cert"
  },
  {
    "nameId": "Elizabeth D. Claghorn",
    "gNumber": "H-100263",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-12-04",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. John W. and Elizabeth"
  },
  {
    "nameId": "Alfred Watkins",
    "gNumber": "H-101495",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-12-07",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Benjamin Molineux",
    "gNumber": "H-100955",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 36,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-08-24",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jonathan White",
    "gNumber": "H-101536",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 54,
    "ancestry": "Unknown",
    "dateOfDeath": "1825",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William C Thomas",
    "gNumber": "H-101396",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-03-25",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William E. Thompson",
    "gNumber": "H-101402",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-03-25",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jeremiah Hacker",
    "gNumber": "H-100583",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-03-30",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Joseph C. Wood",
    "gNumber": "H-101576",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-03-31",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Levi Bates",
    "gNumber": "H-100077",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-04-11",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Kingey?",
    "gNumber": "H-100789",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-04-30",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Willey",
    "gNumber": "H-101551",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-04-30",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Ann Butler",
    "gNumber": "H-100211",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 40,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-10-01",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Joseph"
  },
  {
    "nameId": "Sarah Wiley",
    "gNumber": "H-101547",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 53,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-05-12",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller, signed inter. cert."
  },
  {
    "nameId": "Elisa Combes",
    "gNumber": "H-100306",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 51,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-04-30",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. John R.; grocer, Jesse Miller signed cert."
  },
  {
    "nameId": "Abigail Beasley",
    "gNumber": "H-100086",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 82,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-07-22",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "wid. Stephen"
  },
  {
    "nameId": "Capt Simon (or Stephen) Kingston",
    "gNumber": "H-100791",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 73,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-07-22",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "h. Sarah"
  },
  {
    "nameId": "Mistress Elisa (Lise, Eliza) Lassalle (Laselle)",
    "gNumber": "H-100812",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 48,
    "ancestry": "Unknown",
    "dateOfDeath": "1825-12-09",
    "yearOfDeath": 1825,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "J. Miller Signed int cert"
  },
  {
    "nameId": "Mary Edwards",
    "gNumber": "H-100436",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 24,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-01-09",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Thomas; J. Miller Signed int cert"
  },
  {
    "nameId": "E Canor Bigelow",
    "gNumber": "H-100116",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 88,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-01-30",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth Vogels",
    "gNumber": "H-101449",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 58,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-02-24",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller, Sgnd. Int. Cer."
  },
  {
    "nameId": "Rebecca Fleeson",
    "gNumber": "H-100482",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 72,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-03-14",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "J. Miller Signed int cert"
  },
  {
    "nameId": "Hannah Rush",
    "gNumber": "H-101195",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 71,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-03-19",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"Jesse Miller sgd. Int. Cer. Name spelled Hanah on Dr's slip\""
  },
  {
    "nameId": "Ann Tatem",
    "gNumber": "H-101368",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 18,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-03-23",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller, agd. Int cer."
  },
  {
    "nameId": "Rebecca Kelly",
    "gNumber": "H-100772",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 33,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-03-29",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Daniel R."
  },
  {
    "nameId": "Groome Airy",
    "gNumber": "H-100004",
    "sex": "Unknown",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 37,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-04-27",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Mary Keen",
    "gNumber": "H-100755",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 38,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-05-28",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Henry (Henery) Whiteman",
    "gNumber": "H-101541",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-07-02",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Inter. cert signed by Jesse Miller"
  },
  {
    "nameId": "G. W. Samuel Sexton",
    "gNumber": "H-101240",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-07-17",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller"
  },
  {
    "nameId": "David Lee",
    "gNumber": "H-100820",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-07-23",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "J. Miller Signed int cert"
  },
  {
    "nameId": "Hannah Wray",
    "gNumber": "H-101588",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-07-28",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller"
  },
  {
    "nameId": "(son) Boarth",
    "gNumber": "H-100125",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-07-29",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. William"
  },
  {
    "nameId": "John Palmer (Parmer)",
    "gNumber": "H-101038",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 27,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-08-06",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller"
  },
  {
    "nameId": "Amanda Chandler",
    "gNumber": "H-100248",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-08-09",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Venus York",
    "gNumber": "H-101597",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 95,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-08-14",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Resident of Penn Township; Jesse Miller"
  },
  {
    "nameId": "Robert M. Ford",
    "gNumber": "H-100492",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 29,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-08-26",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller, Sexton"
  },
  {
    "nameId": "(son) Evans",
    "gNumber": "H-100459",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-09-01",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Thomas"
  },
  {
    "nameId": "Martha Jewell",
    "gNumber": "H-100695",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 56,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-09-06",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "James Smith",
    "gNumber": "H-101309",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 29,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-09-10",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Jennings",
    "gNumber": "H-100693",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 28,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-10-02",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jonathan Miller (Milnor)",
    "gNumber": "H-100946",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "14-18",
    "ageAtDeath": 16,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-10-22",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Interment slip gives the name as Jonathan Miller"
  },
  {
    "nameId": "Henry George",
    "gNumber": "H-100534",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "12-16",
    "ageAtDeath": 14,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-11-13",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth Perine",
    "gNumber": "H-101076",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 55,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-11-14",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "J. Miller Signed int cert"
  },
  {
    "nameId": "Joseph Marsh",
    "gNumber": "H-100867",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 90,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-12-06",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller signed inter cert"
  },
  {
    "nameId": "Rebecca S. Wofle",
    "gNumber": "H-101565",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 36,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-12-15",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller, signed int cert."
  },
  {
    "nameId": "Joseph Murphy",
    "gNumber": "H-100997",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 27,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-12-17",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller, Sexton"
  },
  {
    "nameId": "Isaac Trieman",
    "gNumber": "H-101420",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 53,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-12-26",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller, Sexton"
  },
  {
    "nameId": "Mary Bringhurst",
    "gNumber": "H-100170",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 76,
    "ancestry": "Unknown",
    "dateOfDeath": "1826",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "of William"
  },
  {
    "nameId": "Evonne Oney?",
    "gNumber": "H-101033",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 67,
    "ancestry": "Unknown",
    "dateOfDeath": "1826",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Martha Sewell",
    "gNumber": "H-101232",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 55,
    "ancestry": "Unknown",
    "dateOfDeath": "1826",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Kenneth"
  },
  {
    "nameId": "Robert R. Cave",
    "gNumber": "H-100239",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1826",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Benjamin Thaw",
    "gNumber": "H-101382",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 73,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-03-05",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller, signed int cert."
  },
  {
    "nameId": "Joseph Wood",
    "gNumber": "H-101577",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-07-26",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller"
  },
  {
    "nameId": "John Harper",
    "gNumber": "H-100606",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 42,
    "ancestry": "Unknown",
    "dateOfDeath": "1826-08-17",
    "yearOfDeath": 1826,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"the above had died in Southwark,\" Jesse Miller, Sexton"
  },
  {
    "nameId": "Corinda Charles",
    "gNumber": "H-100253",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "12-16",
    "ageAtDeath": 14,
    "ancestry": "Unknown",
    "dateOfDeath": "1827-12-30",
    "yearOfDeath": 1827,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller, signed inter. cer."
  },
  {
    "nameId": "Thomas Morgan",
    "gNumber": "H-100968",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1827",
    "yearOfDeath": 1827,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "George Ingles",
    "gNumber": "H-100678",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1827",
    "yearOfDeath": 1827,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ann Bigar",
    "gNumber": "H-100115",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 45,
    "ancestry": "Unknown",
    "dateOfDeath": "1827",
    "yearOfDeath": 1827,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Martha Garrawith?",
    "gNumber": "H-100517",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 36,
    "ancestry": "Unknown",
    "dateOfDeath": "1827",
    "yearOfDeath": 1827,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elisabeth Sines",
    "gNumber": "H-101289",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 72,
    "ancestry": "Unknown",
    "dateOfDeath": "1827",
    "yearOfDeath": 1827,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Abraham Mitchell",
    "gNumber": "H-100953",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 84,
    "ancestry": "Unknown",
    "dateOfDeath": "1827-04-23",
    "yearOfDeath": 1827,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Henry McClaphan?",
    "gNumber": "H-100886",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1827-03-31",
    "yearOfDeath": 1827,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. John McClaghorn"
  },
  {
    "nameId": "Charles Theodore Aken",
    "gNumber": "H-100005",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1827-04-05",
    "yearOfDeath": 1827,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Sarah Kingston",
    "gNumber": "H-100792",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 56,
    "ancestry": "Unknown",
    "dateOfDeath": "1827-04-09",
    "yearOfDeath": 1827,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "wid. Capt. Simon"
  },
  {
    "nameId": "Ann Rhees",
    "gNumber": "H-101154",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-01-01",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "J. Miller Signed int cert"
  },
  {
    "nameId": "Martha Phillips",
    "gNumber": "H-101088",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 28,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-01-16",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "j. Miller Signed int cert"
  },
  {
    "nameId": "Emma Sanderson",
    "gNumber": "H-101220",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 22,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-01-26",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Wiley",
    "gNumber": "H-101548",
    "sex": "Unknown",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 32,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-01-26",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"No death certificate. No interment signature.\" death is listed \"Jan. 26th 1828Feb. 2, 1828\""
  },
  {
    "nameId": "Mrs (wife) Russel",
    "gNumber": "H-101201",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 45,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-01-29",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth M. Clarke",
    "gNumber": "H-100280",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 21,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-02-08",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Henry L. Smith",
    "gNumber": "H-101310",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 20,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-02-16",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller"
  },
  {
    "nameId": "(son) Neagle",
    "gNumber": "H-101005",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-02-19",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Saml. R.; Jesse Miller, Sexton"
  },
  {
    "nameId": "James E. Lee",
    "gNumber": "H-100821",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-03-07",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller signed inter cert"
  },
  {
    "nameId": "Anna James",
    "gNumber": "H-100687",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 83,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-03-14",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "J. Miller Signed int cert"
  },
  {
    "nameId": "Mary Bright",
    "gNumber": "H-100161",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 68,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-03-28",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Peter B. Evans",
    "gNumber": "H-100460",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "7-11",
    "ageAtDeath": 9,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-04-08",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "J. Miller Signed int cert"
  },
  {
    "nameId": "Rebecca Coxe",
    "gNumber": "H-100325",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 20,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-06-13",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Barger",
    "gNumber": "H-100061",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-06-15",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "George T. Hamilton",
    "gNumber": "H-100592",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-06-16",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller, Sexton"
  },
  {
    "nameId": "Elizabeth Jones",
    "gNumber": "H-100735",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 58,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-06-29",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Robert M. Ford",
    "gNumber": "H-100493",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-06-30",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Benjamin Lambert",
    "gNumber": "H-100809",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 18,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-07-16",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Priscilla Leman",
    "gNumber": "H-100822",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 26,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-07-21",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "J. Miller Signed int cert"
  },
  {
    "nameId": "Ann Sarah Nofues",
    "gNumber": "H-101013",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-07-25",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller, Sexton"
  },
  {
    "nameId": "Elizabeth Stewart",
    "gNumber": "H-101345",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-08-30",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Charles; J. Miller"
  },
  {
    "nameId": "Tacy (Tacey) Barrett (Barrot)",
    "gNumber": "H-100071",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 33,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-08-31",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Susan Tatem",
    "gNumber": "H-101369",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 39,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-10-12",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "J. Miller Signed int cert"
  },
  {
    "nameId": "Elizabeth Thomas",
    "gNumber": "H-101397",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 35,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-10-30",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "J. Miller Signed int cert"
  },
  {
    "nameId": "Mary Poulson",
    "gNumber": "H-101106",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 40,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-11-21",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(daughter) Dutton",
    "gNumber": "H-100421",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-11-29",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Joseph"
  },
  {
    "nameId": "Elizabeth Dobbins",
    "gNumber": "H-100387",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "7-11",
    "ageAtDeath": 9,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-12-02",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Emma Louisa Kille",
    "gNumber": "H-100784",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-12-09",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(son) Mitchell",
    "gNumber": "H-100954",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-12-10",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Wm. H."
  },
  {
    "nameId": "Elisa Phillips",
    "gNumber": "H-101087",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 28,
    "ancestry": "Unknown",
    "dateOfDeath": "1828",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. John"
  },
  {
    "nameId": "Maria Rebecca Jones",
    "gNumber": "H-100736",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 26,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-12-20",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Ann Reynolds",
    "gNumber": "H-101152",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 57,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-09-21",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Chris; j. Miller Signed int cert"
  },
  {
    "nameId": "Mr Thomas Dobbins",
    "gNumber": "H-100386",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 19,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-07-03",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Robert Mall",
    "gNumber": "H-100858",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 63,
    "ancestry": "Unknown",
    "dateOfDeath": "1828-08-15",
    "yearOfDeath": 1828,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"I hereby certify that Robert Mahh of Phila. While on  visit Aug 15, 1828 died at the house of Ann & Rebecca Huston in the town of Chichester Co. of Del. Pa. of an ordinary attack of billious fever. Justus Dunott M.D.("
  },
  {
    "nameId": "Joseph M. Hamilton",
    "gNumber": "H-100593",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "4-8",
    "ageAtDeath": 6,
    "ancestry": "Unknown",
    "dateOfDeath": "1829-01-24",
    "yearOfDeath": 1829,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "J. Miller Signed int cert"
  },
  {
    "nameId": "Mary Brown",
    "gNumber": "H-100187",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 40,
    "ancestry": "Unknown",
    "dateOfDeath": "1829-03-28",
    "yearOfDeath": 1829,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"int cer has case listed as 'Nancy Brown'\""
  },
  {
    "nameId": "Mrs Mary Johnson",
    "gNumber": "H-100707",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 90,
    "ancestry": "Unknown",
    "dateOfDeath": "1829-04-28",
    "yearOfDeath": 1829,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "No int. signature"
  },
  {
    "nameId": "Theodore B. Bozarth",
    "gNumber": "H-100141",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1829-05-07",
    "yearOfDeath": 1829,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John McCloud",
    "gNumber": "H-100889",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 72,
    "ancestry": "Unknown",
    "dateOfDeath": "1829-05-11",
    "yearOfDeath": 1829,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"Doctor has name listed as Mr. McLead\""
  },
  {
    "nameId": "Washington L. Beagle",
    "gNumber": "H-100083",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1829-05-18",
    "yearOfDeath": 1829,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Davenport",
    "gNumber": "H-100343",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 51,
    "ancestry": "Unknown",
    "dateOfDeath": "1829-05-19",
    "yearOfDeath": 1829,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "George D. Croskey",
    "gNumber": "H-100331",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 50,
    "ancestry": "Unknown",
    "dateOfDeath": "1829",
    "yearOfDeath": 1829,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Matilda Chandler",
    "gNumber": "H-100249",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 22,
    "ancestry": "Unknown",
    "dateOfDeath": "1829-08-24",
    "yearOfDeath": 1829,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller, signed inter. cer."
  },
  {
    "nameId": "Theophilius Hansell",
    "gNumber": "H-100600",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1829-08-26",
    "yearOfDeath": 1829,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller, Sexton"
  },
  {
    "nameId": "John Sexton",
    "gNumber": "H-101241",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1829-10-19",
    "yearOfDeath": 1829,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Susannah Brown",
    "gNumber": "H-100188",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 73,
    "ancestry": "Unknown",
    "dateOfDeath": "1829-12-03",
    "yearOfDeath": 1829,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth Humphreys",
    "gNumber": "H-100673",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "1-5",
    "ageAtDeath": 3,
    "ancestry": "Unknown",
    "dateOfDeath": "1829-12-12",
    "yearOfDeath": 1829,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Inter Cert not signed"
  },
  {
    "nameId": "Mrs (wife) Crosson",
    "gNumber": "H-100332",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 60,
    "ancestry": "Unknown",
    "dateOfDeath": "1829-12-18",
    "yearOfDeath": 1829,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Inter. Cert. Not Signed"
  },
  {
    "nameId": "Elizabeth Engels",
    "gNumber": "H-100447",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 76,
    "ancestry": "Unknown",
    "dateOfDeath": "1829-12-21",
    "yearOfDeath": 1829,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller, Sexton"
  },
  {
    "nameId": "Mary Boyd",
    "gNumber": "H-100132",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1829",
    "yearOfDeath": 1829,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "E. Hellings",
    "gNumber": "H-100627",
    "sex": "Unknown",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1829",
    "yearOfDeath": 1829,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Garnes? Mann",
    "gNumber": "H-100863",
    "sex": "Unknown",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 35,
    "ancestry": "Unknown",
    "dateOfDeath": "1829",
    "yearOfDeath": 1829,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rev William Staughton D.D.",
    "gNumber": "H-101326",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 59,
    "ancestry": "Unknown",
    "dateOfDeath": "1829",
    "yearOfDeath": 1829,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Josiah Evans",
    "gNumber": "H-100461",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 59,
    "ancestry": "Unknown",
    "dateOfDeath": "1829-12-14",
    "yearOfDeath": 1829,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "h. Margaret"
  },
  {
    "nameId": "John Turner",
    "gNumber": "H-101432",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 46,
    "ancestry": "Unknown",
    "dateOfDeath": "1829-09-11",
    "yearOfDeath": 1829,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jane Weatherly, Weatherby",
    "gNumber": "H-101514",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1830-01-14",
    "yearOfDeath": 1830,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John How",
    "gNumber": "H-100665",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 64,
    "ancestry": "Unknown",
    "dateOfDeath": "1830-06-24",
    "yearOfDeath": 1830,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Moore",
    "gNumber": "H-100960",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1830",
    "yearOfDeath": 1830,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Grace Patterson",
    "gNumber": "H-101045",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 38,
    "ancestry": "Unknown",
    "dateOfDeath": "1830",
    "yearOfDeath": 1830,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "George Walker",
    "gNumber": "H-101462",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 21,
    "ancestry": "Unknown",
    "dateOfDeath": "1830",
    "yearOfDeath": 1830,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Walbram",
    "gNumber": "H-101452",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1830",
    "yearOfDeath": 1830,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth Cook",
    "gNumber": "H-100309",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 79,
    "ancestry": "Unknown",
    "dateOfDeath": "1830-02-11",
    "yearOfDeath": 1830,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "James Travilla",
    "gNumber": "H-101417",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 32,
    "ancestry": "Unknown",
    "dateOfDeath": "1830-09-17",
    "yearOfDeath": 1830,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Margaretta L. Withy",
    "gNumber": "H-101563",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 22,
    "ancestry": "Unknown",
    "dateOfDeath": "1830-11-01",
    "yearOfDeath": 1830,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"who entered upon her immortal inheritance\u2026Young Talented and pious she sleeps\u2026 to awake in hEaven"
  },
  {
    "nameId": "Miss Sarah Ann Jewell",
    "gNumber": "H-100696",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 24,
    "ancestry": "Unknown",
    "dateOfDeath": "1831-10-24",
    "yearOfDeath": 1831,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller signed inter cert"
  },
  {
    "nameId": "Elisabeth Callbreath",
    "gNumber": "H-100222",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 44,
    "ancestry": "Unknown",
    "dateOfDeath": "1831",
    "yearOfDeath": 1831,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rachel Cloud",
    "gNumber": "H-100289",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 44,
    "ancestry": "Unknown",
    "dateOfDeath": "1831",
    "yearOfDeath": 1831,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. J. Thomas; (husband) refiner at the mint"
  },
  {
    "nameId": "Mary Shemer",
    "gNumber": "H-101253",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 72,
    "ancestry": "Unknown",
    "dateOfDeath": "1831-07-06",
    "yearOfDeath": 1831,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Hannah Eldridge",
    "gNumber": "H-100442",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 55,
    "ancestry": "Unknown",
    "dateOfDeath": "1831-03-29",
    "yearOfDeath": 1831,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Charles Thomas Dobson",
    "gNumber": "H-100395",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "3-7",
    "ageAtDeath": 5,
    "ancestry": "Unknown",
    "dateOfDeath": "1831-09-26",
    "yearOfDeath": 1831,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Robert and Hannah; father was sea catpain"
  },
  {
    "nameId": "Sarah Ann Sewell",
    "gNumber": "H-101233",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 24,
    "ancestry": "Unknown",
    "dateOfDeath": "1831",
    "yearOfDeath": 1831,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Dr Benjamin Rush Rhees M.D.",
    "gNumber": "H-101155",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 33,
    "ancestry": "Unknown",
    "dateOfDeath": "1831-10-09",
    "yearOfDeath": 1831,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"Professor of the Insitutes of Medicine in Jefferson Medical College\u2026 This Tablet isinscribed to his memory by his colleagues as a mark of their esteem for his talents and virtues.\", J. Miller Signed int cert"
  },
  {
    "nameId": "Angelina (Angeline) McCloud",
    "gNumber": "H-100890",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1831-02-04",
    "yearOfDeath": 1831,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "j. Miller Signed int cert"
  },
  {
    "nameId": "John Bright",
    "gNumber": "H-100162",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1831-02-07",
    "yearOfDeath": 1831,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"J. Miller agd int ser\""
  },
  {
    "nameId": "James Stallard",
    "gNumber": "H-101323",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 83,
    "ancestry": "Unknown",
    "dateOfDeath": "1831-02-15",
    "yearOfDeath": 1831,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "shopkeeper"
  },
  {
    "nameId": "Hannah Elisabeth Bird",
    "gNumber": "H-100121",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1831-02-16",
    "yearOfDeath": 1831,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Henry Frowert",
    "gNumber": "H-100508",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1831",
    "yearOfDeath": 1831,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse Miller, Sexton"
  },
  {
    "nameId": "Elvira Ann Holcome",
    "gNumber": "H-100653",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 17,
    "ancestry": "Unknown",
    "dateOfDeath": "1831-11-30",
    "yearOfDeath": 1831,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "J. Miller Signed int cert"
  },
  {
    "nameId": "John Boyd",
    "gNumber": "H-100133",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1832",
    "yearOfDeath": 1832,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elisabeth Vanaken",
    "gNumber": "H-101439",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1832",
    "yearOfDeath": 1832,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rachel Moore",
    "gNumber": "H-100961",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 73,
    "ancestry": "Unknown",
    "dateOfDeath": "1832-01-25",
    "yearOfDeath": 1832,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Charles Jackson Bozarth",
    "gNumber": "H-100142",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1832-02-02",
    "yearOfDeath": 1832,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Mary R. (or B.) Chandler",
    "gNumber": "H-100250",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 52,
    "ancestry": "Unknown",
    "dateOfDeath": "1832-02-14",
    "yearOfDeath": 1832,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Jesse miller also"
  },
  {
    "nameId": "Sally Ann O'Daniell",
    "gNumber": "H-101018",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "3-7",
    "ageAtDeath": 5,
    "ancestry": "Unknown",
    "dateOfDeath": "1832-11-24",
    "yearOfDeath": 1832,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Robert Dobson",
    "gNumber": "H-100396",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1833-05-23",
    "yearOfDeath": 1833,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Robert and Hannah; father was sea catpain"
  },
  {
    "nameId": "Hugh Gourley",
    "gNumber": "H-100558",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 84,
    "ancestry": "Unknown",
    "dateOfDeath": "1833-11-09",
    "yearOfDeath": 1833,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "h. Mary; gentleman, \"who sweetly fell a sleep in Jesus\""
  },
  {
    "nameId": "Joseph Ogden",
    "gNumber": "H-101029",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 33,
    "ancestry": "Unknown",
    "dateOfDeath": "1834",
    "yearOfDeath": 1834,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "James Warren Sr",
    "gNumber": "H-101480",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 42,
    "ancestry": "Unknown",
    "dateOfDeath": "1834",
    "yearOfDeath": 1834,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "George W. Butler",
    "gNumber": "H-100212",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 19,
    "ancestry": "Unknown",
    "dateOfDeath": "1834-01-05",
    "yearOfDeath": 1834,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Joseph and Ann"
  },
  {
    "nameId": "Thomas Bacon Esq.",
    "gNumber": "H-100041",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 59,
    "ancestry": "Unknown",
    "dateOfDeath": "1834-10-23",
    "yearOfDeath": 1834,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"A Planter of Georgia/Son in law of the late Henry Holcombe/Elevated to Public Stations by the confidence of his Fellow Citizens Mr. Bacon Acquitted himself of the duriesassigned to him with integrity and usefulness/In the Church be professes to be a follower of the meek and lowly Jesus of which he worthily occupied the office of Deacon/ As a husband he was ever solicitous of Mmultiplying his Partner's joys, and never failed to sympathize in her sorrows/ As Father of a numerous fFamily, he ruled his Children and his Household with a discipline...l blended energy and effection. IN his intercourse with society, he was dignified, courteous, and friendly, delicate in his Charities, and prompt to assist in the hour of need. In Fine his life as a Christian Statesman and Jurist, the truth that nothin is substantial without Honesty, that there is no enruding happiness wihtout PIety, ad that the highest earthly distinction is a Consistent Christian. A Tribute of Affection By his Wife and Children.\""
  },
  {
    "nameId": "(child) Phillips",
    "gNumber": "H-101089",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1834-11-18",
    "yearOfDeath": 1834,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John"
  },
  {
    "nameId": "Eliza Lemon",
    "gNumber": "H-100824",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1834-11-08",
    "yearOfDeath": 1834,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Peterson",
    "gNumber": "H-101084",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1834-11-12",
    "yearOfDeath": 1834,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. James"
  },
  {
    "nameId": "Elizabeth Withy",
    "gNumber": "H-101564",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1834-11-14",
    "yearOfDeath": 1834,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"in Jones Tomb\""
  },
  {
    "nameId": "(child) Gray",
    "gNumber": "H-100567",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1834-12-20",
    "yearOfDeath": 1834,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Capt. Gray; Poss Cpt. Richard"
  },
  {
    "nameId": "Samuel Arthip?",
    "gNumber": "H-100027",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1834-12-30",
    "yearOfDeath": 1834,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Dilworth",
    "gNumber": "H-100383",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "1-5",
    "ageAtDeath": 3,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-12-28",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John; father was turner"
  },
  {
    "nameId": "(child) Moses",
    "gNumber": "H-100983",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-08-30",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mr."
  },
  {
    "nameId": "Rebecca Hamilton",
    "gNumber": "H-100594",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 78,
    "ancestry": "Unknown",
    "dateOfDeath": "1835",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Shermer",
    "gNumber": "H-101258",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1835",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Joseph"
  },
  {
    "nameId": "Mary Warren",
    "gNumber": "H-101481",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 50,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-07-12",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Susan B. Smith",
    "gNumber": "H-101311",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 24,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-02-05",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ellen Callbreath",
    "gNumber": "H-100223",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 40,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-06-30",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Atkins",
    "gNumber": "H-100035",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1835",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Of Atkins; Between 12/22/1834 and 3/30/1835"
  },
  {
    "nameId": "(child) Cleghorn",
    "gNumber": "H-100285",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1835",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Ch. Mr.; Between 12/22/1834 and 3/30/1836"
  },
  {
    "nameId": "(child) Cleghorn",
    "gNumber": "H-100286",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1835",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Ch. Mr.; Between 12/22/1834 and 3/30/1837"
  },
  {
    "nameId": "(child) Cleghorn",
    "gNumber": "H-100287",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1835",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Ch. Mr.; Between 12/22/1834 and 3/30/1838"
  },
  {
    "nameId": "Mr George McGraw",
    "gNumber": "H-100904",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 35,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-02-09",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"Taking the statement of his family for the nature of his disease for I saw him only afterhis decease\"  from Death Cert; housecarpenter"
  },
  {
    "nameId": "Thomas Dilworth",
    "gNumber": "H-100382",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-10-31",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John; father was turner"
  },
  {
    "nameId": "Elizabeth Bates",
    "gNumber": "H-100078",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-02-25",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mr."
  },
  {
    "nameId": "Ellen Calbreath",
    "gNumber": "H-100220",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 40,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-01-25",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Ann McDermond",
    "gNumber": "H-100895",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 38,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-02-19",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Shermer",
    "gNumber": "H-101257",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-02-21",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Joseph"
  },
  {
    "nameId": "Catherine (Caroline) Gourley",
    "gNumber": "H-100559",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 25,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-06-22",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Catherine Burkloe",
    "gNumber": "H-100200",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 72,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-03-22",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Samuel"
  },
  {
    "nameId": "Frances Baldwin",
    "gNumber": "H-100054",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 81,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-08-09",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Rambo",
    "gNumber": "H-101126",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-12-11",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Narcissa Simons",
    "gNumber": "H-101282",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "8-12",
    "ageAtDeath": 10,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-02-26",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Smith",
    "gNumber": "H-101312",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 42,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-06-20",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Stallard",
    "gNumber": "H-101324",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-07-03",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Cobb",
    "gNumber": "H-100291",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-07-09",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Daniel"
  },
  {
    "nameId": "Thomas Calbraith",
    "gNumber": "H-100219",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-10-11",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Hannah Rhodes",
    "gNumber": "H-101161",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-12-18",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Emily S. Noeman",
    "gNumber": "H-101012",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-03-14",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"removed out\""
  },
  {
    "nameId": "Sarah James",
    "gNumber": "H-100688",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-03-16",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Otto"
  },
  {
    "nameId": "(Man) Clavenger Esq.",
    "gNumber": "H-100282",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1835",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"Removed out of ground\""
  },
  {
    "nameId": "Mary Miller",
    "gNumber": "H-100944",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-06-18",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "James Warren Jr",
    "gNumber": "H-101482",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "3-7",
    "ageAtDeath": 5,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-07-19",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Mary"
  },
  {
    "nameId": "James Travilla",
    "gNumber": "H-101418",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-09-19",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Charles E. Pots",
    "gNumber": "H-101098",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-11-18",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Isabella Gamble",
    "gNumber": "H-100514",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-12-28",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Deborah Gamble",
    "gNumber": "H-100515",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-12-28",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Theophilus I. Todd",
    "gNumber": "H-101407",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1835-12-28",
    "yearOfDeath": 1835,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John; father was weaver"
  },
  {
    "nameId": "Mr Isaac P. Carlisle",
    "gNumber": "H-100229",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 26,
    "ancestry": "Unknown",
    "dateOfDeath": "1836-06-03",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "machinist"
  },
  {
    "nameId": "(child) Wolfe",
    "gNumber": "H-101567",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1836-08-07",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. W. B.; merchant"
  },
  {
    "nameId": "Catherine Eiserman",
    "gNumber": "H-100438",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1836-12-10",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Wm. Wood",
    "gNumber": "H-101578",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1836-07-31",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "inf. Son of Tom"
  },
  {
    "nameId": "(child) Potts",
    "gNumber": "H-101100",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1836",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mr."
  },
  {
    "nameId": "Hannah Dawson",
    "gNumber": "H-100370",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 36,
    "ancestry": "Unknown",
    "dateOfDeath": "1836-01-27",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Robert"
  },
  {
    "nameId": "Mrs Sarah Boyd",
    "gNumber": "H-100134",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 50,
    "ancestry": "Unknown",
    "dateOfDeath": "1836-12-04",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Age 40 in Cem Returns"
  },
  {
    "nameId": "George Moses",
    "gNumber": "H-100984",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1836-05-13",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Mr. G.; father (Gratz?) merchant"
  },
  {
    "nameId": "Charles Henry Mulford",
    "gNumber": "H-100996",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1836-07-13",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Jonathan"
  },
  {
    "nameId": "(child) Wood",
    "gNumber": "H-101579",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1836-08-02",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mr. Jas.; Listed as 'Jas B.'"
  },
  {
    "nameId": "Mrs Ann Wilgus",
    "gNumber": "H-101549",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 63,
    "ancestry": "Unknown",
    "dateOfDeath": "1836-04-13",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Bright",
    "gNumber": "H-100163",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 81,
    "ancestry": "Unknown",
    "dateOfDeath": "1836-03-16",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William W. Keen",
    "gNumber": "H-100756",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1836-01-11",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Deac. William; \"R out\"; \"in grave marked childrne of Deacon William Keen\"; currier"
  },
  {
    "nameId": "Susan Keen",
    "gNumber": "H-100757",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1836-01-18",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Dea. William; \"R out\"; \"in grave marked childrne of Deacon William Keen\"; currier"
  },
  {
    "nameId": "(child) Lemon",
    "gNumber": "H-100825",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1836-04-10",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mr. Charles"
  },
  {
    "nameId": "(child) Brantly",
    "gNumber": "H-100152",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1836-09-09",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mr. W. J."
  },
  {
    "nameId": "(child) Paullin",
    "gNumber": "H-101047",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1836-09-21",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mr. Jas.; Father \"Joel\" was Tailor"
  },
  {
    "nameId": "(child) Randles",
    "gNumber": "H-101131",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1836-11-15",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mr."
  },
  {
    "nameId": "Samuel Pearson",
    "gNumber": "H-101052",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 37,
    "ancestry": "Unknown",
    "dateOfDeath": "1836-11-19",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "blacksmith"
  },
  {
    "nameId": "(child) Gendle",
    "gNumber": "H-100525",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1836-06-13",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John"
  },
  {
    "nameId": "Mary Paullin",
    "gNumber": "H-101046",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1836-01-25",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Daniel Kuhn",
    "gNumber": "H-100799",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1836",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "shoemaker"
  },
  {
    "nameId": "Mary Walbram",
    "gNumber": "H-101453",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1836",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Henry Potts",
    "gNumber": "H-101101",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1836-03-07",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ann Post",
    "gNumber": "H-101095",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 30,
    "ancestry": "Unknown",
    "dateOfDeath": "1836-12-25",
    "yearOfDeath": 1836,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Abby Frances Jones",
    "gNumber": "H-100737",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1837",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"to go to Woodland Cemetery\""
  },
  {
    "nameId": "(child) Paullin",
    "gNumber": "H-101048",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1837",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mary"
  },
  {
    "nameId": "Catharine Ann Cisoner",
    "gNumber": "H-100261",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1837",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Arnold Cowgill",
    "gNumber": "H-100317",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-08-12",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ann Post",
    "gNumber": "H-101096",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-03-18",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"poor member\""
  },
  {
    "nameId": "Catherine Rambig",
    "gNumber": "H-101123",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-03-18",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"poor member\""
  },
  {
    "nameId": "John Phillip Hoff",
    "gNumber": "H-100649",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "1-5",
    "ageAtDeath": 3,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-03-03",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "(child) s. John and Frances H."
  },
  {
    "nameId": "Hannah Ustick",
    "gNumber": "H-101438",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 86,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-03-14",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "wid. Rev. Thomas"
  },
  {
    "nameId": "Mr Nathaniel Davis",
    "gNumber": "H-100366",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 32,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-07-22",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Signed by Sexton Joseph Shermen, Sexton; Doctor was S. Jackson in Microfilm"
  },
  {
    "nameId": "Miss Nancy Ford",
    "gNumber": "H-100494",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 73,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-08-02",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Dates on Cem. Returns are died on the 11th and buried on the 12th of August, 1837; Signed by Sexton Joseph Shermen, Sexton"
  },
  {
    "nameId": "Mrs Ann Edgel",
    "gNumber": "H-100432",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 28,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-09-04",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Signed by Sexton Joseph Shermen, Sexton"
  },
  {
    "nameId": "Mrs Margaret George",
    "gNumber": "H-100535",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 86,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-09-13",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jacob Cave",
    "gNumber": "H-100240",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-11-11",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Joseph and Sarah"
  },
  {
    "nameId": "William Cox",
    "gNumber": "H-100323",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 22,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-01-18",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"stranger\""
  },
  {
    "nameId": "Mr Samuel J. Duncan",
    "gNumber": "H-100414",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 25,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-08-11",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"in his Fathers Vault\"; Signed by Sexton Joseph Shermen, Sexton"
  },
  {
    "nameId": "Frances Holcomb",
    "gNumber": "H-100651",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 70,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-10-22",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"In Tomb of her Husband\""
  },
  {
    "nameId": "(child) Mosses",
    "gNumber": "H-100986",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-07-03",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mr."
  },
  {
    "nameId": "Catharine Harmsted",
    "gNumber": "H-100603",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 91,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-07-06",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Jones",
    "gNumber": "H-100738",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-07-26",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Goglee",
    "gNumber": "H-100546",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-09-13",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mr. Arnold"
  },
  {
    "nameId": "(child) Clark",
    "gNumber": "H-100273",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-04-06",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mr.; \"removed out of ground\""
  },
  {
    "nameId": "(child) Justin",
    "gNumber": "H-100748",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-04-09",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mr. J"
  },
  {
    "nameId": "David Johns",
    "gNumber": "H-100700",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 71,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-05-17",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Justin",
    "gNumber": "H-100749",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "3-7",
    "ageAtDeath": 5,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-06-06",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mr. J"
  },
  {
    "nameId": "Mr (man) Yardsly",
    "gNumber": "H-101595",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 72,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-11-18",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Curtis",
    "gNumber": "H-100333",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 29,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-11-28",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mr (man) Whitesides",
    "gNumber": "H-101543",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 46,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-12-14",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rebecca Hamilton",
    "gNumber": "H-100595",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-01-07",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"stranger\""
  },
  {
    "nameId": "Jane O'Bryen",
    "gNumber": "H-101017",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 50,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-01-18",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"poor member\""
  },
  {
    "nameId": "Aaron Ellis",
    "gNumber": "H-100444",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 65,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-02-26",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Ann Goodman",
    "gNumber": "H-100547",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 58,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-03-09",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(daughter) Evans",
    "gNumber": "H-100462",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-03-19",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Thomas"
  },
  {
    "nameId": "(daughter) Trowart",
    "gNumber": "H-101421",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-01-28",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "infant d. Mr. J."
  },
  {
    "nameId": "Cathrine Coenig",
    "gNumber": "H-100292",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-03-12",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ann Watkins",
    "gNumber": "H-101496",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 20,
    "ancestry": "Unknown",
    "dateOfDeath": "1837-04-04",
    "yearOfDeath": 1837,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"in vault\""
  },
  {
    "nameId": "(son) Keok",
    "gNumber": "H-100778",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1838-01-04",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. J. A."
  },
  {
    "nameId": "Joseph Reeves",
    "gNumber": "H-101140",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "2-6",
    "ageAtDeath": 4,
    "ancestry": "Unknown",
    "dateOfDeath": "1838-01-20",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Early",
    "gNumber": "H-100422",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 85,
    "ancestry": "Unknown",
    "dateOfDeath": "1838-10-18",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "James Dunsford",
    "gNumber": "H-100418",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1838-04-13",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mr."
  },
  {
    "nameId": "Mary Grab (Grubb)",
    "gNumber": "H-100560",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 76,
    "ancestry": "Unknown",
    "dateOfDeath": "1838-12-02",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rebecca Barber",
    "gNumber": "H-100058",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 93,
    "ancestry": "European",
    "dateOfDeath": "1838-12-22",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "widow"
  },
  {
    "nameId": "Mrs Elizabeth Johns",
    "gNumber": "H-100701",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 70,
    "ancestry": "Unknown",
    "dateOfDeath": "1838-01-03",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Widow; Widow born in Phila"
  },
  {
    "nameId": "Elizabeth Clavenger",
    "gNumber": "H-100283",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 71,
    "ancestry": "Unknown",
    "dateOfDeath": "1838-12-07",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"removed out of Ground\" written in new hand"
  },
  {
    "nameId": "(daughter) Moses",
    "gNumber": "H-100985",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1838-04-10",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Samuel; father was carpenter"
  },
  {
    "nameId": "Sarah Powell",
    "gNumber": "H-101113",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 68,
    "ancestry": "Unknown",
    "dateOfDeath": "1838-04-17",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jacob Price",
    "gNumber": "H-101119",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1838-07-23",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Mr. Jacob"
  },
  {
    "nameId": "Mary Easby",
    "gNumber": "H-100429",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 26,
    "ancestry": "Unknown",
    "dateOfDeath": "1838-09-12",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. John"
  },
  {
    "nameId": "Mr Ezekiel E. Maddock",
    "gNumber": "H-100853",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 29,
    "ancestry": "Unknown",
    "dateOfDeath": "1838-09-14",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs July A. Keok (Kesk)",
    "gNumber": "H-100779",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 41,
    "ancestry": "Unknown",
    "dateOfDeath": "1838-01-04",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"Remove out\""
  },
  {
    "nameId": "Tabitha (Tobitha) Sutton",
    "gNumber": "H-101357",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 71,
    "ancestry": "Unknown",
    "dateOfDeath": "1838-03-10",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Benjamin W. Butler",
    "gNumber": "H-100213",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 21,
    "ancestry": "Unknown",
    "dateOfDeath": "1838-02-18",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Joseph and Ann"
  },
  {
    "nameId": "Mary Gilbert",
    "gNumber": "H-100542",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 55,
    "ancestry": "Unknown",
    "dateOfDeath": "1838-11-25",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Kerbough",
    "gNumber": "H-100781",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1838-08-01",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mr. Asmond"
  },
  {
    "nameId": "(child) Reeve",
    "gNumber": "H-101139",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "3-7",
    "ageAtDeath": 5,
    "ancestry": "Unknown",
    "dateOfDeath": "1838-02-15",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mrs. Anna"
  },
  {
    "nameId": "Catharine Ann Everson",
    "gNumber": "H-100463",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "European",
    "dateOfDeath": "1838-12-11",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"grandaughter of G. Eiserman\""
  },
  {
    "nameId": "John Britton",
    "gNumber": "H-100180",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 67,
    "ancestry": "Unknown",
    "dateOfDeath": "1838-01-23",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"Remove out vault\""
  },
  {
    "nameId": "Hariett L. Duncan",
    "gNumber": "H-100415",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "10-14",
    "ageAtDeath": 12,
    "ancestry": "Unknown",
    "dateOfDeath": "1838-05-21",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Wm; \"in her father's vault\""
  },
  {
    "nameId": "(son) Bishop",
    "gNumber": "H-100122",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1838-11-14",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. William Bishop; house carpenter"
  },
  {
    "nameId": "Mary Carmack",
    "gNumber": "H-100230",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 72,
    "ancestry": "Unknown",
    "dateOfDeath": "1838-11-30",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Debra (Deborah) Travilla",
    "gNumber": "H-101419",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 55,
    "ancestry": "Unknown",
    "dateOfDeath": "1838-11-28",
    "yearOfDeath": 1838,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Miss E. Hillings",
    "gNumber": "H-100645",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 36,
    "ancestry": "Unknown",
    "dateOfDeath": "1839-06-15",
    "yearOfDeath": 1839,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ages of 35 listed also"
  },
  {
    "nameId": "Jane Rose",
    "gNumber": "H-101189",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 74,
    "ancestry": "Unknown",
    "dateOfDeath": "1839-08-04",
    "yearOfDeath": 1839,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs (wife) Keen",
    "gNumber": "H-100758",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 28,
    "ancestry": "Unknown",
    "dateOfDeath": "1839-04-19",
    "yearOfDeath": 1839,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Charles; \"removed out\""
  },
  {
    "nameId": "Mrs Martha (Marsha) Dewees (Davis)",
    "gNumber": "H-100378",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 81,
    "ancestry": "Unknown",
    "dateOfDeath": "1839-06-05",
    "yearOfDeath": 1839,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Louisa Lamb",
    "gNumber": "H-100805",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 36,
    "ancestry": "Unknown",
    "dateOfDeath": "1839-01-03",
    "yearOfDeath": 1839,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jane Corfield (Confield)",
    "gNumber": "H-100313",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 73,
    "ancestry": "Unknown",
    "dateOfDeath": "1839-07-26",
    "yearOfDeath": 1839,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs (wife) English",
    "gNumber": "H-100449",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 32,
    "ancestry": "European",
    "dateOfDeath": "1839-06-16",
    "yearOfDeath": 1839,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"married\"; \"native of Philadelphia\""
  },
  {
    "nameId": "Hellin (Hellen) Williams Keen",
    "gNumber": "H-100759",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "7-11",
    "ageAtDeath": 9,
    "ancestry": "Unknown",
    "dateOfDeath": "1839-06-22",
    "yearOfDeath": 1839,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. of W."
  },
  {
    "nameId": "Col James Anderson",
    "gNumber": "H-100014",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 93,
    "ancestry": "Af. Decent",
    "dateOfDeath": "1839-06-25",
    "yearOfDeath": 1839,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"married\"; \"from Africa\"; Pastor"
  },
  {
    "nameId": "Eliza Grimes",
    "gNumber": "H-100576",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1839-04-19",
    "yearOfDeath": 1839,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Dobson",
    "gNumber": "H-100397",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "6-10",
    "ageAtDeath": 8,
    "ancestry": "Unknown",
    "dateOfDeath": "1839-10-17",
    "yearOfDeath": 1839,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Louisa Stephens",
    "gNumber": "H-101332",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 31,
    "ancestry": "Unknown",
    "dateOfDeath": "1839-12-14",
    "yearOfDeath": 1839,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"stranger\"; w. Richard"
  },
  {
    "nameId": "Margaret Brades",
    "gNumber": "H-100150",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 60,
    "ancestry": "Unknown",
    "dateOfDeath": "1839-08-21",
    "yearOfDeath": 1839,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"Our Mother\""
  },
  {
    "nameId": "Sarah Rambo",
    "gNumber": "H-101127",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 59,
    "ancestry": "Unknown",
    "dateOfDeath": "1839-01-27",
    "yearOfDeath": 1839,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Hannah Whitby (Withy)",
    "gNumber": "H-101533",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 40,
    "ancestry": "Unknown",
    "dateOfDeath": "1839-01-16",
    "yearOfDeath": 1839,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Susanna Lamb",
    "gNumber": "H-100806",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 36,
    "ancestry": "Unknown",
    "dateOfDeath": "1839-01-05",
    "yearOfDeath": 1839,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jane Rose",
    "gNumber": "H-101190",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 51,
    "ancestry": "Unknown",
    "dateOfDeath": "1839-08-07",
    "yearOfDeath": 1839,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "David Simpson",
    "gNumber": "H-101283",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Unknown",
    "dateOfDeath": "1839-02-03",
    "yearOfDeath": 1839,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. John"
  },
  {
    "nameId": "Elenor Kuhn (Ruhn)",
    "gNumber": "H-100800",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 72,
    "ancestry": "Unknown",
    "dateOfDeath": "1839-02-05",
    "yearOfDeath": 1839,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Benjamin Z. Curtis",
    "gNumber": "H-100334",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "5-9",
    "ageAtDeath": 7,
    "ancestry": "Unknown",
    "dateOfDeath": "1839-09-22",
    "yearOfDeath": 1839,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Sarah Morris",
    "gNumber": "H-100976",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 73,
    "ancestry": "Unknown",
    "dateOfDeath": "1839-08-28",
    "yearOfDeath": 1839,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Joseph"
  },
  {
    "nameId": "Hannah Rambo",
    "gNumber": "H-101128",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 66,
    "ancestry": "Unknown",
    "dateOfDeath": "1839-03-09",
    "yearOfDeath": 1839,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Clark",
    "gNumber": "H-100274",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1839-03-10",
    "yearOfDeath": 1839,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Thomas; \"removed out of ground\""
  },
  {
    "nameId": "Peter Vanaken (Madarah?)",
    "gNumber": "H-101441",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1839-03-11",
    "yearOfDeath": 1839,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. William; cabinetmaker"
  },
  {
    "nameId": "J. K. Reaves",
    "gNumber": "H-101135",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-01-06",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"an infant\""
  },
  {
    "nameId": "J. M. Gedrick",
    "gNumber": "H-100523",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 28,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-01-14",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth Bright",
    "gNumber": "H-100164",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 45,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-07-10",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Sarah C. Simmons",
    "gNumber": "H-101277",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 25,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-05-28",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs E. Hellings",
    "gNumber": "H-100628",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 45,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-03-25",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Elisabeth Easby",
    "gNumber": "H-100430",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 53,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-08-25",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Capt John Morton",
    "gNumber": "H-100982",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 40,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-09-22",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ann Maria Povall (Poval)",
    "gNumber": "H-101107",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 40,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-10-24",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "widow; \"about 40 years\"; None"
  },
  {
    "nameId": "(son) Wolf (Wolff)",
    "gNumber": "H-101566",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-10-29",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "youngest s. William; (7 hrs)"
  },
  {
    "nameId": "Mary Lyle",
    "gNumber": "H-100849",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 46,
    "ancestry": "European",
    "dateOfDeath": "1840-11-05",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "of Mr. Buckley; None"
  },
  {
    "nameId": "Phebe (Pheby, Phoebe) Maddock",
    "gNumber": "H-100854",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 59,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-11-11",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Mary Sims",
    "gNumber": "H-101288",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 67,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-11-28",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Catharine Simmins",
    "gNumber": "H-101275",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-07-15",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Jane Delworth (Dilworth)",
    "gNumber": "H-100374",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-05-20",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. I. and Elizabeth"
  },
  {
    "nameId": "Mary Hartley",
    "gNumber": "H-100610",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 36,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-02-09",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Lucritia M. George",
    "gNumber": "H-100536",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 18,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-06-09",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Elizabeth How",
    "gNumber": "H-100666",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 70,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-08-03",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Hellings",
    "gNumber": "H-100629",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 21,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-10-19",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Samuel P. George",
    "gNumber": "H-100537",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "11-15",
    "ageAtDeath": 13,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-12-17",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Charles"
  },
  {
    "nameId": "Miss Jane Monk",
    "gNumber": "H-100956",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 50,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-12-30",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"about 50 years\""
  },
  {
    "nameId": "Catharine Eyers",
    "gNumber": "H-100465",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 83,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-07-19",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "widow; \"has resided in Philadelphia 43 years\""
  },
  {
    "nameId": "Tamer S. Filbert",
    "gNumber": "H-100476",
    "sex": "Unknown",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 85,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-08-02",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"Death caused by Marion Wilson\""
  },
  {
    "nameId": "Elizabeth Simmons",
    "gNumber": "H-101278",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "1-5",
    "ageAtDeath": 3,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-08-26",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Emma R. Scott",
    "gNumber": "H-101226",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-02-24",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rebecca T Smith",
    "gNumber": "H-101313",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-03-26",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Lambs",
    "gNumber": "H-100810",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-06-17",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Henry and Margarit"
  },
  {
    "nameId": "Henry Keen",
    "gNumber": "H-100760",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "4-8",
    "ageAtDeath": 6,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-01-15",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Joseph"
  },
  {
    "nameId": "John Simpson",
    "gNumber": "H-101284",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-04-16",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Louisa Mouelle (Manville)",
    "gNumber": "H-100987",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 34,
    "ancestry": "European",
    "dateOfDeath": "1840-05-25",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Married"
  },
  {
    "nameId": "William Grimes",
    "gNumber": "H-100577",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 37,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-06-07",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Ford",
    "gNumber": "H-100495",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 34,
    "ancestry": "Unknown",
    "dateOfDeath": "1840-02-27",
    "yearOfDeath": 1840,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"Removed out\""
  },
  {
    "nameId": "Elizabeth Reeves",
    "gNumber": "H-101141",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1841-01-04",
    "yearOfDeath": 1841,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Israel and Anna"
  },
  {
    "nameId": "Phebe Ann Peters",
    "gNumber": "H-101082",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 35,
    "ancestry": "Af. Decent",
    "dateOfDeath": "1841-10-22",
    "yearOfDeath": 1841,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"virdict of the jury died suddenly from the effects of habitual intemperence\""
  },
  {
    "nameId": "Samuel George",
    "gNumber": "H-100538",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 50,
    "ancestry": "Af. Decent",
    "dateOfDeath": "1841-10-25",
    "yearOfDeath": 1841,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "married; lived in philly 7 years; stevadore and w/??\""
  },
  {
    "nameId": "John Becket",
    "gNumber": "H-100095",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 18,
    "ancestry": "Af. Decent",
    "dateOfDeath": "1841-11-23",
    "yearOfDeath": 1841,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "single; lived in philly 9 years; Waiter"
  },
  {
    "nameId": "Abigael Toupaugh",
    "gNumber": "H-101412",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "3-7",
    "ageAtDeath": 5,
    "ancestry": "Unknown",
    "dateOfDeath": "1841-01-19",
    "yearOfDeath": 1841,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Rinell",
    "gNumber": "H-101167",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 30,
    "ancestry": "Af. Decent",
    "dateOfDeath": "1841-11-08",
    "yearOfDeath": 1841,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"black\""
  },
  {
    "nameId": "Abigael Toupaugh",
    "gNumber": "H-101413",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "3-7",
    "ageAtDeath": 5,
    "ancestry": "Unknown",
    "dateOfDeath": "1841-01-20",
    "yearOfDeath": 1841,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Margaret Scott",
    "gNumber": "H-101227",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 25,
    "ancestry": "Unknown",
    "dateOfDeath": "1841",
    "yearOfDeath": 1841,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jonathan K. Reaves",
    "gNumber": "H-101136",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1841-01-06",
    "yearOfDeath": 1841,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"an infant\""
  },
  {
    "nameId": "Mr (man) Lacoss",
    "gNumber": "H-100803",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1841-03-16",
    "yearOfDeath": 1841,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"in Danewins? Vault\""
  },
  {
    "nameId": "Mary E. Keebough",
    "gNumber": "H-100750",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1841-01-04",
    "yearOfDeath": 1841,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Jur? And Mary"
  },
  {
    "nameId": "(daughter) Dilworth",
    "gNumber": "H-100384",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1841-05-22",
    "yearOfDeath": 1841,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. John"
  },
  {
    "nameId": "Henry Benner",
    "gNumber": "H-100102",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1841-03-11",
    "yearOfDeath": 1841,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "infant ch. Mr."
  },
  {
    "nameId": "George B. Loxley",
    "gNumber": "H-100847",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "7-11",
    "ageAtDeath": 9,
    "ancestry": "Unknown",
    "dateOfDeath": "1841-03-11",
    "yearOfDeath": 1841,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"in Rhees Vault\""
  },
  {
    "nameId": "Miss Maria Charles",
    "gNumber": "H-100254",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 25,
    "ancestry": "Unknown",
    "dateOfDeath": "1841-02-02",
    "yearOfDeath": 1841,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Stanton",
    "gNumber": "H-101325",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 51,
    "ancestry": "European",
    "dateOfDeath": "1841-04-22",
    "yearOfDeath": 1841,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "single; resided in Phila 20 years; Nurse"
  },
  {
    "nameId": "Samuel Tolman",
    "gNumber": "H-101408",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1841-07-31",
    "yearOfDeath": 1841,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Samuel Tolman; \"Removed out of Ground\""
  },
  {
    "nameId": "William S. Benner (Bensren)",
    "gNumber": "H-100104",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "2-6",
    "ageAtDeath": 4,
    "ancestry": "Unknown",
    "dateOfDeath": "1841-12-29",
    "yearOfDeath": 1841,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Sexton",
    "gNumber": "H-101242",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 73,
    "ancestry": "Unknown",
    "dateOfDeath": "1841-10-17",
    "yearOfDeath": 1841,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Ann Zegler",
    "gNumber": "H-101604",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 86,
    "ancestry": "European",
    "dateOfDeath": "1841-12-23",
    "yearOfDeath": 1841,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Married; Midwife"
  },
  {
    "nameId": "Mrs Jane Davis",
    "gNumber": "H-100367",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 76,
    "ancestry": "Unknown",
    "dateOfDeath": "1841-10-24",
    "yearOfDeath": 1841,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Dea. John"
  },
  {
    "nameId": "(daughter) Herbaugh",
    "gNumber": "H-100633",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1841-10-28",
    "yearOfDeath": 1841,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Opman"
  },
  {
    "nameId": "(child) Dilworth",
    "gNumber": "H-100385",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "10-14",
    "ageAtDeath": 12,
    "ancestry": "Unknown",
    "dateOfDeath": "1841-05-22",
    "yearOfDeath": 1841,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. John  CHECK AGE"
  },
  {
    "nameId": "Mary Wooll (Wood)",
    "gNumber": "H-101585",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 73,
    "ancestry": "Unknown",
    "dateOfDeath": "1842-06-12",
    "yearOfDeath": 1842,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"died at the Residence of Ezekie Hall, Camden (NJ)\u2026\""
  },
  {
    "nameId": "Miss Ellen Warren",
    "gNumber": "H-101483",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 27,
    "ancestry": "Unknown",
    "dateOfDeath": "1842-02-27",
    "yearOfDeath": 1842,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Thomas Rhoads",
    "gNumber": "H-101157",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 38,
    "ancestry": "Unknown",
    "dateOfDeath": "1842-02-28",
    "yearOfDeath": 1842,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mr Joseph Morris",
    "gNumber": "H-100977",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 81,
    "ancestry": "Unknown",
    "dateOfDeath": "1842-03-17",
    "yearOfDeath": 1842,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "h. Sarah"
  },
  {
    "nameId": "Mrs Sarah Charles",
    "gNumber": "H-100255",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 57,
    "ancestry": "Unknown",
    "dateOfDeath": "1842-03-19",
    "yearOfDeath": 1842,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Mary Ann Grimes",
    "gNumber": "H-100578",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 42,
    "ancestry": "Unknown",
    "dateOfDeath": "1842-04-11",
    "yearOfDeath": 1842,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jane Swain",
    "gNumber": "H-101359",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 69,
    "ancestry": "Unknown",
    "dateOfDeath": "1842-04-28",
    "yearOfDeath": 1842,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "die at \"old womans asylum 4/28\""
  },
  {
    "nameId": "Noyes (Noges) Mather",
    "gNumber": "H-100873",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 32,
    "ancestry": "Unknown",
    "dateOfDeath": "1842-10-06",
    "yearOfDeath": 1842,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Charles Thompson",
    "gNumber": "H-101403",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "7-11",
    "ageAtDeath": 9,
    "ancestry": "Unknown",
    "dateOfDeath": "1842-11-21",
    "yearOfDeath": 1842,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Daniel Thompson"
  },
  {
    "nameId": "(infant daughter) Gendell (Gendle)",
    "gNumber": "H-100524",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "European",
    "dateOfDeath": "1842-11-28",
    "yearOfDeath": 1842,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "infant d. John A"
  },
  {
    "nameId": "Abigail (Hagal) Forpaugh (Fornaugh)",
    "gNumber": "H-100496",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "3-7",
    "ageAtDeath": 5,
    "ancestry": "Unknown",
    "dateOfDeath": "1842-01-19",
    "yearOfDeath": 1842,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"removed out of ground\""
  },
  {
    "nameId": "Mrs Mary Posten (Postin)",
    "gNumber": "H-101097",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 65,
    "ancestry": "Unknown",
    "dateOfDeath": "1842-02-04",
    "yearOfDeath": 1842,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Miss Maria L. Warren",
    "gNumber": "H-101485",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "13-17",
    "ageAtDeath": 15,
    "ancestry": "Unknown",
    "dateOfDeath": "1842-06-11",
    "yearOfDeath": 1842,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Rebecca Sharp",
    "gNumber": "H-101246",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 63,
    "ancestry": "Unknown",
    "dateOfDeath": "1842-06-11",
    "yearOfDeath": 1842,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Thomas Rhoads",
    "gNumber": "H-101158",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 38,
    "ancestry": "European",
    "dateOfDeath": "1842-06-26",
    "yearOfDeath": 1842,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Dry Goods Merchant"
  },
  {
    "nameId": "Ann Bavis",
    "gNumber": "H-100081",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 54,
    "ancestry": "European",
    "dateOfDeath": "1842-07-12",
    "yearOfDeath": 1842,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "single"
  },
  {
    "nameId": "Mrs (wife) Hellings",
    "gNumber": "H-100630",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 78,
    "ancestry": "Unknown",
    "dateOfDeath": "1842-03-01",
    "yearOfDeath": 1842,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. E"
  },
  {
    "nameId": "Collin Warren",
    "gNumber": "H-101484",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 27,
    "ancestry": "Unknown",
    "dateOfDeath": "1842-02-28",
    "yearOfDeath": 1842,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ann Jordan",
    "gNumber": "H-100744",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Af. Decent",
    "dateOfDeath": "1843-10-17",
    "yearOfDeath": 1843,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Eliza J. David",
    "gNumber": "H-100344",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "0-4",
    "ageAtDeath": 2,
    "ancestry": "Af. Decent",
    "dateOfDeath": "1843-10-17",
    "yearOfDeath": 1843,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Susan Adalad Thompson",
    "gNumber": "H-101404",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1843-11-02",
    "yearOfDeath": 1843,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "infant daughter of Daniel Thompson"
  },
  {
    "nameId": "Mayant Shippard",
    "gNumber": "H-101269",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1843-05-17",
    "yearOfDeath": 1843,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Louisa Charles",
    "gNumber": "H-100256",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 34,
    "ancestry": "Unknown",
    "dateOfDeath": "1843-02-13",
    "yearOfDeath": 1843,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Hutchinson",
    "gNumber": "H-100676",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1843-06-23",
    "yearOfDeath": 1843,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s William and Mary Cooke"
  },
  {
    "nameId": "Rebecca Jackaway",
    "gNumber": "H-100681",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 87,
    "ancestry": "Unknown",
    "dateOfDeath": "1843-05-18",
    "yearOfDeath": 1843,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "widow"
  },
  {
    "nameId": "Mrs Elizabeth Warner (Warren)",
    "gNumber": "H-101479",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 64,
    "ancestry": "Unknown",
    "dateOfDeath": "1843-11-06",
    "yearOfDeath": 1843,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"Sunday at 12 O'clock Noon\""
  },
  {
    "nameId": "Sarah Elizabeth Cave",
    "gNumber": "H-100241",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "1-5",
    "ageAtDeath": 3,
    "ancestry": "Unknown",
    "dateOfDeath": "1843-02-18",
    "yearOfDeath": 1843,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Mr. Cave"
  },
  {
    "nameId": "Robert Rice Cave",
    "gNumber": "H-100242",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1843-02-26",
    "yearOfDeath": 1843,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Joseph and Sarah"
  },
  {
    "nameId": "Thomas Weight (Wight)",
    "gNumber": "H-101517",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 72,
    "ancestry": "Unknown",
    "dateOfDeath": "1843-11-10",
    "yearOfDeath": 1843,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Anna M. (Ann) Moulder",
    "gNumber": "H-100994",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 21,
    "ancestry": "Unknown",
    "dateOfDeath": "1843-12-09",
    "yearOfDeath": 1843,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. of W. W. L. Moulder"
  },
  {
    "nameId": "Jane L. Charles",
    "gNumber": "H-100257",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 32,
    "ancestry": "Unknown",
    "dateOfDeath": "1843-02-16",
    "yearOfDeath": 1843,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Harkinson Cook",
    "gNumber": "H-100310",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1843-06-24",
    "yearOfDeath": 1843,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Joseph M. Duncan",
    "gNumber": "H-100416",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 42,
    "ancestry": "Unknown",
    "dateOfDeath": "1843-10-30",
    "yearOfDeath": 1843,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Keen",
    "gNumber": "H-100761",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "4-8",
    "ageAtDeath": 6,
    "ancestry": "Unknown",
    "dateOfDeath": "1843-10-26",
    "yearOfDeath": 1843,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Charles"
  },
  {
    "nameId": "Adaline Thompson",
    "gNumber": "H-101405",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1843-11-03",
    "yearOfDeath": 1843,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Daniel"
  },
  {
    "nameId": "Samuel Arrison",
    "gNumber": "H-100025",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1844-07-08",
    "yearOfDeath": 1844,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Samuel"
  },
  {
    "nameId": "Emma Rebeca Batchnall (Buthnall)",
    "gNumber": "H-100076",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1844-09-19",
    "yearOfDeath": 1844,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Anne Lovering Neely",
    "gNumber": "H-101008",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "1-5",
    "ageAtDeath": 3,
    "ancestry": "Unknown",
    "dateOfDeath": "1844-02-04",
    "yearOfDeath": 1844,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Doctor Fisher J. Snow",
    "gNumber": "H-101317",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 41,
    "ancestry": "Unknown",
    "dateOfDeath": "1844-02-18",
    "yearOfDeath": 1844,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Catherine McKnight",
    "gNumber": "H-100914",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 59,
    "ancestry": "Unknown",
    "dateOfDeath": "1844-05-01",
    "yearOfDeath": 1844,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Betsey Sweeney",
    "gNumber": "H-101360",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 56,
    "ancestry": "Unknown",
    "dateOfDeath": "1844-05-13",
    "yearOfDeath": 1844,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Sarah Walker",
    "gNumber": "H-101463",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 52,
    "ancestry": "Unknown",
    "dateOfDeath": "1844-02-11",
    "yearOfDeath": 1844,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Sarah Moulder Richards",
    "gNumber": "H-101163",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 39,
    "ancestry": "Unknown",
    "dateOfDeath": "1844-02-08",
    "yearOfDeath": 1844,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"Duncan's Vault\""
  },
  {
    "nameId": "Eliza M. Sites",
    "gNumber": "H-101292",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 33,
    "ancestry": "Unknown",
    "dateOfDeath": "1844-07-07",
    "yearOfDeath": 1844,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"died Tuesday afternoon at 3 O'Clock\"; \"removed out of ground\""
  },
  {
    "nameId": "William Sites",
    "gNumber": "H-101293",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "1844-07-20",
    "yearOfDeath": 1844,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"removed out of ground\""
  },
  {
    "nameId": "Joseph Butler",
    "gNumber": "H-100214",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 54,
    "ancestry": "Unknown",
    "dateOfDeath": "1844-03-17",
    "yearOfDeath": 1844,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "h. Ann"
  },
  {
    "nameId": "Elizabeth Josiah",
    "gNumber": "H-100747",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 82,
    "ancestry": "Unknown",
    "dateOfDeath": "1844-12-27",
    "yearOfDeath": 1844,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "wid. Capt James"
  },
  {
    "nameId": "(daughter) Worden",
    "gNumber": "H-101586",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1845-01-18",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. A. Worden"
  },
  {
    "nameId": "Ann Miller",
    "gNumber": "H-100945",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 45,
    "ancestry": "Af. Decent",
    "dateOfDeath": "1845-02-19",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Cecilia Cooper",
    "gNumber": "H-100311",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 27,
    "ancestry": "Af. Decent",
    "dateOfDeath": "1845-02-25",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Sarah West",
    "gNumber": "H-101526",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 75,
    "ancestry": "Unknown",
    "dateOfDeath": "1845-05-04",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Matilda Wright",
    "gNumber": "H-101592",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 33,
    "ancestry": "Af. Decent",
    "dateOfDeath": "1845-05-04",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary McMullen",
    "gNumber": "H-100919",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 58,
    "ancestry": "Unknown",
    "dateOfDeath": "1845-05-27",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rev William T. Brantly D.D.",
    "gNumber": "H-100153",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 58,
    "ancestry": "Unknown",
    "dateOfDeath": "1845",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Jacob Rutherford",
    "gNumber": "H-101205",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 76,
    "ancestry": "Unknown",
    "dateOfDeath": "1845",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(infant) Warden",
    "gNumber": "H-101471",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1845",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "inf. Mary B."
  },
  {
    "nameId": "Elizabeth Ann Jones",
    "gNumber": "H-100739",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "5-9",
    "ageAtDeath": 7,
    "ancestry": "Unknown",
    "dateOfDeath": "1845-08-06",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Thomas T. McDurmond",
    "gNumber": "H-100899",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1845-06-13",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Thomas Sheilds",
    "gNumber": "H-101251",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 75,
    "ancestry": "Unknown",
    "dateOfDeath": "1845-12-21",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Thomas"
  },
  {
    "nameId": "(son) Bats (Bett)",
    "gNumber": "H-100080",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1845-01-16",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "inf s. Edmund and Eliza Ann"
  },
  {
    "nameId": "Edward Hansell",
    "gNumber": "H-100601",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "10-14",
    "ageAtDeath": 12,
    "ancestry": "Unknown",
    "dateOfDeath": "1845-06-09",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"remove out\""
  },
  {
    "nameId": "Mary O'Neill",
    "gNumber": "H-101020",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 80,
    "ancestry": "Unknown",
    "dateOfDeath": "1845-06-02",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Philip Jones",
    "gNumber": "H-100740",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 78,
    "ancestry": "Unknown",
    "dateOfDeath": "1845-12-18",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Robert Dobson",
    "gNumber": "H-100398",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 52,
    "ancestry": "Unknown",
    "dateOfDeath": "1845-03-30",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "mistakenly listed in Friends Fairhill in the Cem Returns Microfilm at HSP"
  },
  {
    "nameId": "Hellin Hankin",
    "gNumber": "H-100597",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 50,
    "ancestry": "Unknown",
    "dateOfDeath": "1845-04-03",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Sarah West",
    "gNumber": "H-101527",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 75,
    "ancestry": "Unknown",
    "dateOfDeath": "1845-05-06",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"to go to Woodland Cemetery\""
  },
  {
    "nameId": "Rebeca Ann Easby",
    "gNumber": "H-100431",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 36,
    "ancestry": "Unknown",
    "dateOfDeath": "1845-06-20",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "George Rumford",
    "gNumber": "H-101193",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1845-10-25",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Cyrus T. Smith",
    "gNumber": "H-101314",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 39,
    "ancestry": "Unknown",
    "dateOfDeath": "1845-03-28",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"In Rheese's Vault\""
  },
  {
    "nameId": "Rebeca Garretson (Garbersen)",
    "gNumber": "H-100518",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 62,
    "ancestry": "Unknown",
    "dateOfDeath": "1845-06-05",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Whedin",
    "gNumber": "H-101529",
    "sex": "Unknown",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "2-16",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1845-01-19",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Mr."
  },
  {
    "nameId": "Margaret Hearn",
    "gNumber": "H-100622",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 83,
    "ancestry": "Unknown",
    "dateOfDeath": "1845-11-01",
    "yearOfDeath": 1845,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John Perry",
    "gNumber": "H-101079",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 63,
    "ancestry": "Unknown",
    "dateOfDeath": "1846-04-21",
    "yearOfDeath": 1846,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ann L. Nealy",
    "gNumber": "H-101006",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "1-5",
    "ageAtDeath": 3,
    "ancestry": "Unknown",
    "dateOfDeath": "1846-02-06",
    "yearOfDeath": 1846,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Susan Maulte",
    "gNumber": "H-100879",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1846-05-29",
    "yearOfDeath": 1846,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Lucretia George",
    "gNumber": "H-100539",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1846",
    "yearOfDeath": 1846,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William Grimes",
    "gNumber": "H-100579",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1846-06-05",
    "yearOfDeath": 1846,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Sarah Simmons",
    "gNumber": "H-101279",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 25,
    "ancestry": "Unknown",
    "dateOfDeath": "1846-05-28",
    "yearOfDeath": 1846,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"to be paid by John C. Davis\""
  },
  {
    "nameId": "(son) Lamb",
    "gNumber": "H-100807",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1846-06-17",
    "yearOfDeath": 1846,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. H."
  },
  {
    "nameId": "Ann Jane Fopless (Toplass)",
    "gNumber": "H-100490",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 25,
    "ancestry": "Unknown",
    "dateOfDeath": "1846-05-30",
    "yearOfDeath": 1846,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "George McDermond",
    "gNumber": "H-100896",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1846-07-09",
    "yearOfDeath": 1846,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Charles Semple Sites",
    "gNumber": "H-101294",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "4-8",
    "ageAtDeath": 6,
    "ancestry": "Unknown",
    "dateOfDeath": "1846-06-14",
    "yearOfDeath": 1846,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"Removed out of Ground\""
  },
  {
    "nameId": "Thomas Brown",
    "gNumber": "H-100189",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 81,
    "ancestry": "Unknown",
    "dateOfDeath": "1846-10-12",
    "yearOfDeath": 1846,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Anthony H. Simmons",
    "gNumber": "H-101280",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 34,
    "ancestry": "Unknown",
    "dateOfDeath": "1846-06-03",
    "yearOfDeath": 1846,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Dea John Davis",
    "gNumber": "H-100368",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 79,
    "ancestry": "Unknown",
    "dateOfDeath": "1846-06-13",
    "yearOfDeath": 1846,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"a Deacon of this Church\""
  },
  {
    "nameId": "(infant) Coldwell",
    "gNumber": "H-100299",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1846-04-11",
    "yearOfDeath": 1846,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "inf ch. S.A.; \"not found\""
  },
  {
    "nameId": "George H. Simpson",
    "gNumber": "H-101285",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "2-6",
    "ageAtDeath": 4,
    "ancestry": "Unknown",
    "dateOfDeath": "1846-01-15",
    "yearOfDeath": 1846,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Margaret H. Hess",
    "gNumber": "H-100642",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 68,
    "ancestry": "Unknown",
    "dateOfDeath": "1846-02-02",
    "yearOfDeath": 1846,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Ann Warren",
    "gNumber": "H-101486",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 45,
    "ancestry": "Unknown",
    "dateOfDeath": "1846-11-09",
    "yearOfDeath": 1846,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary E. Rufflin",
    "gNumber": "H-101192",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "5-9",
    "ageAtDeath": 7,
    "ancestry": "Af. Decent",
    "dateOfDeath": "1847-05-17",
    "yearOfDeath": 1847,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"blk.\""
  },
  {
    "nameId": "Harriet Press",
    "gNumber": "H-101117",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Af. Decent",
    "dateOfDeath": "1847-08-22",
    "yearOfDeath": 1847,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Joseph Rhoads",
    "gNumber": "H-101159",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "6-10",
    "ageAtDeath": 8,
    "ancestry": "Unknown",
    "dateOfDeath": "1847-02-06",
    "yearOfDeath": 1847,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Thomas  (Dec'd)"
  },
  {
    "nameId": "Joseph Cave",
    "gNumber": "H-100243",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 49,
    "ancestry": "Unknown",
    "dateOfDeath": "1847-03-15",
    "yearOfDeath": 1847,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Margaret Scott",
    "gNumber": "H-101228",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 35,
    "ancestry": "Unknown",
    "dateOfDeath": "1847-09-06",
    "yearOfDeath": 1847,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Lavinia Phillips (Phipps)",
    "gNumber": "H-101090",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "14-18",
    "ageAtDeath": 16,
    "ancestry": "Unknown",
    "dateOfDeath": "1847-03-04",
    "yearOfDeath": 1847,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mary Sophia Hingham",
    "gNumber": "H-100647",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 17,
    "ancestry": "Unknown",
    "dateOfDeath": "1847-04-11",
    "yearOfDeath": 1847,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "Might say \"Daughter of Mrs. Woods\""
  },
  {
    "nameId": "Jane Clark",
    "gNumber": "H-100275",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 82,
    "ancestry": "Unknown",
    "dateOfDeath": "1847-02-04",
    "yearOfDeath": 1847,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"IN Mrs. A. Rhee's Vault\""
  },
  {
    "nameId": "John Warner",
    "gNumber": "H-101478",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 72,
    "ancestry": "Unknown",
    "dateOfDeath": "1847-04-02",
    "yearOfDeath": 1847,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(child) Vanaken",
    "gNumber": "H-101440",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1847-06-24",
    "yearOfDeath": 1847,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Wm"
  },
  {
    "nameId": "Mary Watkinson",
    "gNumber": "H-101497",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1847-10-13",
    "yearOfDeath": 1847,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "inf d. W. E."
  },
  {
    "nameId": "Dinah Anderson",
    "gNumber": "H-100015",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 77,
    "ancestry": "Unknown",
    "dateOfDeath": "1848-03-30",
    "yearOfDeath": 1848,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Josephine George",
    "gNumber": "H-100540",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Af. Decent",
    "dateOfDeath": "1848-10-04",
    "yearOfDeath": 1848,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "John McNully (Macnelly)",
    "gNumber": "H-100921",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 50,
    "ancestry": "Unknown",
    "dateOfDeath": "1848-02-26",
    "yearOfDeath": 1848,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"not a member\"; printer"
  },
  {
    "nameId": "Deborah Mather",
    "gNumber": "H-100874",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 70,
    "ancestry": "Unknown",
    "dateOfDeath": "1848-04-23",
    "yearOfDeath": 1848,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Catharine Plummer",
    "gNumber": "H-101094",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 47,
    "ancestry": "Unknown",
    "dateOfDeath": "1848-08-07",
    "yearOfDeath": 1848,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Frederick; d. Samuel and Catherine Burkloe"
  },
  {
    "nameId": "Dinnes Anderson Cole",
    "gNumber": "H-100303",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 77,
    "ancestry": "Unknown",
    "dateOfDeath": "1848-03-31",
    "yearOfDeath": 1848,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "George W. Smith",
    "gNumber": "H-101315",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 68,
    "ancestry": "Unknown",
    "dateOfDeath": "1848-07-11",
    "yearOfDeath": 1848,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Carilin E. (Caroline) Keen",
    "gNumber": "H-100762",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Adolescent",
    "ageRange": "11-15",
    "ageAtDeath": 13,
    "ancestry": "Unknown",
    "dateOfDeath": "1848-09-17",
    "yearOfDeath": 1848,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "(daughter) Park",
    "gNumber": "H-101039",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Af. Decent",
    "dateOfDeath": "1849-08-04",
    "yearOfDeath": 1849,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Edward"
  },
  {
    "nameId": "(child) Burt",
    "gNumber": "H-100206",
    "sex": "Unknown",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "1849-08-27",
    "yearOfDeath": 1849,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "ch. Joseph"
  },
  {
    "nameId": "Mrs Ann Smith",
    "gNumber": "H-101316",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 59,
    "ancestry": "Unknown",
    "dateOfDeath": "1849-11-10",
    "yearOfDeath": 1849,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Martha Barber",
    "gNumber": "H-100059",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 67,
    "ancestry": "Unknown",
    "dateOfDeath": "1849-11-05",
    "yearOfDeath": 1849,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"in full assurance of a blessed immortality\""
  },
  {
    "nameId": "Mr Andrew Topless (Fopless(",
    "gNumber": "H-101411",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 67,
    "ancestry": "Unknown",
    "dateOfDeath": "1849-12-10",
    "yearOfDeath": 1849,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Ann (Loxley) Rhees",
    "gNumber": "H-101156",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 74,
    "ancestry": "Unknown",
    "dateOfDeath": "1849-04-11",
    "yearOfDeath": 1849,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Rev. Morgan John; d. Col. Loxley"
  },
  {
    "nameId": "Mr John B. Hoff",
    "gNumber": "H-100650",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 78,
    "ancestry": "Af. Decent",
    "dateOfDeath": "1849-04-03",
    "yearOfDeath": 1849,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Joseph Hermstead",
    "gNumber": "H-100634",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 62,
    "ancestry": "Unknown",
    "dateOfDeath": "1849-06-26",
    "yearOfDeath": 1849,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Susan Avery",
    "gNumber": "H-100036",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 54,
    "ancestry": "Unknown",
    "dateOfDeath": "1849-08-13",
    "yearOfDeath": 1849,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"removed out\""
  },
  {
    "nameId": "Daniel C. Pierson",
    "gNumber": "H-101092",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 34,
    "ancestry": "Unknown",
    "dateOfDeath": "1849-01-21",
    "yearOfDeath": 1849,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Mary Warren",
    "gNumber": "H-101487",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 50,
    "ancestry": "Unknown",
    "dateOfDeath": "1849-07-12",
    "yearOfDeath": 1849,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Masher Moulder",
    "gNumber": "H-100995",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 94,
    "ancestry": "Unknown",
    "dateOfDeath": "1849-08-14",
    "yearOfDeath": 1849,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Ann Reynold",
    "gNumber": "H-101146",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1849-08-23",
    "yearOfDeath": 1849,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mr Nickloes Harices",
    "gNumber": "H-100602",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 90,
    "ancestry": "Unknown",
    "dateOfDeath": "1850-01-28",
    "yearOfDeath": 1850,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"Removed out\""
  },
  {
    "nameId": "Miss Mary Ann Lamb",
    "gNumber": "H-100808",
    "sex": "Female",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "5-9",
    "ageAtDeath": 7,
    "ancestry": "Unknown",
    "dateOfDeath": "1850-02-11",
    "yearOfDeath": 1850,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mr Edwin B. Phippes",
    "gNumber": "H-101091",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 25,
    "ancestry": "Unknown",
    "dateOfDeath": "1850-03-17",
    "yearOfDeath": 1850,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Elizabeth McLain",
    "gNumber": "H-100915",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1850-04-09",
    "yearOfDeath": 1850,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Miss Mary Ann Avery",
    "gNumber": "H-100037",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 27,
    "ancestry": "Unknown",
    "dateOfDeath": "1850-02-12",
    "yearOfDeath": 1850,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"removed out\""
  },
  {
    "nameId": "Mrs Mary Steelman",
    "gNumber": "H-101328",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1851-01-09",
    "yearOfDeath": 1851,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Sarah Gugger (Guifer)",
    "gNumber": "H-100580",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 72,
    "ancestry": "Unknown",
    "dateOfDeath": "1851-06-09",
    "yearOfDeath": 1851,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Rebecca Nixon",
    "gNumber": "H-101011",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 93,
    "ancestry": "Unknown",
    "dateOfDeath": "1852",
    "yearOfDeath": 1852,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mr Charles Geary",
    "gNumber": "H-100522",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 62,
    "ancestry": "Unknown",
    "dateOfDeath": "1852-03-28",
    "yearOfDeath": 1852,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs (wife) Rutherford",
    "gNumber": "H-101206",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1852-09-30",
    "yearOfDeath": 1852,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. Jacob"
  },
  {
    "nameId": "Mr John Hannce",
    "gNumber": "H-100598",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 60,
    "ancestry": "Unknown",
    "dateOfDeath": "1853-04-12",
    "yearOfDeath": 1853,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Ann Jeanette Burr",
    "gNumber": "H-100203",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 50,
    "ancestry": "Unknown",
    "dateOfDeath": "1853-02-17",
    "yearOfDeath": 1853,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Sarah Baker",
    "gNumber": "H-100052",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 87,
    "ancestry": "Unknown",
    "dateOfDeath": "1853-10-27",
    "yearOfDeath": 1853,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Margaret Shepard",
    "gNumber": "H-101256",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1853-11-17",
    "yearOfDeath": 1853,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "George H. Simpson",
    "gNumber": "H-101286",
    "sex": "Male",
    "age": "Subadult",
    "ageCat": "Child",
    "ageRange": "2-6",
    "ageAtDeath": 4,
    "ancestry": "Unknown",
    "dateOfDeath": "1854",
    "yearOfDeath": 1854,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mitchell Bennis",
    "gNumber": "H-100110",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 58,
    "ancestry": "Unknown",
    "dateOfDeath": "1854-09-25",
    "yearOfDeath": 1854,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"having sustaned the office of class leader in the M.E. Union Church philadelphia for upwards of 36 years peacefully fell asleep in Jesus on\u2026\""
  },
  {
    "nameId": "Mrs Martha Young",
    "gNumber": "H-101601",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 76,
    "ancestry": "Unknown",
    "dateOfDeath": "1854-05-17",
    "yearOfDeath": 1854,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "w. C."
  },
  {
    "nameId": "Lidia Young",
    "gNumber": "H-101602",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 79,
    "ancestry": "Unknown",
    "dateOfDeath": "1854-07-08",
    "yearOfDeath": 1854,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Emily Ramage (Ranage)",
    "gNumber": "H-101122",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 74,
    "ancestry": "Unknown",
    "dateOfDeath": "1854-07-06",
    "yearOfDeath": 1854,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Mary McIlhaney",
    "gNumber": "H-100905",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 76,
    "ancestry": "Unknown",
    "dateOfDeath": "1854-11-06",
    "yearOfDeath": 1854,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "George Hannold",
    "gNumber": "H-100599",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 80,
    "ancestry": "Unknown",
    "dateOfDeath": "1855-04-01",
    "yearOfDeath": 1855,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mr Henry Benner",
    "gNumber": "H-100103",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 82,
    "ancestry": "Unknown",
    "dateOfDeath": "1857-10-09",
    "yearOfDeath": 1857,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Sarah Ann Rambo (Rainbow)",
    "gNumber": "H-101129",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Middle Adult",
    "ageRange": "35-50",
    "ageAtDeath": 47,
    "ancestry": "Unknown",
    "dateOfDeath": "1857-11-04",
    "yearOfDeath": 1857,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Ulen Jones",
    "gNumber": "H-100741",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Af. Decent",
    "dateOfDeath": "1857",
    "yearOfDeath": 1857,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"coulered\""
  },
  {
    "nameId": "Catharine White",
    "gNumber": "H-101537",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 88,
    "ancestry": "Unknown",
    "dateOfDeath": "1858-03-18",
    "yearOfDeath": 1858,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Dinah Brown",
    "gNumber": "H-100190",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 56,
    "ancestry": "Af. Decent",
    "dateOfDeath": "1858-09-04",
    "yearOfDeath": 1858,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mr George Powel",
    "gNumber": "H-101108",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Adult",
    "ageRange": "17+",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "1859",
    "yearOfDeath": 1859,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Mrs Mary Thomson",
    "gNumber": "H-101406",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Old Adult",
    "ageRange": "50+",
    "ageAtDeath": 85,
    "ancestry": "Unknown",
    "dateOfDeath": "1859-08-24",
    "yearOfDeath": 1859,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Emily W. Griffith",
    "gNumber": "H-100571",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "(before 1860)",
    "yearOfDeath": null,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Henry W. Griffith",
    "gNumber": "H-100572",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "(before 1860)",
    "yearOfDeath": null,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Eliza Genther",
    "gNumber": "H-100526",
    "sex": "Female",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 0,
    "ancestry": "Unknown",
    "dateOfDeath": "(before 1860)",
    "yearOfDeath": null,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. John"
  },
  {
    "nameId": "Willie (unknown)",
    "gNumber": "H-100001",
    "sex": "Male",
    "age": "Infant",
    "ageCat": "Infant",
    "ageRange": "0-2",
    "ageAtDeath": 1,
    "ancestry": "Unknown",
    "dateOfDeath": "(before 1860)",
    "yearOfDeath": null,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "\"our little Willie\""
  },
  {
    "nameId": "Jane Griffith",
    "gNumber": "H-100573",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "(before 1860)",
    "yearOfDeath": null,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "William H. Griffith",
    "gNumber": "H-100574",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "(before 1860)",
    "yearOfDeath": null,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Benjamin Loxley",
    "gNumber": "H-100844",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "(before 1860)",
    "yearOfDeath": null,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "AND FAMILY MOVED"
  },
  {
    "nameId": "Sarah J. Pelen",
    "gNumber": "H-101058",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 19,
    "ancestry": "Unknown",
    "dateOfDeath": "(before 1860)",
    "yearOfDeath": null,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Abraham and Elizabeth"
  },
  {
    "nameId": "Augustus Pelen",
    "gNumber": "H-101059",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 20,
    "ancestry": "Unknown",
    "dateOfDeath": "(before 1860)",
    "yearOfDeath": null,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Abraham and Elizabeth"
  },
  {
    "nameId": "Clara Pelen",
    "gNumber": "H-101060",
    "sex": "Female",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 20,
    "ancestry": "Unknown",
    "dateOfDeath": "(before 1860)",
    "yearOfDeath": null,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "d. Abraham and Elizabeth"
  },
  {
    "nameId": "Eddie Pelen",
    "gNumber": "H-101061",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 26,
    "ancestry": "Unknown",
    "dateOfDeath": "(before 1860)",
    "yearOfDeath": null,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Abraham and Elizabeth"
  },
  {
    "nameId": "Charles Pelen",
    "gNumber": "H-101062",
    "sex": "Male",
    "age": "Adult",
    "ageCat": "Young Adult",
    "ageRange": "20-35",
    "ageAtDeath": 27,
    "ancestry": "Unknown",
    "dateOfDeath": "(before 1860)",
    "yearOfDeath": null,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": "s. Abraham and Elizabeth"
  },
  {
    "nameId": "Edward James Jones",
    "gNumber": "H-100710",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "(before 1860)",
    "yearOfDeath": null,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Eleanora Jones",
    "gNumber": "H-100711",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "(before 1860)",
    "yearOfDeath": null,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Emma Matilda Jones",
    "gNumber": "H-100712",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "(before 1860)",
    "yearOfDeath": null,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Esther Maria Jones",
    "gNumber": "H-100713",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "(before 1860)",
    "yearOfDeath": null,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Grace Eliza Jones",
    "gNumber": "H-100714",
    "sex": "Female",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "(before 1860)",
    "yearOfDeath": null,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  },
  {
    "nameId": "Philip Jones",
    "gNumber": "H-100715",
    "sex": "Male",
    "age": "Unknown",
    "ageCat": "Unknown",
    "ageRange": "",
    "ageAtDeath": null,
    "ancestry": "Unknown",
    "dateOfDeath": "(before 1860)",
    "yearOfDeath": null,
    "coffinShape": "Unknown",
    "preservation": "Unknown",
    "lidType": "Unknown",
    "coffinHandles": "Unknown",
    "notes": ""
  }
];

export const NAMED_COUNT = namedPersonsData.length;
